
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iwsIy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7c17de4ac57e2ee$var$_react = $d7c17de4ac57e2ee$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $d7c17de4ac57e2ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d7c17de4ac57e2ee$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $d7c17de4ac57e2ee$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$d7c17de4ac57e2ee$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $d7c17de4ac57e2ee$var$_default = module.exports.default = $d7c17de4ac57e2ee$var$PeopleGroupIcon;

});

parcelRegister("77CtJ", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $38f6d3b0d81fde12$export$c4b5b1f965d8b3eb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $38f6d3b0d81fde12$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $38f6d3b0d81fde12$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $38f6d3b0d81fde12$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("4q38b", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bf06ba22418d3f0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");

var $3vMGX = parcelRequire("3vMGX");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $0bf06ba22418d3f0$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $eUqFw.useState)((0, $juktg.default)());
    (0, $eUqFw.useEffect)(()=>{
        const observer = new (0, $3vMGX.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $0bf06ba22418d3f0$export$2e2bcd8739ae039 = $0bf06ba22418d3f0$var$useThemeObserver;

});
parcelRegister("juktg", function(module, exports) {

$parcel$export(module.exports, "default", () => $73112f76ef618559$export$2e2bcd8739ae039);

var $kyri3 = parcelRequire("kyri3");

var $31snR = parcelRequire("31snR");

var $iednx = parcelRequire("iednx");
const $73112f76ef618559$var$isThemeColorMode = (colorMode)=>{
    return (0, $31snR.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $73112f76ef618559$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $kyri3.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $kyri3.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $iednx.themeStringToObject)(theme),
        ...$73112f76ef618559$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $73112f76ef618559$export$2e2bcd8739ae039 = $73112f76ef618559$var$getGlobalTheme;

});
parcelRegister("31snR", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $80ca8d8c810bbe93$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $80ca8d8c810bbe93$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $80ca8d8c810bbe93$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $80ca8d8c810bbe93$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $80ca8d8c810bbe93$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ const $80ca8d8c810bbe93$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $80ca8d8c810bbe93$export$8ce7e340c74e86c5 = [
    'more',
    'no-preference',
    'auto'
];
const $80ca8d8c810bbe93$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized'
];
const $80ca8d8c810bbe93$export$ba8a43b83ecc69f8 = [];
const $80ca8d8c810bbe93$export$92ba366331403db2 = [
    ...$80ca8d8c810bbe93$export$7d43e72a58e3283f,
    ...$80ca8d8c810bbe93$export$ba8a43b83ecc69f8
];
const $80ca8d8c810bbe93$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $80ca8d8c810bbe93$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var $80ca8d8c810bbe93$export$2e2bcd8739ae039 = $80ca8d8c810bbe93$var$themeConfig;

});

parcelRegister("iednx", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $66a09631b05a8331$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $66a09631b05a8331$export$62c37ab81302621a);

var $31snR = parcelRequire("31snR");
const $66a09631b05a8331$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $66a09631b05a8331$var$customThemeOptions = 'UNSAFE_themeOptions';
const $66a09631b05a8331$var$isThemeKind = (themeKind)=>{
    return $66a09631b05a8331$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $66a09631b05a8331$var$isThemeIds = (themeId)=>{
    return (0, $31snR.themeIds).find((id)=>id === themeId) !== undefined;
};
const $66a09631b05a8331$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $66a09631b05a8331$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $66a09631b05a8331$var$isColorMode(id)) themeObject[kind] = id;
        if ($66a09631b05a8331$var$isThemeKind(kind) && $66a09631b05a8331$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $66a09631b05a8331$var$customThemeOptions) try {
            themeObject[$66a09631b05a8331$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $66a09631b05a8331$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $66a09631b05a8331$var$isColorMode(id) || // custom theme state
        kind === $66a09631b05a8331$var$customThemeOptions && typeof id === 'object' || // other theme states
        $66a09631b05a8331$var$isThemeKind(kind) && typeof id === 'string' && $66a09631b05a8331$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("3vMGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $55357d15c6f4bfa6$export$2e2bcd8739ae039);

var $kyri3 = parcelRequire("kyri3");

var $juktg = parcelRequire("juktg");
class $55357d15c6f4bfa6$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$55357d15c6f4bfa6$export$2e2bcd8739ae039.observer) {
            $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $juktg.default)();
                $55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $kyri3.THEME_DATA_ATTRIBUTE),
                    (0, $kyri3.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($55357d15c6f4bfa6$export$2e2bcd8739ae039.callbacks.size === 0 && $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer) {
            $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer.disconnect();
            $55357d15c6f4bfa6$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});


parcelRegister("lpzFL", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", () => $7b2cbc1b56c22840$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $7b2cbc1b56c22840$export$793fba32aed8942a);
$parcel$export(module.exports, "sizes", () => $7b2cbc1b56c22840$export$c647cb0ee6e282fe);
const $7b2cbc1b56c22840$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $7b2cbc1b56c22840$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
const $7b2cbc1b56c22840$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $7b2cbc1b56c22840$export$31d7044b7540a6d8 = $7b2cbc1b56c22840$export$438460117ae6b7ee;

});

parcelRegister("9m0Eq", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $2cabbe911fcb4bd2$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $2cabbe911fcb4bd2$export$bbacc3980e0f3029);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");
const $2cabbe911fcb4bd2$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $PdmhA.B400);
            iconGradientStop = (0, $PdmhA.B200);
            iconColor = (0, $PdmhA.B200);
            textColor = `var(--ds-text, ${0, $PdmhA.N800})`;
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $PdmhA.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $PdmhA.N600);
            iconGradientStop = (0, $PdmhA.N100);
            iconColor = (0, $PdmhA.N100);
            textColor = (0, $PdmhA.N400);
            atlassianLogoTextColor = (0, $PdmhA.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $2cabbe911fcb4bd2$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $PdmhA.N0);
            textColor = (0, $PdmhA.N0);
            atlassianLogoTextColor = (0, $PdmhA.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $2cabbe911fcb4bd2$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $2cabbe911fcb4bd2$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $2cabbe911fcb4bd2$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});

parcelRegister("urYMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $46761837faa35cc1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lpzFL = parcelRequire("lpzFL");
function $46761837faa35cc1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $46761837faa35cc1$var$CSS_VAR_COLOR = '--logo-color';
const $46761837faa35cc1$var$CSS_VAR_FILL = '--logo-fill';
const $46761837faa35cc1$var$baseWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    color: `var(${$46761837faa35cc1$var$CSS_VAR_COLOR})`,
    fill: `var(${$46761837faa35cc1$var$CSS_VAR_FILL})`,
    lineHeight: 1,
    userSelect: 'none',
    whiteSpace: 'normal',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': {
        height: '100%',
        fill: 'inherit'
    }
});
const $46761837faa35cc1$var$stopColorStyles = {
    name: "1hl44m8",
    styles: "stop{stop-color:currentColor;}"
};
const $46761837faa35cc1$var$sizeStyles = Object.entries((0, $lpzFL.sizes)).reduce((acc, [key, val])=>{
    acc[key] = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${val}px`
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $46761837faa35cc1$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $46761837faa35cc1$var$baseWrapperStyles,
            shouldApplyStopColor && $46761837faa35cc1$var$stopColorStyles,
            size && $46761837faa35cc1$var$sizeStyles[size]
        ],
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$46761837faa35cc1$var$CSS_VAR_COLOR]: iconColor,
            [$46761837faa35cc1$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest
    });
};
var $46761837faa35cc1$export$2e2bcd8739ae039 = $46761837faa35cc1$var$Wrapper;

});


parcelRegister("96IgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a1703e228f19740$var$_react = $6a1703e228f19740$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6a1703e228f19740$var$_error = $6a1703e228f19740$var$_interopRequireDefault((parcelRequire("3LDmK")));
function $6a1703e228f19740$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6a1703e228f19740$var$ErrorIcon = (props)=>/*#__PURE__*/ $6a1703e228f19740$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentColor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $6a1703e228f19740$var$_error.default
    }));
$6a1703e228f19740$var$ErrorIcon.displayName = 'ErrorIcon';
var $6a1703e228f19740$var$_default = module.exports.default = $6a1703e228f19740$var$ErrorIcon;

});
parcelRegister("3LDmK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2be44c1d2e478490$var$_react = $2be44c1d2e478490$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2be44c1d2e478490$var$_UNSAFE_baseNew = $2be44c1d2e478490$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $2be44c1d2e478490$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Error".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2be44c1d2e478490$var$ErrorIcon = (props)=>/*#__PURE__*/ $2be44c1d2e478490$var$_react.default.createElement($2be44c1d2e478490$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$2be44c1d2e478490$var$ErrorIcon.displayName = 'ErrorIcon';
var $2be44c1d2e478490$var$_default = module.exports.default = $2be44c1d2e478490$var$ErrorIcon;

});


parcelRegister("oeORR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $048dbcd6d1394bcb$var$_react = $048dbcd6d1394bcb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $048dbcd6d1394bcb$var$_dashboard = $048dbcd6d1394bcb$var$_interopRequireDefault((parcelRequire("5sPjT")));
function $048dbcd6d1394bcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $048dbcd6d1394bcb$var$ActivityIcon = (props)=>/*#__PURE__*/ $048dbcd6d1394bcb$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
    }, props, {
        newIcon: $048dbcd6d1394bcb$var$_dashboard.default
    }));
$048dbcd6d1394bcb$var$ActivityIcon.displayName = 'ActivityIcon';
var $048dbcd6d1394bcb$var$_default = module.exports.default = $048dbcd6d1394bcb$var$ActivityIcon;

});
parcelRegister("5sPjT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fa76052ee199c2a$var$_react = $3fa76052ee199c2a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3fa76052ee199c2a$var$_UNSAFE_baseNew = $3fa76052ee199c2a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3fa76052ee199c2a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Dashboard".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3fa76052ee199c2a$var$DashboardIcon = (props)=>/*#__PURE__*/ $3fa76052ee199c2a$var$_react.default.createElement($3fa76052ee199c2a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h5m0-12.5h5c.69 0 1.25.56 1.25 1.25v5M8 1.75V8m0 6.25h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25V8m0 0h6.25"/>`
    }, props));
$3fa76052ee199c2a$var$DashboardIcon.displayName = 'DashboardIcon';
var $3fa76052ee199c2a$var$_default = module.exports.default = $3fa76052ee199c2a$var$DashboardIcon;

});


parcelRegister("iFXD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d98a4f81d02f8071$var$_react = $d98a4f81d02f8071$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d98a4f81d02f8071$var$_app = $d98a4f81d02f8071$var$_interopRequireDefault((parcelRequire("l1LQr")));
function $d98a4f81d02f8071$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d98a4f81d02f8071$var$AddonIcon = (props)=>/*#__PURE__*/ $d98a4f81d02f8071$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
    }, props, {
        newIcon: $d98a4f81d02f8071$var$_app.default
    }));
$d98a4f81d02f8071$var$AddonIcon.displayName = 'AddonIcon';
var $d98a4f81d02f8071$var$_default = module.exports.default = $d98a4f81d02f8071$var$AddonIcon;

});
parcelRegister("l1LQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4eecdf43ef607c7$var$_react = $f4eecdf43ef607c7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f4eecdf43ef607c7$var$_UNSAFE_baseNew = $f4eecdf43ef607c7$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f4eecdf43ef607c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "App".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4eecdf43ef607c7$var$AppIcon = (props)=>/*#__PURE__*/ $f4eecdf43ef607c7$var$_react.default.createElement($f4eecdf43ef607c7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m2.357 4.136 5-3a1.25 1.25 0 0 1 1.286 0l5 3c.377.226.607.633.607 1.072v5.584c0 .44-.23.846-.607 1.072l-5 3a1.25 1.25 0 0 1-1.286 0l-5-3a1.25 1.25 0 0 1-.607-1.072V5.208c0-.44.23-.846.607-1.072Z"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$f4eecdf43ef607c7$var$AppIcon.displayName = 'AppIcon';
var $f4eecdf43ef607c7$var$_default = module.exports.default = $f4eecdf43ef607c7$var$AppIcon;

});


parcelRegister("eLhcP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abf2cd30d4bf2060$var$_react = $abf2cd30d4bf2060$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $abf2cd30d4bf2060$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $abf2cd30d4bf2060$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $abf2cd30d4bf2060$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
    }, props));
$abf2cd30d4bf2060$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $abf2cd30d4bf2060$var$_default = module.exports.default = $abf2cd30d4bf2060$var$AppSwitcherIcon;

});

parcelRegister("1j9EV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f3f0ee35b88c73e$var$_react = $0f3f0ee35b88c73e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $0f3f0ee35b88c73e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0f3f0ee35b88c73e$var$BillingIcon = (props)=>/*#__PURE__*/ $0f3f0ee35b88c73e$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
    }, props));
$0f3f0ee35b88c73e$var$BillingIcon.displayName = 'BillingIcon';
var $0f3f0ee35b88c73e$var$_default = module.exports.default = $0f3f0ee35b88c73e$var$BillingIcon;

});

parcelRegister("86Ndv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e750fba7c07630a$var$_react = $5e750fba7c07630a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $5e750fba7c07630a$var$_chevronDown = $5e750fba7c07630a$var$_interopRequireDefault((parcelRequire("c6CvK")));
function $5e750fba7c07630a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5e750fba7c07630a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5e750fba7c07630a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $5e750fba7c07630a$var$_chevronDown.default,
        iconType: "utility"
    }));
$5e750fba7c07630a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $5e750fba7c07630a$var$_default = module.exports.default = $5e750fba7c07630a$var$ChevronDownIcon;

});

parcelRegister("dtaN9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ce65ad39d5363d8$var$_react = $9ce65ad39d5363d8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9ce65ad39d5363d8$var$_chevronRight = $9ce65ad39d5363d8$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9ce65ad39d5363d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9ce65ad39d5363d8$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $9ce65ad39d5363d8$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $9ce65ad39d5363d8$var$_chevronRight.default,
        iconType: "utility"
    }));
$9ce65ad39d5363d8$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $9ce65ad39d5363d8$var$_default = module.exports.default = $9ce65ad39d5363d8$var$ChevronRightIcon;

});
parcelRegister("fCmfi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5eba92d20a08f99$var$_react = $b5eba92d20a08f99$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b5eba92d20a08f99$var$_UNSAFE_baseNew = $b5eba92d20a08f99$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b5eba92d20a08f99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Reserved for menu fly-outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5eba92d20a08f99$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $b5eba92d20a08f99$var$_react.default.createElement($b5eba92d20a08f99$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m4 10.75 4.5-4.5L4 1.75"/>`,
        type: 'utility'
    }, props));
$b5eba92d20a08f99$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $b5eba92d20a08f99$var$_default = module.exports.default = $b5eba92d20a08f99$var$ChevronRightIcon;

});


parcelRegister("2KhVf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ffdc7a77e26f852$var$_react = $1ffdc7a77e26f852$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1ffdc7a77e26f852$var$_creditCard = $1ffdc7a77e26f852$var$_interopRequireDefault((parcelRequire("3zPrX")));
function $1ffdc7a77e26f852$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1ffdc7a77e26f852$var$CreditcardFilledIcon = (props)=>/*#__PURE__*/ $1ffdc7a77e26f852$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M3 10.99h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM6.01 16h2v-2h-2zM21 8.99V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.99"/></svg>`
    }, props, {
        newIcon: $1ffdc7a77e26f852$var$_creditCard.default
    }));
$1ffdc7a77e26f852$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
var $1ffdc7a77e26f852$var$_default = module.exports.default = $1ffdc7a77e26f852$var$CreditcardFilledIcon;

});
parcelRegister("3zPrX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29ac8ce28abc20ad$var$_react = $29ac8ce28abc20ad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $29ac8ce28abc20ad$var$_UNSAFE_baseNew = $29ac8ce28abc20ad$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $29ac8ce28abc20ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "CreditCard".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29ac8ce28abc20ad$var$CreditCardIcon = (props)=>/*#__PURE__*/ $29ac8ce28abc20ad$var$_react.default.createElement($29ac8ce28abc20ad$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M.75 6.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.25m-14.5 0V4c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v2.25m-14.5 0h14.5m-2.25 4H9"/>`
    }, props));
$29ac8ce28abc20ad$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $29ac8ce28abc20ad$var$_default = module.exports.default = $29ac8ce28abc20ad$var$CreditCardIcon;

});


parcelRegister("hXGRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d139322d15a7a750$var$_react = $d139322d15a7a750$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d139322d15a7a750$var$_dashboard = $d139322d15a7a750$var$_interopRequireDefault((parcelRequire("5sPjT")));
function $d139322d15a7a750$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d139322d15a7a750$var$DashboardIcon = (props)=>/*#__PURE__*/ $d139322d15a7a750$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props, {
        newIcon: $d139322d15a7a750$var$_dashboard.default
    }));
$d139322d15a7a750$var$DashboardIcon.displayName = 'DashboardIcon';
var $d139322d15a7a750$var$_default = module.exports.default = $d139322d15a7a750$var$DashboardIcon;

});

parcelRegister("bkIGg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8404389a307bab2b$var$_react = $8404389a307bab2b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8404389a307bab2b$var$_edit = $8404389a307bab2b$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $8404389a307bab2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8404389a307bab2b$var$EditorAddIcon = (props)=>/*#__PURE__*/ $8404389a307bab2b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $8404389a307bab2b$var$_edit.default
    }));
$8404389a307bab2b$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $8404389a307bab2b$var$_default = module.exports.default = $8404389a307bab2b$var$EditorAddIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Edit".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M7 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9m-.75-4 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 8.979 9.521c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});


parcelRegister("24y6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $182669c75dfa02c6$var$_react = $182669c75dfa02c6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $182669c75dfa02c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $182669c75dfa02c6$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $182669c75dfa02c6$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$182669c75dfa02c6$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $182669c75dfa02c6$var$_default = module.exports.default = $182669c75dfa02c6$var$EmojiAtlassianIcon;

});

parcelRegister("4ki2H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3267068b245906ad$var$_react = $3267068b245906ad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3267068b245906ad$var$_filter = $3267068b245906ad$var$_interopRequireDefault((parcelRequire("aKPxm")));
function $3267068b245906ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3267068b245906ad$var$FilterIcon = (props)=>/*#__PURE__*/ $3267068b245906ad$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $3267068b245906ad$var$_filter.default
    }));
$3267068b245906ad$var$FilterIcon.displayName = 'FilterIcon';
var $3267068b245906ad$var$_default = module.exports.default = $3267068b245906ad$var$FilterIcon;

});
parcelRegister("aKPxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d462d743b8b04cc$var$_react = $7d462d743b8b04cc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7d462d743b8b04cc$var$_UNSAFE_baseNew = $7d462d743b8b04cc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7d462d743b8b04cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Filter".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d462d743b8b04cc$var$FilterIcon = (props)=>/*#__PURE__*/ $7d462d743b8b04cc$var$_react.default.createElement($7d462d743b8b04cc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
    }, props));
$7d462d743b8b04cc$var$FilterIcon.displayName = 'FilterIcon';
var $7d462d743b8b04cc$var$_default = module.exports.default = $7d462d743b8b04cc$var$FilterIcon;

});


parcelRegister("e5T2d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a42c3910affccfb4$var$_react = $a42c3910affccfb4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a42c3910affccfb4$var$_folderClosed = $a42c3910affccfb4$var$_interopRequireDefault((parcelRequire("02DNG")));
function $a42c3910affccfb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a42c3910affccfb4$var$FolderIcon = (props)=>/*#__PURE__*/ $a42c3910affccfb4$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $a42c3910affccfb4$var$_folderClosed.default
    }));
$a42c3910affccfb4$var$FolderIcon.displayName = 'FolderIcon';
var $a42c3910affccfb4$var$_default = module.exports.default = $a42c3910affccfb4$var$FolderIcon;

});
parcelRegister("02DNG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $007f0f914430e9e0$var$_react = $007f0f914430e9e0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $007f0f914430e9e0$var$_UNSAFE_baseNew = $007f0f914430e9e0$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $007f0f914430e9e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "FolderClosed".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $007f0f914430e9e0$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $007f0f914430e9e0$var$_react.default.createElement($007f0f914430e9e0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h3.25L8 3.5h5c.69 0 1.25.56 1.25 1.25v2m-12.5 0h12.5"/>`
    }, props));
$007f0f914430e9e0$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $007f0f914430e9e0$var$_default = module.exports.default = $007f0f914430e9e0$var$FolderClosedIcon;

});


parcelRegister("6nIG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a578bfd70cc9f83$var$_react = $4a578bfd70cc9f83$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4a578bfd70cc9f83$var$_issues = $4a578bfd70cc9f83$var$_interopRequireDefault((parcelRequire("3vmed")));
function $4a578bfd70cc9f83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a578bfd70cc9f83$var$IssuesIcon = (props)=>/*#__PURE__*/ $4a578bfd70cc9f83$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $4a578bfd70cc9f83$var$_issues.default
    }));
$4a578bfd70cc9f83$var$IssuesIcon.displayName = 'IssuesIcon';
var $4a578bfd70cc9f83$var$_default = module.exports.default = $4a578bfd70cc9f83$var$IssuesIcon;

});
parcelRegister("3vmed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28d58268642df4a6$var$_react = $28d58268642df4a6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $28d58268642df4a6$var$_UNSAFE_baseNew = $28d58268642df4a6$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $28d58268642df4a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Issues".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for multiple issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28d58268642df4a6$var$IssuesIcon = (props)=>/*#__PURE__*/ $28d58268642df4a6$var$_react.default.createElement($28d58268642df4a6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m3.875 7 1.75 1.75L9.125 5M.75 10V4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25Z"/><path stroke="currentColor" stroke-width="1.5" d="M5 14.25h7.75a2.5 2.5 0 0 0 2.5-2.5V7"/>`
    }, props));
$28d58268642df4a6$var$IssuesIcon.displayName = 'IssuesIcon';
var $28d58268642df4a6$var$_default = module.exports.default = $28d58268642df4a6$var$IssuesIcon;

});


parcelRegister("jG1wZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e533209b7442b630$var$_react = $e533209b7442b630$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e533209b7442b630$var$_showMoreHorizontal = $e533209b7442b630$var$_interopRequireDefault((parcelRequire("7JXZ0")));
function $e533209b7442b630$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e533209b7442b630$var$MoreIcon = (props)=>/*#__PURE__*/ $e533209b7442b630$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $e533209b7442b630$var$_showMoreHorizontal.default
    }));
$e533209b7442b630$var$MoreIcon.displayName = 'MoreIcon';
var $e533209b7442b630$var$_default = module.exports.default = $e533209b7442b630$var$MoreIcon;

});
parcelRegister("7JXZ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a2b43bc11fda386$var$_react = $5a2b43bc11fda386$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5a2b43bc11fda386$var$_UNSAFE_baseNew = $5a2b43bc11fda386$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5a2b43bc11fda386$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a2b43bc11fda386$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $5a2b43bc11fda386$var$_react.default.createElement($5a2b43bc11fda386$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentColor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$5a2b43bc11fda386$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $5a2b43bc11fda386$var$_default = module.exports.default = $5a2b43bc11fda386$var$ShowMoreHorizontalIcon;

});


parcelRegister("aLjrh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d5d5f54949dbd99$var$_react = $7d5d5f54949dbd99$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $7d5d5f54949dbd99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7d5d5f54949dbd99$var$NotificationIcon = (props)=>/*#__PURE__*/ $7d5d5f54949dbd99$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M6.49 17.67a2 2 0 0 0 2.83 0l-2.83-2.83a2 2 0 0 0 0 2.83m4.89-12.19-.72.73c-.78.78-2.21 1.81-3.21 2.31l-3.02 1.51c-.49.25-.58.77-.19 1.17l8.56 8.56c.4.4.92.31 1.17-.19l1.51-3.02c.49-.99 1.53-2.42 2.31-3.21l.73-.73a5.05 5.05 0 0 0 .64-6.36 1.01 1.01 0 1 0-1.35-1.49q-.04.04-.07.08A5.04 5.04 0 0 0 14.95 4a5.04 5.04 0 0 0-3.57 1.48"/></svg>`
    }, props));
$7d5d5f54949dbd99$var$NotificationIcon.displayName = 'NotificationIcon';
var $7d5d5f54949dbd99$var$_default = module.exports.default = $7d5d5f54949dbd99$var$NotificationIcon;

});

parcelRegister("a10lp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74aa43bc29155859$var$_react = $74aa43bc29155859$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $74aa43bc29155859$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $74aa43bc29155859$var$NotificationDirectIcon = (props)=>/*#__PURE__*/ $74aa43bc29155859$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M6.59 17.83a2 2 0 0 0 2.83 0L6.59 15a2 2 0 0 0 0 2.83m4.79-12.35A5.04 5.04 0 0 1 14.95 4c.97 0 1.95.28 2.79.84q.03-.04.07-.07a1.01 1.01 0 1 1 1.35 1.49 5.05 5.05 0 0 1-.64 6.36l-.72.73c-.78.78-1.81 2.21-2.31 3.21l-1.51 3.02c-.25.5-.77.58-1.17.19l-8.56-8.55c-.4-.4-.31-.92.19-1.17l3.02-1.51c.99-.49 2.42-1.53 3.21-2.31zm2.74 9.63c.52-.97 1.57-2.4 2.35-3.18l.73-.73a3.05 3.05 0 0 0 .39-3.83c-.19-.29-.72-.77-.86-.86A3.04 3.04 0 0 0 15.05 6c-.8 0-1.57.31-2.16.89l-.95.95c-.78.79-2.22 1.82-3.2 2.31L7 11.02l6.07 6.07z"/></svg>`
    }, props));
$74aa43bc29155859$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
var $74aa43bc29155859$var$_default = module.exports.default = $74aa43bc29155859$var$NotificationDirectIcon;

});

parcelRegister("8GAdb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652e55d4accccbc5$var$_react = $652e55d4accccbc5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $652e55d4accccbc5$var$_arrowUpRight = $652e55d4accccbc5$var$_interopRequireDefault((parcelRequire("5kg9o")));
function $652e55d4accccbc5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $652e55d4accccbc5$var$OpenIcon = (props)=>/*#__PURE__*/ $652e55d4accccbc5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $652e55d4accccbc5$var$_arrowUpRight.default
    }));
$652e55d4accccbc5$var$OpenIcon.displayName = 'OpenIcon';
var $652e55d4accccbc5$var$_default = module.exports.default = $652e55d4accccbc5$var$OpenIcon;

});
parcelRegister("5kg9o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e0b5928d2c3822a$var$_react = $3e0b5928d2c3822a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3e0b5928d2c3822a$var$_UNSAFE_baseNew = $3e0b5928d2c3822a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3e0b5928d2c3822a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ArrowUpRight".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: open a link in a new page (but not a new tab).
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e0b5928d2c3822a$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $3e0b5928d2c3822a$var$_react.default.createElement($3e0b5928d2c3822a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 2.75 2.5 13.5M6.25 2.75h7v7"/>`
    }, props));
$3e0b5928d2c3822a$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $3e0b5928d2c3822a$var$_default = module.exports.default = $3e0b5928d2c3822a$var$ArrowUpRightIcon;

});


parcelRegister("cI9iM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9410cf464908763e$var$_react = $9410cf464908763e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9410cf464908763e$var$_person = $9410cf464908763e$var$_interopRequireDefault((parcelRequire("5wwfG")));
function $9410cf464908763e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9410cf464908763e$var$PersonIcon = (props)=>/*#__PURE__*/ $9410cf464908763e$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $9410cf464908763e$var$_person.default
    }));
$9410cf464908763e$var$PersonIcon.displayName = 'PersonIcon';
var $9410cf464908763e$var$_default = module.exports.default = $9410cf464908763e$var$PersonIcon;

});
parcelRegister("5wwfG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4058f58074609e1b$var$_react = $4058f58074609e1b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $4058f58074609e1b$var$_UNSAFE_baseNew = $4058f58074609e1b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $4058f58074609e1b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Person".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4058f58074609e1b$var$PersonIcon = (props)=>/*#__PURE__*/ $4058f58074609e1b$var$_react.default.createElement($4058f58074609e1b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 16v-3a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3v3m8.5-12a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$4058f58074609e1b$var$PersonIcon.displayName = 'PersonIcon';
var $4058f58074609e1b$var$_default = module.exports.default = $4058f58074609e1b$var$PersonIcon;

});


parcelRegister("ktq0D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee7ab0ff59e83b3d$var$_react = $ee7ab0ff59e83b3d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ee7ab0ff59e83b3d$var$_personAvatar = $ee7ab0ff59e83b3d$var$_interopRequireDefault((parcelRequire("fmxcK")));
function $ee7ab0ff59e83b3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ee7ab0ff59e83b3d$var$PersonCircleIcon = (props)=>/*#__PURE__*/ $ee7ab0ff59e83b3d$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
    }, props, {
        newIcon: $ee7ab0ff59e83b3d$var$_personAvatar.default
    }));
$ee7ab0ff59e83b3d$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
var $ee7ab0ff59e83b3d$var$_default = module.exports.default = $ee7ab0ff59e83b3d$var$PersonCircleIcon;

});
parcelRegister("fmxcK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2f2aad98c18b5df$var$_react = $b2f2aad98c18b5df$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b2f2aad98c18b5df$var$_UNSAFE_baseNew = $b2f2aad98c18b5df$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b2f2aad98c18b5df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "PersonAvatar".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2f2aad98c18b5df$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $b2f2aad98c18b5df$var$_react.default.createElement($b2f2aad98c18b5df$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 14.35v-.6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v.6m-.75-7.85a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z"/>`
    }, props));
$b2f2aad98c18b5df$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $b2f2aad98c18b5df$var$_default = module.exports.default = $b2f2aad98c18b5df$var$PersonAvatarIcon;

});


parcelRegister("1n6uL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ffcfa3f9afe5f5a$var$_react = $0ffcfa3f9afe5f5a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $0ffcfa3f9afe5f5a$var$_premium = $0ffcfa3f9afe5f5a$var$_interopRequireDefault((parcelRequire("582wZ")));
function $0ffcfa3f9afe5f5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0ffcfa3f9afe5f5a$var$PremiumIcon = (props)=>/*#__PURE__*/ $0ffcfa3f9afe5f5a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $0ffcfa3f9afe5f5a$var$_premium.default
    }));
$0ffcfa3f9afe5f5a$var$PremiumIcon.displayName = 'PremiumIcon';
var $0ffcfa3f9afe5f5a$var$_default = module.exports.default = $0ffcfa3f9afe5f5a$var$PremiumIcon;

});
parcelRegister("582wZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bbfa9b5644027b3$var$_react = $3bbfa9b5644027b3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3bbfa9b5644027b3$var$_UNSAFE_baseNew = $3bbfa9b5644027b3$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3bbfa9b5644027b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Premium".
 * Category: Single-purpose
 * Location: Icon contributions
 * Usage guidance: Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bbfa9b5644027b3$var$PremiumIcon = (props)=>/*#__PURE__*/ $3bbfa9b5644027b3$var$_react.default.createElement($3bbfa9b5644027b3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 13.75h2.25m0 0H16m-2.25 0V11.5m0 2.25V16M0 2.25h2.25m0 0H4.5m-2.25 0V0m0 2.25V4.5M8 1.75l1.75 4.5L14.25 8l-4.5 1.75L8 14.25l-1.75-4.5L1.75 8l4.5-1.75z"/>`
    }, props));
$3bbfa9b5644027b3$var$PremiumIcon.displayName = 'PremiumIcon';
var $3bbfa9b5644027b3$var$_default = module.exports.default = $3bbfa9b5644027b3$var$PremiumIcon;

});


parcelRegister("ioiQ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d639150540ca3770$var$_react = $d639150540ca3770$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d639150540ca3770$var$_questionCircle = $d639150540ca3770$var$_interopRequireDefault((parcelRequire("8MkOl")));
function $d639150540ca3770$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d639150540ca3770$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $d639150540ca3770$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentColor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $d639150540ca3770$var$_questionCircle.default
    }));
$d639150540ca3770$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $d639150540ca3770$var$_default = module.exports.default = $d639150540ca3770$var$QuestionCircleIcon;

});
parcelRegister("8MkOl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6642f313ed56af9a$var$_react = $6642f313ed56af9a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6642f313ed56af9a$var$_UNSAFE_baseNew = $6642f313ed56af9a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $6642f313ed56af9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6642f313ed56af9a$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $6642f313ed56af9a$var$_react.default.createElement($6642f313ed56af9a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentColor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$6642f313ed56af9a$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $6642f313ed56af9a$var$_default = module.exports.default = $6642f313ed56af9a$var$QuestionCircleIcon;

});


parcelRegister("k6W9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea417b25f2e1b21d$var$_react = $ea417b25f2e1b21d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ea417b25f2e1b21d$var$_clock = $ea417b25f2e1b21d$var$_interopRequireDefault((parcelRequire("eSHsi")));
function $ea417b25f2e1b21d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ea417b25f2e1b21d$var$RecentIcon = (props)=>/*#__PURE__*/ $ea417b25f2e1b21d$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
    }, props, {
        newIcon: $ea417b25f2e1b21d$var$_clock.default
    }));
$ea417b25f2e1b21d$var$RecentIcon.displayName = 'RecentIcon';
var $ea417b25f2e1b21d$var$_default = module.exports.default = $ea417b25f2e1b21d$var$RecentIcon;

});
parcelRegister("eSHsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad57d129a6074c24$var$_react = $ad57d129a6074c24$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ad57d129a6074c24$var$_UNSAFE_baseNew = $ad57d129a6074c24$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ad57d129a6074c24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Clock".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: recent, time input, sprint time remaining.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad57d129a6074c24$var$ClockIcon = (props)=>/*#__PURE__*/ $ad57d129a6074c24$var$_react.default.createElement($ad57d129a6074c24$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$ad57d129a6074c24$var$ClockIcon.displayName = 'ClockIcon';
var $ad57d129a6074c24$var$_default = module.exports.default = $ad57d129a6074c24$var$ClockIcon;

});


parcelRegister("5318D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ace1d9d3a4d7e1f$var$_react = $3ace1d9d3a4d7e1f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3ace1d9d3a4d7e1f$var$_screen = $3ace1d9d3a4d7e1f$var$_interopRequireDefault((parcelRequire("gbbKH")));
function $3ace1d9d3a4d7e1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3ace1d9d3a4d7e1f$var$ScreenIcon = (props)=>/*#__PURE__*/ $3ace1d9d3a4d7e1f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 13.991zM5 14h14V6H5z"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5v.5H9z"/></g></svg>`
    }, props, {
        newIcon: $3ace1d9d3a4d7e1f$var$_screen.default
    }));
$3ace1d9d3a4d7e1f$var$ScreenIcon.displayName = 'ScreenIcon';
var $3ace1d9d3a4d7e1f$var$_default = module.exports.default = $3ace1d9d3a4d7e1f$var$ScreenIcon;

});
parcelRegister("gbbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc76ca24978f4d5d$var$_react = $bc76ca24978f4d5d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bc76ca24978f4d5d$var$_UNSAFE_baseNew = $bc76ca24978f4d5d$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $bc76ca24978f4d5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Screen".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc76ca24978f4d5d$var$ScreenIcon = (props)=>/*#__PURE__*/ $bc76ca24978f4d5d$var$_react.default.createElement($bc76ca24978f4d5d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M8 11.25h5c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25zm0 0v3m0 0h4m-4 0H4"/>`
    }, props));
$bc76ca24978f4d5d$var$ScreenIcon.displayName = 'ScreenIcon';
var $bc76ca24978f4d5d$var$_default = module.exports.default = $bc76ca24978f4d5d$var$ScreenIcon;

});


parcelRegister("dsroq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cc32389de297b6e$var$_react = $9cc32389de297b6e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9cc32389de297b6e$var$_search = $9cc32389de297b6e$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $9cc32389de297b6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9cc32389de297b6e$var$SearchIcon = (props)=>/*#__PURE__*/ $9cc32389de297b6e$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $9cc32389de297b6e$var$_search.default
    }));
$9cc32389de297b6e$var$SearchIcon.displayName = 'SearchIcon';
var $9cc32389de297b6e$var$_default = module.exports.default = $9cc32389de297b6e$var$SearchIcon;

});
parcelRegister("9IsWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $712eac3ce5f61ae7$var$_react = $712eac3ce5f61ae7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $712eac3ce5f61ae7$var$_UNSAFE_baseNew = $712eac3ce5f61ae7$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $712eac3ce5f61ae7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Search".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $712eac3ce5f61ae7$var$SearchIcon = (props)=>/*#__PURE__*/ $712eac3ce5f61ae7$var$_react.default.createElement($712eac3ce5f61ae7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$712eac3ce5f61ae7$var$SearchIcon.displayName = 'SearchIcon';
var $712eac3ce5f61ae7$var$_default = module.exports.default = $712eac3ce5f61ae7$var$SearchIcon;

});


parcelRegister("iw0Y6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7abf776b52155a3$var$_react = $d7abf776b52155a3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d7abf776b52155a3$var$_settings = $d7abf776b52155a3$var$_interopRequireDefault((parcelRequire("dW1OX")));
function $d7abf776b52155a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d7abf776b52155a3$var$SettingsIcon = (props)=>/*#__PURE__*/ $d7abf776b52155a3$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $d7abf776b52155a3$var$_settings.default
    }));
$d7abf776b52155a3$var$SettingsIcon.displayName = 'SettingsIcon';
var $d7abf776b52155a3$var$_default = module.exports.default = $d7abf776b52155a3$var$SettingsIcon;

});
parcelRegister("dW1OX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2521ab8cf3961ed$var$_react = $a2521ab8cf3961ed$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a2521ab8cf3961ed$var$_UNSAFE_baseNew = $a2521ab8cf3961ed$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a2521ab8cf3961ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Settings".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2521ab8cf3961ed$var$SettingsIcon = (props)=>/*#__PURE__*/ $a2521ab8cf3961ed$var$_react.default.createElement($a2521ab8cf3961ed$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$a2521ab8cf3961ed$var$SettingsIcon.displayName = 'SettingsIcon';
var $a2521ab8cf3961ed$var$_default = module.exports.default = $a2521ab8cf3961ed$var$SettingsIcon;

});


parcelRegister("14lY4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c77348158dae6ea$var$_react = $0c77348158dae6ea$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $0c77348158dae6ea$var$_release = $0c77348158dae6ea$var$_interopRequireDefault((parcelRequire("1rDQJ")));
function $0c77348158dae6ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0c77348158dae6ea$var$ShipIcon = (props)=>/*#__PURE__*/ $0c77348158dae6ea$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $0c77348158dae6ea$var$_release.default
    }));
$0c77348158dae6ea$var$ShipIcon.displayName = 'ShipIcon';
var $0c77348158dae6ea$var$_default = module.exports.default = $0c77348158dae6ea$var$ShipIcon;

});
parcelRegister("1rDQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10d73953e13c9d7a$var$_react = $10d73953e13c9d7a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $10d73953e13c9d7a$var$_UNSAFE_baseNew = $10d73953e13c9d7a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $10d73953e13c9d7a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Release".
 * Category: Single-purpose
 * Location: Icon contributions
 * Usage guidance: Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10d73953e13c9d7a$var$ReleaseIcon = (props)=>/*#__PURE__*/ $10d73953e13c9d7a$var$_react.default.createElement($10d73953e13c9d7a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$10d73953e13c9d7a$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $10d73953e13c9d7a$var$_default = module.exports.default = $10d73953e13c9d7a$var$ReleaseIcon;

});


parcelRegister("23NQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1802859362692b41$var$_react = $1802859362692b41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $1802859362692b41$var$_linkExternal = $1802859362692b41$var$_interopRequireDefault((parcelRequire("1yh1n")));
function $1802859362692b41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1802859362692b41$var$ShortcutIcon = (props)=>/*#__PURE__*/ $1802859362692b41$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $1802859362692b41$var$_linkExternal.default
    }));
$1802859362692b41$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $1802859362692b41$var$_default = module.exports.default = $1802859362692b41$var$ShortcutIcon;

});
parcelRegister("1yh1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12162b7a8a9ddc85$var$_react = $12162b7a8a9ddc85$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $12162b7a8a9ddc85$var$_UNSAFE_baseNew = $12162b7a8a9ddc85$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $12162b7a8a9ddc85$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12162b7a8a9ddc85$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $12162b7a8a9ddc85$var$_react.default.createElement($12162b7a8a9ddc85$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M6 2.75H4c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-2M8 8l5.25-5.25m0 4.25V2.75H9"/>`
    }, props));
$12162b7a8a9ddc85$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $12162b7a8a9ddc85$var$_default = module.exports.default = $12162b7a8a9ddc85$var$LinkExternalIcon;

});


parcelRegister("1ZFzZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $173bbdbf247c682d$var$_react = $173bbdbf247c682d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $173bbdbf247c682d$var$_logIn = $173bbdbf247c682d$var$_interopRequireDefault((parcelRequire("uuI5V")));
function $173bbdbf247c682d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $173bbdbf247c682d$var$SignInIcon = (props)=>/*#__PURE__*/ $173bbdbf247c682d$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0 0 19.006 3z"/><path d="M3.977 11A.99.99 0 0 0 3 12.001c0 .551.437.999.977.999h11.047a.99.99 0 0 0 .976-.999.99.99 0 0 0-.976-1.001z"/><path d="M12.303 8.305a1.053 1.053 0 0 0 0 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 0 0 0 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 0 0 0-1.477l-2.93-2.956a1.034 1.034 0 0 0-1.465 0"/></g></svg>`
    }, props, {
        newIcon: $173bbdbf247c682d$var$_logIn.default
    }));
$173bbdbf247c682d$var$SignInIcon.displayName = 'SignInIcon';
var $173bbdbf247c682d$var$_default = module.exports.default = $173bbdbf247c682d$var$SignInIcon;

});
parcelRegister("uuI5V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05ba9fdd0cb630c4$var$_react = $05ba9fdd0cb630c4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $05ba9fdd0cb630c4$var$_UNSAFE_baseNew = $05ba9fdd0cb630c4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $05ba9fdd0cb630c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "LogIn".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for login.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05ba9fdd0cb630c4$var$LogInIcon = (props)=>/*#__PURE__*/ $05ba9fdd0cb630c4$var$_react.default.createElement($05ba9fdd0cb630c4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75h5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H8M5.75 4.5 9.25 8m0 0-3.5 3.5M9.25 8H1"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 4.5 9.25 8l-3.5 3.5"/>`
    }, props));
$05ba9fdd0cb630c4$var$LogInIcon.displayName = 'LogInIcon';
var $05ba9fdd0cb630c4$var$_default = module.exports.default = $05ba9fdd0cb630c4$var$LogInIcon;

});


parcelRegister("daM3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99717d2ff622f6d5$var$_react = $99717d2ff622f6d5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $99717d2ff622f6d5$var$_starUnstarred = $99717d2ff622f6d5$var$_interopRequireDefault((parcelRequire("7jsaI")));
function $99717d2ff622f6d5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $99717d2ff622f6d5$var$StarIcon = (props)=>/*#__PURE__*/ $99717d2ff622f6d5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $99717d2ff622f6d5$var$_starUnstarred.default
    }));
$99717d2ff622f6d5$var$StarIcon.displayName = 'StarIcon';
var $99717d2ff622f6d5$var$_default = module.exports.default = $99717d2ff622f6d5$var$StarIcon;

});
parcelRegister("7jsaI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5530291ce1758d26$var$_react = $5530291ce1758d26$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5530291ce1758d26$var$_UNSAFE_baseNew = $5530291ce1758d26$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5530291ce1758d26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5530291ce1758d26$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $5530291ce1758d26$var$_react.default.createElement($5530291ce1758d26$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$5530291ce1758d26$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $5530291ce1758d26$var$_default = module.exports.default = $5530291ce1758d26$var$StarUnstarredIcon;

});


parcelRegister("hlWtt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca21c19e82ca8ae2$var$_react = $ca21c19e82ca8ae2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ca21c19e82ca8ae2$var$_starStarred = $ca21c19e82ca8ae2$var$_interopRequireDefault((parcelRequire("23Ou2")));
function $ca21c19e82ca8ae2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ca21c19e82ca8ae2$var$StarFilledIcon = (props)=>/*#__PURE__*/ $ca21c19e82ca8ae2$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $ca21c19e82ca8ae2$var$_starStarred.default
    }));
$ca21c19e82ca8ae2$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $ca21c19e82ca8ae2$var$_default = module.exports.default = $ca21c19e82ca8ae2$var$StarFilledIcon;

});
parcelRegister("23Ou2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1803058a10442127$var$_react = $1803058a10442127$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1803058a10442127$var$_UNSAFE_baseNew = $1803058a10442127$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1803058a10442127$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "StarStarred".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1803058a10442127$var$StarStarredIcon = (props)=>/*#__PURE__*/ $1803058a10442127$var$_react.default.createElement($1803058a10442127$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentColor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
    }, props));
$1803058a10442127$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $1803058a10442127$var$_default = module.exports.default = $1803058a10442127$var$StarStarredIcon;

});


parcelRegister("5YsMl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4598e13719f4189b$var$_react = $4598e13719f4189b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $4598e13719f4189b$var$_warning = $4598e13719f4189b$var$_interopRequireDefault((parcelRequire("ewJfY")));
function $4598e13719f4189b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4598e13719f4189b$var$WarningIcon = (props)=>/*#__PURE__*/ $4598e13719f4189b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentColor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $4598e13719f4189b$var$_warning.default
    }));
$4598e13719f4189b$var$WarningIcon.displayName = 'WarningIcon';
var $4598e13719f4189b$var$_default = module.exports.default = $4598e13719f4189b$var$WarningIcon;

});
parcelRegister("ewJfY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a93728e2db5c27c2$var$_react = $a93728e2db5c27c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a93728e2db5c27c2$var$_UNSAFE_baseNew = $a93728e2db5c27c2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a93728e2db5c27c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Warning".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a93728e2db5c27c2$var$WarningIcon = (props)=>/*#__PURE__*/ $a93728e2db5c27c2$var$_react.default.createElement($a93728e2db5c27c2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.379.342 12.046zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$a93728e2db5c27c2$var$WarningIcon.displayName = 'WarningIcon';
var $a93728e2db5c27c2$var$_default = module.exports.default = $a93728e2db5c27c2$var$WarningIcon;

});


parcelRegister("kigFe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6edb9f28366efd9a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cMtFc = parcelRequire("cMtFc");

var $dlyGx = parcelRequire("dlyGx");
const $6edb9f28366efd9a$var$headerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $dlyGx.padding),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlockEnd: `${(0, $dlyGx.padding) - (0, $dlyGx.keylineHeight)}px`
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $6edb9f28366efd9a$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6edb9f28366efd9a$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $6edb9f28366efd9a$export$2e2bcd8739ae039 = $6edb9f28366efd9a$var$ModalHeader;

});
parcelRegister("cMtFc", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $fcb16fa0a8cd6eb7$export$33ffd74ebf07f060);

var $eUqFw = parcelRequire("eUqFw");

var $i7afc = parcelRequire("i7afc");
const $fcb16fa0a8cd6eb7$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $eUqFw.useContext)((0, $i7afc.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});


parcelRegister("boSVF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $244f2d118fff9712$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $96IgR = parcelRequire("96IgR");

var $5YsMl = parcelRequire("5YsMl");

var $cMtFc = parcelRequire("cMtFc");

var $dlyGx = parcelRequire("dlyGx");
function $244f2d118fff9712$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $244f2d118fff9712$var$titleStyles = {
    name: "1yaejj3",
    styles: "display:flex;min-width:0;margin:var(--ds-space-0, 0px);gap:var(--ds-space-100, 8px);font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $244f2d118fff9712$var$textStyles = {
    name: "1k30s2j",
    styles: "min-width:0;flex:1 1 auto;word-wrap:break-word"
};
const $244f2d118fff9712$var$iconStyles = {
    name: "1cdsq8b",
    styles: "flex:0 0 auto;color:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit"
};
const $244f2d118fff9712$var$truncatedTextStyles = {
    name: "1h52dri",
    styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $244f2d118fff9712$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))) : (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl)));
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $244f2d118fff9712$var$iconStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        label: appearance,
        primaryColor: (0, $dlyGx.iconColor)[appearance]
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $244f2d118fff9712$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: $244f2d118fff9712$var$titleStyles,
        "data-testid": testId
    }, appearance && /*#__PURE__*/ (0, $byn9U.jsx)($244f2d118fff9712$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: titleId,
        css: [
            $244f2d118fff9712$var$textStyles,
            !isMultiline && $244f2d118fff9712$var$truncatedTextStyles
        ],
        "data-testid": testId && `${testId}-text`
    }, children));
};
var $244f2d118fff9712$export$2e2bcd8739ae039 = $244f2d118fff9712$var$ModalTitle;

});

parcelRegister("lfiOu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $32d7be1cefbdd135$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8MHxr = parcelRequire("8MHxr");

var $cMtFc = parcelRequire("cMtFc");

var $84xlG = parcelRequire("84xlG");

var $dlyGx = parcelRequire("dlyGx");

var $eo7vn = parcelRequire("eo7vn");
function $32d7be1cefbdd135$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32d7be1cefbdd135$var$bodyStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer.
 */ const $32d7be1cefbdd135$var$bodyScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $dlyGx.keylineHeight)}px ${(0, $dlyGx.padding)}px`
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ const $32d7be1cefbdd135$var$viewportScrollStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0px ${(0, $dlyGx.padding)}px`
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $32d7be1cefbdd135$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const shouldScrollInViewport = (0, $eo7vn.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $32d7be1cefbdd135$var$bodyStyles,
            $32d7be1cefbdd135$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8MHxr.TouchScrollable), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $84xlG.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $32d7be1cefbdd135$var$bodyStyles,
            $32d7be1cefbdd135$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $32d7be1cefbdd135$export$2e2bcd8739ae039 = $32d7be1cefbdd135$var$ModalBody;

});
parcelRegister("84xlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $56917204a240f120$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $8yx6O = parcelRequire("8yx6O");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $3jACL = parcelRequire("3jACL");

var $3LlFG = parcelRequire("3LlFG");

var $51sCz = parcelRequire("51sCz");

var $4Ywu9 = parcelRequire("4Ywu9");

var $dlyGx = parcelRequire("dlyGx");
const $56917204a240f120$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inherit',
    margin: "var(--ds-space-0, 0px)",
    flex: 'inherit',
    flexDirection: 'inherit',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    [(0, $4Ywu9.media).above.xs]: {
        height: 'unset',
        overflowY: 'auto'
    }
});
const $56917204a240f120$var$topKeylineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockStart: `${(0, $dlyGx.keylineHeight)}px solid ${(0, $dlyGx.keylineColor)}`
});
const $56917204a240f120$var$bottomKeylineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `${(0, $dlyGx.keylineHeight)}px solid ${(0, $dlyGx.keylineColor)}`
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $56917204a240f120$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { testId: testId, children: children } = props;
    const [hasSiblings, setSiblings] = (0, $3LlFG.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eUqFw.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const setLazySiblings = (0, $3jACL.default)(setSiblings);
    const setLazyContentFocus = (0, $3jACL.default)((0, $8yx6O.default)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $3jACL.default)((0, $8yx6O.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $dlyGx.keylineHeight));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $dlyGx.keylineHeight));
        }
    }));
    (0, $eUqFw.useEffect)(()=>{
        const target = scrollableRef.current;
        const unbindWindowEvent = (0, $74BVL.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $74BVL.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $5Q9wj.default);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        "data-testid": testId && `${testId}--scrollable`,
        ref: (0, $1lQG9.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $56917204a240f120$var$baseStyles,
            showTopKeyline && $56917204a240f120$var$topKeylineStyles,
            showBottomKeyline && $56917204a240f120$var$bottomKeylineStyles
        ]
    }, children));
});
$56917204a240f120$var$ScrollContainer.displayName = 'ScrollContainer';
var $56917204a240f120$export$2e2bcd8739ae039 = $56917204a240f120$var$ScrollContainer;

});

parcelRegister("eo7vn", function(module, exports) {

$parcel$export(module.exports, "default", () => $38cfd2158a03253c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $i7afc = parcelRequire("i7afc");
function $38cfd2158a03253c$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $eUqFw.useContext)((0, $i7afc.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("2OJfS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $82fa2bab5a342607$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $cMtFc = parcelRequire("cMtFc");

var $dlyGx = parcelRequire("dlyGx");
const $82fa2bab5a342607$var$footerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $dlyGx.padding),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlockStart: `${(0, $dlyGx.padding) - (0, $dlyGx.keylineHeight)}px`
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $82fa2bab5a342607$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $82fa2bab5a342607$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $82fa2bab5a342607$export$2e2bcd8739ae039 = $82fa2bab5a342607$var$ModalFooter;

});

parcelRegister("j9fWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $882a7c49c57eabf3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ZL0y = parcelRequire("4ZL0y");

var $8cU5f = parcelRequire("8cU5f");

var $cxipd = parcelRequire("cxipd");
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/icon-button/examples)
 * - [Code](https://atlassian.design/components/icon-button/code)
 * - [Usage](https://atlassian.design/components/icon-button/usage)
 */ const $882a7c49c57eabf3$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    /**
		 * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
		 * buttons. It's currently duplicated and mostly the same.
		 */ const baseProps = (0, $cxipd.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'button',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
            ...saferRest,
            // Top level props
            "aria-labelledby": baseProps['aria-labelledby'],
            type: type,
            testId: testId,
            componentName: "IconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                saferRest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                saferRest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                saferRest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                saferRest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                saferRest.onBlur?.(e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                baseProps?.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (ref)=>{
                baseProps.ref(ref);
                triggerProps?.ref?.(ref);
            },
            // Base props only
            xcss: baseProps.xcss,
            isDisabled: baseProps.isDisabled,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture
        }, baseProps.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...saferRest,
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, baseProps.children);
}));
$882a7c49c57eabf3$var$IconButton.displayName = 'IconButton';
var $882a7c49c57eabf3$export$2e2bcd8739ae039 = $882a7c49c57eabf3$var$IconButton;

});
parcelRegister("8cU5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb971103818d470$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $591ND = parcelRequire("591ND");

var $5Q9wj = parcelRequire("5Q9wj");

var $kVO3J = parcelRequire("kVO3J");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");

var $5LHuc = parcelRequire("5LHuc");

var $i6BC8 = parcelRequire("i6BC8");

var $gmZvv = parcelRequire("gmZvv");

var $lcnyw = parcelRequire("lcnyw");

var $e4oGB = parcelRequire("e4oGB");

var $b68Pq = parcelRequire("b68Pq");

var $3iORZ = parcelRequire("3iORZ");

var $dPawH = parcelRequire("dPawH");

var $FbZPV = parcelRequire("FbZPV");
const $3fb971103818d470$var$tooltipZIndex = (0, $lcnyw.layers).tooltip();
const $3fb971103818d470$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $3fb971103818d470$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $3fb971103818d470$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
function $3fb971103818d470$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $dPawH.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $5Q9wj.default), onHide: onHide = (0, $5Q9wj.default), hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $591ND.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$3fb971103818d470$var$analyticsAttributes
    });
    const onHideHandler = (0, $591ND.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$3fb971103818d470$var$analyticsAttributes
    });
    const apiRef = (0, $eUqFw.useRef)(null);
    const [state, setState] = (0, $eUqFw.useState)('hide');
    const targetRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $eUqFw.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const lastState = (0, $eUqFw.useRef)(state);
    const lastDelay = (0, $eUqFw.useRef)(delay);
    const lastHandlers = (0, $eUqFw.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    const hasCalledShowHandler = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    const start = (0, $eUqFw.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $eUqFw.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, []);
    const abort = (0, $eUqFw.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $eUqFw.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $e4oGB.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const showTooltip = (0, $eUqFw.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        const entry = {
            source: source,
            delay: lastDelay.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $b68Pq.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    const hideTooltipOnEsc = (0, $eUqFw.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $kVO3J.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $eUqFw.useEffect)(()=>{
        if (state === 'hide') return 0, $5Q9wj.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $74BVL.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $eUqFw.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $FbZPV.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $eUqFw.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $FbZPV.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $eUqFw.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $eUqFw.useCallback)(()=>{
        showTooltip({
            type: 'keyboard'
        });
    }, [
        showTooltip
    ]);
    const onBlur = (0, $eUqFw.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $eUqFw.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && lastState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipContainer = state !== 'hide' && Boolean(content);
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipId = (0, $3iORZ.default)('tooltip', shouldRenderTooltipContainer);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $eUqFw.useEffect)(()=>{
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        const target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute('aria-describedby', tooltipId);
        else target.removeAttribute('aria-describedby');
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    const hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === 'function' ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        ...tooltipTriggerProps,
        'aria-describedby': tooltipId,
        ref: setDirectRef
    }), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CastTargetContainer, {
        ...tooltipTriggerProps,
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }, children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
        zIndex: $3fb971103818d470$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, ({ ref: ref, style: style, update: update, placement: placement })=>{
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        const direction = position === 'mouse' ? undefined : $3fb971103818d470$var$invertedDirection[$3fb971103818d470$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === 'show-immediate' ? 0 : (0, $5LHuc.mediumDurationMs)
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, {
                ref: ref,
                /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `Tooltip ${className}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...ignoreTooltipPointerEvents && {
                        pointerEvents: 'none'
                    }
                },
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content)));
    })) : null);
}
$3fb971103818d470$var$Tooltip.displayName = 'Tooltip';
var $3fb971103818d470$export$2e2bcd8739ae039 = $3fb971103818d470$var$Tooltip;

});
parcelRegister("kVO3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $753bd8784aa528d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

function $753bd8784aa528d9$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $54717ce5fa2c74b1$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';


parcelRegister("e4oGB", function(module, exports) {

$parcel$export(module.exports, "register", () => $89787f5f1d3ba871$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $74BVL = parcelRequire("74BVL");
const $89787f5f1d3ba871$var$registrations = new Set();
let $89787f5f1d3ba871$var$cleanupEndEventListeners = null;
function $89787f5f1d3ba871$var$onDragStart() {
    if ($89787f5f1d3ba871$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $89787f5f1d3ba871$var$cleanupEndEventListeners = (0, $74BVL.bindAll)(window, [
        {
            type: 'dragend',
            listener: $89787f5f1d3ba871$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $89787f5f1d3ba871$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $89787f5f1d3ba871$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($89787f5f1d3ba871$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $89787f5f1d3ba871$var$onDragEnd() {
    $89787f5f1d3ba871$var$cleanupEndEventListeners?.();
    $89787f5f1d3ba871$var$cleanupEndEventListeners = null;
    const clone = Array.from($89787f5f1d3ba871$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $89787f5f1d3ba871$var$bindStartEvents() {
    return (0, $74BVL.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $89787f5f1d3ba871$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $89787f5f1d3ba871$var$onDragStart
        }
    ]);
}
let $89787f5f1d3ba871$var$cleanupStartEventListeners = null;
function $89787f5f1d3ba871$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$89787f5f1d3ba871$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $89787f5f1d3ba871$var$cleanupStartEventListeners = $89787f5f1d3ba871$var$bindStartEvents();
    $89787f5f1d3ba871$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $89787f5f1d3ba871$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $89787f5f1d3ba871$var$registrations.delete(registration);
        if ($89787f5f1d3ba871$var$registrations.size === 0) {
            $89787f5f1d3ba871$var$cleanupStartEventListeners?.();
            $89787f5f1d3ba871$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("b68Pq", function(module, exports) {

$parcel$export(module.exports, "show", () => $e419e64720bfb6f9$export$57bf213be019eeb0);

var $9qZhf = parcelRequire("9qZhf");
let $e419e64720bfb6f9$var$active = null;
function $e419e64720bfb6f9$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($e419e64720bfb6f9$var$active && $e419e64720bfb6f9$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $9qZhf.clearScheduled)();
            $e419e64720bfb6f9$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $9qZhf.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $9qZhf.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $9qZhf.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($e419e64720bfb6f9$var$active && $e419e64720bfb6f9$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($e419e64720bfb6f9$var$active) {
            (0, $9qZhf.clearScheduled)();
            $e419e64720bfb6f9$var$active.entry.hide({
                isImmediate: true
            });
            $e419e64720bfb6f9$var$active.entry.done();
            $e419e64720bfb6f9$var$active = null;
        }
        // this tooltip is now the active tooltip
        $e419e64720bfb6f9$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $9qZhf.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("9qZhf", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $7dbfbdfec4230fa7$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $7dbfbdfec4230fa7$export$5f4d6617421d489b);
let $7dbfbdfec4230fa7$var$delayId = null;
function $7dbfbdfec4230fa7$export$eaf678f6f93f5250() {
    if ($7dbfbdfec4230fa7$var$delayId != null) {
        window.clearTimeout($7dbfbdfec4230fa7$var$delayId);
        $7dbfbdfec4230fa7$var$delayId = null;
    }
}
function $7dbfbdfec4230fa7$export$5f4d6617421d489b(fn, delay) {
    $7dbfbdfec4230fa7$export$eaf678f6f93f5250();
    $7dbfbdfec4230fa7$var$delayId = window.setTimeout(()=>{
        $7dbfbdfec4230fa7$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("3iORZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bb7c4fa7016f0c0$export$2e2bcd8739ae039);

var $jFtVs = parcelRequire("jFtVs");
function $9bb7c4fa7016f0c0$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $jFtVs.useUIDSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});

parcelRegister("dPawH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7709415186bb42bf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $g3tFP = parcelRequire("g3tFP");
function $7709415186bb42bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7709415186bb42bf$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    maxWidth: '240px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    backgroundColor: `var(--ds-background-neutral-bold, ${(0, $PdmhA.N800)})`,
    color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`
});
const $7709415186bb42bf$var$truncateStyles = {
    name: "1e1ci1f",
    styles: "max-width:420px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $7709415186bb42bf$var$TooltipContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $g3tFP.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $7709415186bb42bf$var$baseStyles,
            truncate ? $7709415186bb42bf$var$truncateStyles : null
        ]
    }, children);
});
$7709415186bb42bf$var$TooltipContainer.displayName = 'TooltipContainer';
var $7709415186bb42bf$export$2e2bcd8739ae039 = $7709415186bb42bf$var$TooltipContainer;

});
parcelRegister("g3tFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b965e13e2506d09$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $7b965e13e2506d09$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $7b965e13e2506d09$var$primitiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zindex: `var(${$7b965e13e2506d09$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
const $7b965e13e2506d09$var$TooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$7b965e13e2506d09$var$VAR_PRIMITIVE_ZINDEX]: (0, $lcnyw.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        /* eslint-enable jsx-a11y/mouse-events-have-key-events */ css: $7b965e13e2506d09$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$7b965e13e2506d09$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $7b965e13e2506d09$export$2e2bcd8739ae039 = $7b965e13e2506d09$var$TooltipPrimitive;

});


parcelRegister("FbZPV", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $e4af402eec8ac769$export$642213d516a9b928);
function $e4af402eec8ac769$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("cxipd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dc8402cbeff77f2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");

var $3ICHT = parcelRequire("3ICHT");

var $1Pq75 = parcelRequire("1Pq75");

var $fE1y3 = parcelRequire("fE1y3");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ const $0dc8402cbeff77f2$var$useIconButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shape: shape, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
    const isCircle = shape === 'circle';
    const baseProps = (0, $fE1y3.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Pq75.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $0dc8402cbeff77f2$export$2e2bcd8739ae039 = $0dc8402cbeff77f2$var$useIconButton;

});
parcelRegister("3ICHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4778d4b230a21253$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $4778d4b230a21253$var$textStyles = (0, $1ZAYh.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $4778d4b230a21253$var$iconStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0,
    userSelect: 'none'
});
const $4778d4b230a21253$var$commonStyles = (0, $1ZAYh.xcss)({
    transition: 'opacity 0.3s'
});
const $4778d4b230a21253$var$fadeStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $4778d4b230a21253$var$beforeIconStyles = (0, $1ZAYh.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
const $4778d4b230a21253$var$afterIconStyles = (0, $1ZAYh.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $4778d4b230a21253$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $4778d4b230a21253$var$commonStyles,
            ...type === 'text' ? [
                $4778d4b230a21253$var$textStyles
            ] : [
                $4778d4b230a21253$var$iconStyles
            ],
            ...isLoading ? [
                $4778d4b230a21253$var$fadeStyles
            ] : [],
            ...position === 'before' ? [
                $4778d4b230a21253$var$beforeIconStyles
            ] : [],
            ...position === 'after' ? [
                $4778d4b230a21253$var$afterIconStyles
            ] : []
        ]
    }, children);
};
var $4778d4b230a21253$export$2e2bcd8739ae039 = $4778d4b230a21253$var$Content;

});

parcelRegister("1Pq75", function(module, exports) {

$parcel$export(module.exports, "default", () => $80e6adc142bfc0f1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $80e6adc142bfc0f1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $80e6adc142bfc0f1$var$IconRenderer = ({ icon: Icon })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $80e6adc142bfc0f1$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: "",
        color: 'currentColor'
    }));
};
var $80e6adc142bfc0f1$export$2e2bcd8739ae039 = $80e6adc142bfc0f1$var$IconRenderer;

});

parcelRegister("fE1y3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f92f4a271b94157$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $tkrFt = parcelRequire("tkrFt");

var $1lQG9 = parcelRequire("1lQG9");

var $hhlqA = parcelRequire("hhlqA");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $lkPEe = parcelRequire("lkPEe");

var $j5H17 = parcelRequire("j5H17");

var $alfOm = parcelRequire("alfOm");


var $byjW4 = parcelRequire("byjW4");
const $9f92f4a271b94157$var$buttonStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: `${32 / 14}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
const $9f92f4a271b94157$var$hardCodedButtonStyles = (0, $1ZAYh.xcss)({
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: `${32 / 14}em`,
    paddingBlock: 'space.0'
});
const $9f92f4a271b94157$var$tokenizedButtonStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: 'space.075'
});
const $9f92f4a271b94157$var$defaultInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$PdmhA.N500})`
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-neutral-pressed, ${$PdmhA.B75})`,
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$PdmhA.B400})`
    }
});
const $9f92f4a271b94157$var$defaultInteractiveRefreshedStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
const $9f92f4a271b94157$var$defaultStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: `var(--ds-background-neutral, ${$PdmhA.N20A})`,
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$PdmhA.N500})`,
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$PdmhA.N500})`
    }
});
const $9f92f4a271b94157$var$defaultRefreshedStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
const $9f92f4a271b94157$var$primaryStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
const $9f92f4a271b94157$var$primaryInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
const $9f92f4a271b94157$var$warningStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
const $9f92f4a271b94157$var$warningInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
const $9f92f4a271b94157$var$dangerStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $9f92f4a271b94157$var$dangerInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
const $9f92f4a271b94157$var$discoveryStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $9f92f4a271b94157$var$discoveryInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
const $9f92f4a271b94157$var$subtleStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $9f92f4a271b94157$var$subtleRefreshedStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
const $9f92f4a271b94157$var$subtleInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $9f92f4a271b94157$var$subtleInteractiveRefreshedStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
const $9f92f4a271b94157$var$linkStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-link, ${$PdmhA.B400})`,
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-link, ${$PdmhA.B300})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-link, ${$PdmhA.B400})`
    }
});
const $9f92f4a271b94157$var$subtleLinkStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${$PdmhA.N200})`,
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${$PdmhA.N90})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$PdmhA.N400})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${$PdmhA.N200})`
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
const $9f92f4a271b94157$var$linkDecorationUnsetStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
const $9f92f4a271b94157$var$linkDecorationStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus': {
        textDecoration: 'underline'
    }
});
const $9f92f4a271b94157$var$disabledStyles = (0, $1ZAYh.xcss)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-disabled, ${$PdmhA.N20A})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
const $9f92f4a271b94157$var$selectedStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$PdmhA.N700})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$PdmhA.N20})`,
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`
    }
});
const $9f92f4a271b94157$var$selectedRefreshedStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
const $9f92f4a271b94157$var$selectedInsideSplitButtonStyles = (0, $1ZAYh.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
const $9f92f4a271b94157$var$selectedInteractiveStyles = (0, $1ZAYh.xcss)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected-hovered, ${$PdmhA.N700})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected-pressed, ${$PdmhA.N700})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $9f92f4a271b94157$var$selectedWarningStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$PdmhA.Y400})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$PdmhA.N800})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$PdmhA.Y400})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$PdmhA.Y400})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $9f92f4a271b94157$var$selectedDangerStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$PdmhA.R500})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$PdmhA.N20})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$PdmhA.R500})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$PdmhA.R500})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $9f92f4a271b94157$var$selectedDiscoveryStyles = (0, $1ZAYh.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$PdmhA.N20})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$PdmhA.N20})`,
        background: "var(--ds-background-selected, #403294)"
    }
});
const $9f92f4a271b94157$var$spacingCompactStyles = (0, $1ZAYh.xcss)({
    columnGap: 'space.050',
    height: `${24 / 14}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
const $9f92f4a271b94157$var$baseSpacingCompactStyles = (0, $1ZAYh.xcss)({
    lineHeight: `${24 / 14}em`
});
const $9f92f4a271b94157$var$tokenizedSpacingCompactStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.025'
});
const $9f92f4a271b94157$var$spacingNoneStyles = (0, $1ZAYh.xcss)({
    columnGap: 'space.0',
    height: 'auto',
    lineHeight: 'inherit',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0',
    verticalAlign: 'baseline'
});
const $9f92f4a271b94157$var$tokenizedSpacingNoneStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.0'
});
const $9f92f4a271b94157$var$circleStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.circle'
});
const $9f92f4a271b94157$var$fullWidthStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $9f92f4a271b94157$var$loadingStyles = (0, $1ZAYh.xcss)({
    cursor: 'progress'
});
const $9f92f4a271b94157$var$iconButtonStyles = (0, $1ZAYh.xcss)({
    height: `${32 / 14}em`,
    width: `${32 / 14}em`,
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
const $9f92f4a271b94157$var$iconButtonCompactStyles = (0, $1ZAYh.xcss)({
    width: `${24 / 14}em`,
    height: `${24 / 14}em`
});
const $9f92f4a271b94157$var$buttonIconBeforeStyles = (0, $1ZAYh.xcss)({
    paddingInlineStart: 'space.100'
});
const $9f92f4a271b94157$var$buttonIconAfterStyles = (0, $1ZAYh.xcss)({
    paddingInlineEnd: 'space.100'
});
const $9f92f4a271b94157$var$splitButtonStyles = (0, $1ZAYh.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
const $9f92f4a271b94157$var$navigationSplitButtonStyles = (0, $1ZAYh.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
const $9f92f4a271b94157$var$loadingOverlayStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $9f92f4a271b94157$var$useButtonBase = ({ appearance: propAppearance = 'default', autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: // TODO: Separate Icon Button styling from button base
isIconButton = false, isCircle: isCircle = false, hasIconBefore: // TODO: Separate icon slot styling from button base
hasIconBefore = false, hasIconAfter: hasIconAfter = false, children: children, onClick: onClick, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onTouchStartCapture: onTouchStartCapture, onTouchEndCapture: onTouchEndCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, ref: ref, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy })=>{
    const localRef = (0, $eUqFw.useRef)(null);
    const splitButtonContext = (0, $j5H17.useSplitButtonContext)();
    // TODO: Use React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    const loadingLabelId = (0, $tkrFt.uid)({
        ariaLabelledBy: ariaLabelledBy
    });
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton && (0, $XHGTv.fg)('platform-component-visual-refresh') ? 'subtle' : splitButtonContext?.appearance || propAppearance;
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $hhlqA.default)(localRef, autoFocus);
    return {
        ref: (0, $1lQG9.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $XHGTv.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $9f92f4a271b94157$var$tokenizedButtonStyles : $9f92f4a271b94157$var$hardCodedButtonStyles,
            $9f92f4a271b94157$var$buttonStyles,
            appearance === 'default' && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $9f92f4a271b94157$var$defaultRefreshedStyles : $9f92f4a271b94157$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $9f92f4a271b94157$var$defaultInteractiveRefreshedStyles : $9f92f4a271b94157$var$defaultInteractiveStyles),
            appearance === 'primary' && $9f92f4a271b94157$var$primaryStyles,
            appearance === 'primary' && isInteractive && $9f92f4a271b94157$var$primaryInteractiveStyles,
            appearance === 'warning' && $9f92f4a271b94157$var$warningStyles,
            appearance === 'warning' && isInteractive && $9f92f4a271b94157$var$warningInteractiveStyles,
            appearance === 'danger' && $9f92f4a271b94157$var$dangerStyles,
            appearance === 'danger' && isInteractive && $9f92f4a271b94157$var$dangerInteractiveStyles,
            appearance === 'discovery' && $9f92f4a271b94157$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $9f92f4a271b94157$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $9f92f4a271b94157$var$subtleRefreshedStyles : $9f92f4a271b94157$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $9f92f4a271b94157$var$subtleInteractiveRefreshedStyles : $9f92f4a271b94157$var$subtleInteractiveStyles),
            appearance === 'link' && $9f92f4a271b94157$var$linkStyles,
            appearance === 'subtle-link' && $9f92f4a271b94157$var$subtleLinkStyles,
            !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? $9f92f4a271b94157$var$linkDecorationStyles : $9f92f4a271b94157$var$linkDecorationUnsetStyles,
            isSelected && ((0, $XHGTv.fg)('platform-component-visual-refresh') ? $9f92f4a271b94157$var$selectedRefreshedStyles : $9f92f4a271b94157$var$selectedStyles),
            isSelected && isSplitButton && $9f92f4a271b94157$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $9f92f4a271b94157$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $9f92f4a271b94157$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $9f92f4a271b94157$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $9f92f4a271b94157$var$selectedDiscoveryStyles,
            isDisabled && $9f92f4a271b94157$var$disabledStyles,
            isCircle && !isSplitButton && $9f92f4a271b94157$var$circleStyles,
            spacing === 'compact' && $9f92f4a271b94157$var$spacingCompactStyles,
            spacing === 'compact' && ((0, $XHGTv.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $9f92f4a271b94157$var$tokenizedSpacingCompactStyles : $9f92f4a271b94157$var$baseSpacingCompactStyles),
            spacing === 'none' && $9f92f4a271b94157$var$spacingNoneStyles,
            spacing === 'none' && (0, $XHGTv.fg)('platform.design-system-team.button-tokenised-typography-styles') && $9f92f4a271b94157$var$tokenizedSpacingNoneStyles,
            spacing !== 'none' && hasIconBefore && $9f92f4a271b94157$var$buttonIconBeforeStyles,
            spacing !== 'none' && hasIconAfter && $9f92f4a271b94157$var$buttonIconAfterStyles,
            isIconButton && $9f92f4a271b94157$var$iconButtonStyles,
            isIconButton && spacing === 'compact' && $9f92f4a271b94157$var$iconButtonCompactStyles,
            shouldFitContainer && $9f92f4a271b94157$var$fullWidthStyles,
            isLoading && $9f92f4a271b94157$var$loadingStyles,
            isSplitButton && $9f92f4a271b94157$var$splitButtonStyles,
            isNavigationSplitButton && $9f92f4a271b94157$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span",
            xcss: $9f92f4a271b94157$var$loadingOverlayStyles
        }, (0, $byjW4.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
            id: loadingLabelId
        }, (0, $a3c11500ccd013c5$export$d4c5499dc806c969))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${0, $a3c11500ccd013c5$export$d4c5499dc806c969}` : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        ...(0, $alfOm.default)(isEffectivelyDisabled, {
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        })
    };
};
var $9f92f4a271b94157$export$2e2bcd8739ae039 = $9f92f4a271b94157$var$useButtonBase;

});
parcelRegister("j5H17", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $288d53effe11d2ef$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $288d53effe11d2ef$export$47e2c6fdb142d947);

var $eUqFw = parcelRequire("eUqFw");
const $288d53effe11d2ef$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $288d53effe11d2ef$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $eUqFw.useContext)($288d53effe11d2ef$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("alfOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d09f2c06bb45703d$export$2e2bcd8739ae039);
function $d09f2c06bb45703d$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $d09f2c06bb45703d$var$tabKeyCode = 9;
function $d09f2c06bb45703d$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d09f2c06bb45703d$var$tabKeyCode) return;
    $d09f2c06bb45703d$var$abort(event);
}
function $d09f2c06bb45703d$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $d09f2c06bb45703d$var$abort,
        onMouseUpCapture: $d09f2c06bb45703d$var$abort,
        onKeyDownCapture: $d09f2c06bb45703d$var$onKey,
        onKeyUpCapture: $d09f2c06bb45703d$var$onKey,
        onTouchStartCapture: $d09f2c06bb45703d$var$abort,
        onTouchEndCapture: $d09f2c06bb45703d$var$abort,
        onPointerDownCapture: $d09f2c06bb45703d$var$abort,
        onPointerUpCapture: $d09f2c06bb45703d$var$abort,
        onClickCapture: $d09f2c06bb45703d$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $d09f2c06bb45703d$var$abort
    } : events;
}

});

const $a3c11500ccd013c5$export$d4c5499dc806c969 = ', Loading';

parcelRegister("byjW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $346199fe426f0bc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");
function $346199fe426f0bc4$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        case 'none':
            return 'xsmall';
        default:
            return 'medium';
    }
}
function $346199fe426f0bc4$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $346199fe426f0bc4$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: $346199fe426f0bc4$var$getIconSpacing(spacing),
        appearance: $346199fe426f0bc4$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});




parcelRegister("dxopF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce92a55e318ecfb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $9ce92a55e318ecfb$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        appear: true
    }, props.children);
};
var $9ce92a55e318ecfb$export$2e2bcd8739ae039 = $9ce92a55e318ecfb$var$ModalTransition;

});

parcelRegister("5OdZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a459d0ad400a9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");
function $b9a459d0ad400a9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b9a459d0ad400a9b$var$commonLinkStyles = (0, $1ZAYh.xcss)({
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:hover': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $b9a459d0ad400a9b$var$defaultAppearanceStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'underline',
    color: 'color.link',
    ':hover': {
        color: 'color.link',
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $b9a459d0ad400a9b$var$subtleAppearanceStyles = (0, $1ZAYh.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtle',
    ':hover': {
        color: 'color.text.subtle',
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.text'
    }
});
// Prevent the icon from wrapping onto a new line by itself
// Using this technique involving a zero-width space: https://snook.ca/archives/html_and_css/icon-wrap-after-text
const $b9a459d0ad400a9b$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline',
    whiteSpace: 'nowrap'
});
const $b9a459d0ad400a9b$var$iconStyles = {
    name: "11149m5",
    styles: "width:1em;height:1em;margin-inline-start:.3em"
};
const $b9a459d0ad400a9b$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4kMup.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            $b9a459d0ad400a9b$var$commonLinkStyles,
            appearance === 'default' && $b9a459d0ad400a9b$var$defaultAppearanceStyles,
            appearance === 'subtle' && $b9a459d0ad400a9b$var$subtleAppearanceStyles
        ],
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        as: "span",
        xcss: $b9a459d0ad400a9b$var$iconWrapperStyles,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        css: $b9a459d0ad400a9b$var$iconStyles,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $b9a459d0ad400a9b$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)($b9a459d0ad400a9b$var$LinkWithoutRef);
var $b9a459d0ad400a9b$export$2e2bcd8739ae039 = $b9a459d0ad400a9b$var$Link;

});
parcelRegister("4kMup", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e97c7fa17b82aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");

var $8ynlC = parcelRequire("8ynlC");

var $lUFyV = parcelRequire("lUFyV");

var $9ENjd = parcelRequire("9ENjd");

var $5Q9wj = parcelRequire("5Q9wj");

var $jsCXU = parcelRequire("jsCXU");

var $lkPEe = parcelRequire("lkPEe");

var $9seLS = parcelRequire("9seLS");

var $1ZAYh = parcelRequire("1ZAYh");
function $78e97c7fa17b82aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $78e97c7fa17b82aa$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $9seLS.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $9seLS.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $9seLS.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $78e97c7fa17b82aa$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $78e97c7fa17b82aa$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $78e97c7fa17b82aa$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $78e97c7fa17b82aa$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $78e97c7fa17b82aa$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $5Q9wj.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    // TODO: Use React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    const opensNewWindowLabelId = (0, $tkrFt.uid)({
        ariaLabelledBy: ariaLabelledBy
    });
    const onClick = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    const RouterLink = (0, $9ENjd.default)();
    const isExternal = typeof href === 'string' && $78e97c7fa17b82aa$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $78e97c7fa17b82aa$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $8ynlC.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $78e97c7fa17b82aa$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $78e97c7fa17b82aa$var$baseStyles,
            $78e97c7fa17b82aa$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $9seLS.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $9seLS.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $9seLS.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $9seLS.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $9seLS.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $9seLS.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $9seLS.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $9seLS.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $78e97c7fa17b82aa$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * @internal Still under development. Do not use.
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * This component is mostly used by other design system components, such as the [link component](/components/link/usage).
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $78e97c7fa17b82aa$var$Anchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)($78e97c7fa17b82aa$var$AnchorNoRef);
var $78e97c7fa17b82aa$export$2e2bcd8739ae039 = $78e97c7fa17b82aa$var$Anchor;

});
parcelRegister("9ENjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d596fc4650924ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1SoQa = parcelRequire("1SoQa");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $6d596fc4650924ea$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $eUqFw.useContext)((0, $1SoQa.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
};
var $6d596fc4650924ea$export$2e2bcd8739ae039 = $6d596fc4650924ea$var$useRouterLink;

});
parcelRegister("1SoQa", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $a7efb4f013bfd7bf$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $a7efb4f013bfd7bf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $a7efb4f013bfd7bf$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $eUqFw.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $a7efb4f013bfd7bf$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7efb4f013bfd7bf$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a7efb4f013bfd7bf$export$2e2bcd8739ae039 = $a7efb4f013bfd7bf$var$RouterLinkProvider;

});




parcelRegister("ho1Ek", function(module, exports) {

$parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$cbfb0f5b2869b17b);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$c103b605cd368aed);
$parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$fa34f417972d6341);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$bcd94a6a792e7f96);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $9bfcd1a3e554435a$export$b6744d31294864fd);
$parcel$export(module.exports, "DIMENSIONS", () => $9bfcd1a3e554435a$export$d67ac355184b7646);
$parcel$export(module.exports, "LEFT_PANEL", () => $9bfcd1a3e554435a$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $9bfcd1a3e554435a$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $9bfcd1a3e554435a$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $9bfcd1a3e554435a$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $9bfcd1a3e554435a$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$be83e7118304b28e);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$539e68c09584883a);
$parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$b92df8810d2fcd01);
$parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$c3e41153b9288bcf);
$parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$c4d6152f86ea28f6);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$991d5285ad765a3d);
$parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", () => $9bfcd1a3e554435a$export$6949d4f32b161684);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $9bfcd1a3e554435a$export$3749e1104328fde4);
$parcel$export(module.exports, "FLYOUT_DELAY", () => $9bfcd1a3e554435a$export$1074d925b0b82be5);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $9bfcd1a3e554435a$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $9bfcd1a3e554435a$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $9bfcd1a3e554435a$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", () => $9bfcd1a3e554435a$export$70c702a8c5895f03);
$parcel$export(module.exports, "GRAB_AREA_SELECTOR", () => $9bfcd1a3e554435a$export$48a43f91e4becf4e);
$parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", () => $9bfcd1a3e554435a$export$dac2fb31a9f6844d);
$parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", () => $9bfcd1a3e554435a$export$9ecd22db14e6c70e);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $9bfcd1a3e554435a$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $9bfcd1a3e554435a$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $9bfcd1a3e554435a$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $9bfcd1a3e554435a$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $9bfcd1a3e554435a$export$b44ab66843c05a69);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $9bfcd1a3e554435a$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $9bfcd1a3e554435a$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $9bfcd1a3e554435a$export$d2fa14f05b61e66);
// dimension vars
const $9bfcd1a3e554435a$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $9bfcd1a3e554435a$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $9bfcd1a3e554435a$export$c103b605cd368aed = 'rightSidebarWidth';
const $9bfcd1a3e554435a$export$fa34f417972d6341 = 'rightPanelWidth';
const $9bfcd1a3e554435a$export$3a6a779d9181047c = 'topNavigationHeight';
const $9bfcd1a3e554435a$export$bcd94a6a792e7f96 = 'bannerHeight';
const $9bfcd1a3e554435a$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $9bfcd1a3e554435a$export$d67ac355184b7646 = [
    $9bfcd1a3e554435a$export$cbfb0f5b2869b17b,
    $9bfcd1a3e554435a$export$fa34f417972d6341,
    $9bfcd1a3e554435a$export$bcd94a6a792e7f96,
    $9bfcd1a3e554435a$export$3a6a779d9181047c,
    $9bfcd1a3e554435a$export$a30f2e00489a8957,
    $9bfcd1a3e554435a$export$c103b605cd368aed
];
const $9bfcd1a3e554435a$export$344062f7cfc9528e = 'left-panel';
const $9bfcd1a3e554435a$export$c7139cc2d6110b5f = 'right-panel';
const $9bfcd1a3e554435a$export$238d30785c4bca84 = 'banner';
const $9bfcd1a3e554435a$export$bec6dca2e63de4ae = 'top-navigation';
const $9bfcd1a3e554435a$export$d1213e82613ff4df = 'content';
const $9bfcd1a3e554435a$export$2d8180803f50fc5 = 'main';
const $9bfcd1a3e554435a$export$50ea883ba6f28ff5 = 'left-sidebar';
const $9bfcd1a3e554435a$export$7bf43119a6b49ddb = 'right-sidebar';
const $9bfcd1a3e554435a$export$be83e7118304b28e = 56;
const $9bfcd1a3e554435a$export$4a98ee0bd1ae362 = 56;
const $9bfcd1a3e554435a$export$539e68c09584883a = 240;
const $9bfcd1a3e554435a$export$b92df8810d2fcd01 = 280;
const $9bfcd1a3e554435a$export$c3e41153b9288bcf = 368;
const $9bfcd1a3e554435a$export$c4d6152f86ea28f6 = 368;
const $9bfcd1a3e554435a$export$46acf8758e9e2636 = 20;
const $9bfcd1a3e554435a$export$70740f5ad8360a78 = 16;
const $9bfcd1a3e554435a$export$f562af313cda0684 = 80;
const $9bfcd1a3e554435a$export$991d5285ad765a3d = 240;
const $9bfcd1a3e554435a$export$6949d4f32b161684 = 200;
const $9bfcd1a3e554435a$export$d6e7e8af042815bb = 350;
const $9bfcd1a3e554435a$export$3749e1104328fde4 = 300;
const $9bfcd1a3e554435a$export$1074d925b0b82be5 = 200;
const $9bfcd1a3e554435a$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
const $9bfcd1a3e554435a$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $9bfcd1a3e554435a$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $9bfcd1a3e554435a$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $9bfcd1a3e554435a$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
const $9bfcd1a3e554435a$export$70c702a8c5895f03 = 'data-grab-area-line';
const $9bfcd1a3e554435a$export$48a43f91e4becf4e = 'data-grab-area';
const $9bfcd1a3e554435a$export$dac2fb31a9f6844d = 'data-resize-button';
const $9bfcd1a3e554435a$export$9ecd22db14e6c70e = 'data-resize-control';
const $9bfcd1a3e554435a$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $9bfcd1a3e554435a$export$206a08f7f8beb554 = 'Skip to:';
const $9bfcd1a3e554435a$export$659ee746b31b360d = 'data-layout-container';
const $9bfcd1a3e554435a$export$f963aecf2d4465bd = `var(--${$9bfcd1a3e554435a$export$cbfb0f5b2869b17b}, 0px)`;
const $9bfcd1a3e554435a$export$750459958906793 = `var(--${$9bfcd1a3e554435a$export$fa34f417972d6341}, 0px)`;
const $9bfcd1a3e554435a$export$f897e1ed9f8ed251 = `var(--${$9bfcd1a3e554435a$export$a30f2e00489a8957}, 0px)`;
const $9bfcd1a3e554435a$export$b44ab66843c05a69 = `var(--${$9bfcd1a3e554435a$export$c103b605cd368aed}, 0px)`;
const $9bfcd1a3e554435a$export$aeff86a16f13529 = `var(--${$9bfcd1a3e554435a$export$3a6a779d9181047c}, 0px)`;
const $9bfcd1a3e554435a$export$ed7cc0d417ee89e = `var(--${$9bfcd1a3e554435a$export$bcd94a6a792e7f96}, 0px)`;
const $9bfcd1a3e554435a$export$d2fa14f05b61e66 = `var(--${$9bfcd1a3e554435a$export$b6744d31294864fd}, ${$9bfcd1a3e554435a$export$991d5285ad765a3d}px)`;

});

parcelRegister("ce8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b13c4031a112ab9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bVhyO = parcelRequire("bVhyO");

var $5Y0DT = parcelRequire("5Y0DT");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6b13c4031a112ab9$var$svgStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $5Y0DT.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ const $6b13c4031a112ab9$var$SVG = /*#__PURE__*/ (0, $eUqFw.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $bVhyO.getBackground)()
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $6b13c4031a112ab9$var$svgStyles,
            (0, $5Y0DT.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $6b13c4031a112ab9$export$2e2bcd8739ae039 = $6b13c4031a112ab9$var$SVG;

});

parcelRegister("iJlfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $448a91e99b3083ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFtVs = parcelRequire("jFtVs");

var $bFzGY = parcelRequire("bFzGY");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $6AJyI = parcelRequire("6AJyI");

var $eri7S = parcelRequire("eri7S");

var $6PZxV = parcelRequire("6PZxV");

var $8DZtu = parcelRequire("8DZtu");

var $lcJeR = parcelRequire("lcJeR");

var $6ecEX = parcelRequire("6ecEX");
const $448a91e99b3083ec$var$packageName = "platform-pkg";
const $448a91e99b3083ec$var$packageVersion = "0.0.0-use.local";
const $448a91e99b3083ec$var$getStyles = (css, { size: size, radius: radius, appearance: appearance, borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-surface-overlay, ${0, $PdmhA.N0})`, stackIndex: stackIndex, isInteractive: isInteractive, isDisabled: isDisabled })=>//eslint-disable-next-line @repo/internal/react/no-css-string-literals
    css`
		height: ${size}px;
		width: ${size}px;
		align-items: stretch;
		background-color: ${borderColor};
		border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
		box-sizing: content-box;
		cursor: inherit;
		display: flex;
		flex-direction: column;
		justify-content: center;
		outline: none;
		overflow: hidden;
		position: static;
		transform: translateZ(0);
		transition:
			transform 200ms,
			opacity 200ms;
		box-shadow: 0 0 0 ${0, $eri7S.BORDER_WIDTH}px ${borderColor};
		border: none;
		margin: ${"var(--ds-space-025, 2px)"};
		padding: ${"var(--ds-space-0, 0px)"};

		&::-moz-focus-inner {
			border: 0;
			margin: ${"var(--ds-space-0, 0px)"};
			padding: ${"var(--ds-space-0, 0px)"};
		}

		&::after {
			background-color: transparent;
			inset: 0px;

			/* Added border-radius style to fix hover issue in safari */
			border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
			content: ' ';
			opacity: 0;
			pointer-events: none;
			position: absolute;
			transition: opacity 200ms;
			width: 100%;
		}

		${stackIndex && `position: relative;`}

		${isInteractive && `
      cursor: pointer;

      :focus {
        outline: none;
        box-shadow: 0 0 0 ${0, $eri7S.BORDER_WIDTH}px ${`var(--ds-border-focused, ${0, $PdmhA.B300})`}
      }

      :hover {
        &::after {
          background-color: ${`var(--ds-interaction-hovered, ${0, $PdmhA.N70A})`};
          opacity: 1;
        }
      }

      :active {
        &::after {
          background-color: ${`var(--ds-interaction-pressed, ${0, $PdmhA.N70A})`};
          opacity: 1;
        }
      }

      :active {
        transform: scale(${0, $eri7S.ACTIVE_SCALE_FACTOR});
      }

      @media screen and (forced-colors: active) {
        &:focus-visible {
          outline: 1px solid
        }
      }
    `}

    ${isDisabled && `
        cursor: not-allowed;

        &::after {
          opacity: ${"var(--ds-opacity-disabled, 0.7)"};
          pointer-events: none;
          background-color: ${`var(--ds-surface, ${0, $PdmhA.N0})`};
        }
      `}
	`;
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $448a91e99b3083ec$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div' }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const context = (0, $6PZxV.useAvatarContext)();
    const size = sizeProp ?? context?.size ?? 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $eUqFw.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $eUqFw.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $eUqFw.useRef)(analyticsContext);
    const uuid = (0, $jFtVs.useUIDSeed)()('avatar');
    (0, $eUqFw.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $448a91e99b3083ec$var$packageName,
                packageVersion: $448a91e99b3083ec$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $448a91e99b3083ec$var$packageName,
            packageVersion: $448a91e99b3083ec$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--inner`
        } : {
            testId: `${testId}--inner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClickHandler) : {
                onClick: onClick
            }
        };
    };
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? `${uuid}-label` : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            className: $448a91e99b3083ec$var$getStyles(css, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                radius: (0, $eri7S.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(isInteractive || children) && {
                'aria-label': label || defaultLabel
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6AJyI.default), {
                // Only pass in the name if an image is provded and the
                // container is not being used as an `img` role
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    }), isPresence && /*#__PURE__*/ (0, $byn9U.jsx)((0, $8DZtu.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ (0, $byn9U.jsx)((0, $lcJeR.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId && `${testId}--label`,
        id: `${uuid}-label`,
        hidden: true
    }, defaultLabel) : undefined);
});
$448a91e99b3083ec$var$Avatar.displayName = 'Avatar';
var $448a91e99b3083ec$export$2e2bcd8739ae039 = $448a91e99b3083ec$var$Avatar;

});
parcelRegister("6AJyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd400e55ad422969$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5wwfG = parcelRequire("5wwfG");

var $1rDQJ = parcelRequire("1rDQJ");

var $cI9iM = parcelRequire("cI9iM");

var $14lY4 = parcelRequire("14lY4");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");
function $fd400e55ad422969$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fd400e55ad422969$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`
});
const $fd400e55ad422969$var$avatarDefaultIconVisualRefreshStyles = {
    name: "dg8dij",
    styles: "display:block;width:100%;height:100%;background-color:var(--ds-background-accent-gray-subtler, #DCDFE4)"
};
const $fd400e55ad422969$var$nestedAvatarStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size}px`
            }
        })
    };
}, {});
const $fd400e55ad422969$var$avatarImageStyles = {
    name: "1gr7gcv",
    styles: "display:flex;width:100%;height:100%;flex:1 1 100%"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $fd400e55ad422969$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
    const borderRadius = appearance === 'circle' ? '50%' : `${(0, $eri7S.AVATAR_RADIUS)[size]}px`;
    const isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $eUqFw.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $XHGTv.fg)('platform-component-visual-refresh') ? $fd400e55ad422969$var$avatarDefaultIconVisualRefreshStyles : $fd400e55ad422969$var$avatarDefaultIconStyles,
            $fd400e55ad422969$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? (0, $XHGTv.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wwfG))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && `${testId}--person`,
        spacing: "spacious"
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cI9iM))), {
        label: alt,
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
        secondaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`,
        testId: testId && `${testId}--person`,
        "aria-hidden": isHidden
    }) : (0, $XHGTv.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1rDQJ))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && `${testId}--ship`,
        spacing: "spacious"
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
        label: alt,
        primaryColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
        secondaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`,
        testId: testId && `${testId}--ship`,
        "aria-hidden": isHidden
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $fd400e55ad422969$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": isHidden
    });
};
var $fd400e55ad422969$export$2e2bcd8739ae039 = $fd400e55ad422969$var$AvatarImage;

});
parcelRegister("eri7S", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $87ac36054c2add67$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $87ac36054c2add67$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $87ac36054c2add67$export$e2bd4c1faded7921);
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", () => $87ac36054c2add67$export$89a980dfdf90df51);
$parcel$export(module.exports, "CSS_VAR_AVATAR_BGCOLOR", () => $87ac36054c2add67$export$3c061e31594ebabe);
$parcel$export(module.exports, "ICON_SIZES", () => $87ac36054c2add67$export$fdc820179f1f9be4);
$parcel$export(module.exports, "ICON_OFFSET", () => $87ac36054c2add67$export$382610e783aa2ae8);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $87ac36054c2add67$export$9a270941bcff7e77 = {
    xsmall: (0, $lcnyw.gridSize)() * 2,
    small: (0, $lcnyw.gridSize)() * 3,
    medium: (0, $lcnyw.gridSize)() * 4,
    large: (0, $lcnyw.gridSize)() * 5,
    xlarge: (0, $lcnyw.gridSize)() * 12,
    xxlarge: (0, $lcnyw.gridSize)() * 16
};
const $87ac36054c2add67$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $87ac36054c2add67$export$e2bd4c1faded7921 = 2;
const $87ac36054c2add67$export$89a980dfdf90df51 = 0.9;
const $87ac36054c2add67$export$3c061e31594ebabe = '--avatar-background-color';
const $87ac36054c2add67$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $87ac36054c2add67$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});


parcelRegister("6PZxV", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", () => $13bd4a9d2b547d84$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $13bd4a9d2b547d84$export$b50b87a1c4086b23);

var $eUqFw = parcelRequire("eUqFw");
const $13bd4a9d2b547d84$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $13bd4a9d2b547d84$export$b50b87a1c4086b23 = ()=>(0, $eUqFw.useContext)($13bd4a9d2b547d84$export$a20dad690e1279e2);

});

parcelRegister("8DZtu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c823831f9e985b0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PresenceWrapper", () => $6c823831f9e985b0$export$972c5e90200fa0ef);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");

var $j53Tc = parcelRequire("j53Tc");
const $6c823831f9e985b0$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
const $6c823831f9e985b0$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-icon-discovery, ${(0, $PdmhA.P300)})`,
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
const $6c823831f9e985b0$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N40)})`,
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
const $6c823831f9e985b0$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $6c823831f9e985b0$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $6c823831f9e985b0$var$BusyIndicator;
        case 'focus':
            return $6c823831f9e985b0$var$FocusIndicator;
        case 'offline':
            return $6c823831f9e985b0$var$OfflineIndicator;
        case 'online':
            return $6c823831f9e985b0$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $6c823831f9e985b0$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j53Tc.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $6c823831f9e985b0$var$getPresence(presence)) : children);
var $6c823831f9e985b0$export$2e2bcd8739ae039 = $6c823831f9e985b0$var$AvatarPresence;
const $6c823831f9e985b0$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    const position = appearance === 'square' ? -4 : (0, $eri7S.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            bottom: `${position}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${(0, $eri7S.ICON_SIZES)[size]}px`,
            right: `${position}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $eri7S.ICON_SIZES)[size]}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c823831f9e985b0$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("j53Tc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d8c16c039483b9f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");
function $8d8c16c039483b9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d8c16c039483b9f$var$iconWrapperStyles = {
    name: "1kwqznv",
    styles: "display:flex;box-sizing:border-box;width:100%;height:100%;align-items:center;align-content:center;border-radius:var(--ds-border-radius-circle, 50%);overflow:hidden"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $8d8c16c039483b9f$var$IconWrapper = ({ bgColor: bgColor = `var(--ds-surface-overlay, ${0, $PdmhA.N0})`, children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d8c16c039483b9f$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: `${(0, $eri7S.BORDER_WIDTH)}px solid ${bgColor}`,
            backgroundColor: bgColor
        }
    }, children);
var $8d8c16c039483b9f$export$2e2bcd8739ae039 = $8d8c16c039483b9f$var$IconWrapper;

});


parcelRegister("lcJeR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09a193fba3c21822$export$2e2bcd8739ae039);
$parcel$export(module.exports, "StatusWrapper", () => $09a193fba3c21822$export$8045894f255f9726);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $eri7S = parcelRequire("eri7S");

var $j53Tc = parcelRequire("j53Tc");
const $09a193fba3c21822$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-success, ${(0, $PdmhA.G400)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
const $09a193fba3c21822$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
const $09a193fba3c21822$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
    fill: `var(--ds-text-subtlest, ${(0, $PdmhA.N40)})`,
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
    fill: `var(--ds-surface-overlay, ${(0, $PdmhA.N500)})`,
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $09a193fba3c21822$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $09a193fba3c21822$var$ApprovedIndicator;
        case 'declined':
            return $09a193fba3c21822$var$DeclinedIndicator;
        case 'locked':
            return $09a193fba3c21822$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $09a193fba3c21822$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j53Tc.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $09a193fba3c21822$var$getStatus(status)) : children);
var $09a193fba3c21822$export$2e2bcd8739ae039 = $09a193fba3c21822$var$AvatarStatus;
const $09a193fba3c21822$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    const position = appearance === 'square' ? 0 : (0, $eri7S.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${(0, $eri7S.ICON_SIZES)[size]}px`,
            right: `${position}px`,
            top: `${position}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $eri7S.ICON_SIZES)[size]}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09a193fba3c21822$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("6ecEX", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", () => $76f3d55517805afd$export$60113ebe1cf0ecf);
$parcel$export(module.exports, "getButtonProps", () => $76f3d55517805afd$export$cca6f1bef43616d3);
$parcel$export(module.exports, "getCustomElement", () => $76f3d55517805afd$export$83ee468102cdf04c);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
const $76f3d55517805afd$export$60113ebe1cf0ecf = (href, target)=>({
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    });
const $76f3d55517805afd$export$cca6f1bef43616d3 = (onClick)=>({
        type: 'button',
        onClick: onClick
    });
const $76f3d55517805afd$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});


parcelRegister("8BKky", function(module, exports) {

$parcel$export(module.exports, "default", () => $073dff249b778dca$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview */ /**
                                                                                                                                   * @jsxRuntime classic
                                                                                                                                   * @jsx jsx
                                                                                                                                   */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $4lTFP = parcelRequire("4lTFP");

var $5wpwq = parcelRequire("5wpwq");
function $073dff249b778dca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $073dff249b778dca$var$gridSize = (0, $lcnyw.gridSize)();
const $073dff249b778dca$var$itemHeadingTopMargin = $073dff249b778dca$var$gridSize * 2.5;
const $073dff249b778dca$var$itemHeadingBottomMargin = $073dff249b778dca$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $073dff249b778dca$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $073dff249b778dca$var$skeletonHeadingHeight = $073dff249b778dca$var$gridSize;
const $073dff249b778dca$var$skeletonHeadingMarginOffset = 3;
const $073dff249b778dca$var$skeletonHeadingTopMargin = $073dff249b778dca$var$itemHeadingTopMargin + ($073dff249b778dca$var$itemHeadingContentHeight - $073dff249b778dca$var$skeletonHeadingHeight) - $073dff249b778dca$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $073dff249b778dca$var$skeletonHeadingBottomMargin = $073dff249b778dca$var$itemHeadingBottomMargin + $073dff249b778dca$var$skeletonHeadingMarginOffset;
const $073dff249b778dca$var$sectionPaddingTopBottom = $073dff249b778dca$var$gridSize * 0.75;
const $073dff249b778dca$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
const $073dff249b778dca$var$sectionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $073dff249b778dca$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $073dff249b778dca$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $073dff249b778dca$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $073dff249b778dca$var$itemHeadingTopMargin - $073dff249b778dca$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $073dff249b778dca$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $073dff249b778dca$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $073dff249b778dca$var$skeletonHeadingTopMargin - $073dff249b778dca$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
const $073dff249b778dca$var$scrollableStyles = {
    name: "qji62u",
    styles: "flex-shrink:1;overflow:auto"
};
const $073dff249b778dca$var$unscrollableStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $073dff249b778dca$var$thickSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockStart: `2px solid var(${$073dff249b778dca$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $PdmhA.N30A)})`})`
});
const $073dff249b778dca$var$thinSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockStart: `1px solid var(${$073dff249b778dca$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $PdmhA.N30A)})`})`
});
const $073dff249b778dca$var$noSeparatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $073dff249b778dca$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, overrides: overrides, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    const content = isList ? /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $eUqFw.Children).map((0, $eUqFw.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $byn9U.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wpwq.default), {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: UNSAFE_headingOverrides,
        testId: testId && `${testId}--heading`,
        "aria-hidden": true
    }, title), content) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, content);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        css: [
            $073dff249b778dca$var$sectionStyles,
            isScrollable ? $073dff249b778dca$var$scrollableStyles : $073dff249b778dca$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.fg)('platform.design-system-team.section-1px-seperator-borders') ? $073dff249b778dca$var$thinSeparatorStyles : $073dff249b778dca$var$thickSeparatorStyles : $073dff249b778dca$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $073dff249b778dca$export$2e2bcd8739ae039 = $073dff249b778dca$var$Section;

});
parcelRegister("5wpwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4e8b314a8e2773$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
function $2b4e8b314a8e2773$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b4e8b314a8e2773$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $2b4e8b314a8e2773$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $2b4e8b314a8e2773$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
const $2b4e8b314a8e2773$var$baseHeadingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $2b4e8b314a8e2773$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $2b4e8b314a8e2773$var$itemHeadingContentHeight / $2b4e8b314a8e2773$var$itemHeadingFontSize
});
const $2b4e8b314a8e2773$var$tokenizedHeadingStyles = {
    name: "1xm9io",
    styles: "font:var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2b4e8b314a8e2773$var$HeadingItem = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, cssFn: cssFn = (0, $5Q9wj.default), // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $byn9U.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $2b4e8b314a8e2773$var$headingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.fg)('platform.design-system-team.menu-tokenised-typography-styles') ? $2b4e8b314a8e2773$var$tokenizedHeadingStyles : $2b4e8b314a8e2773$var$baseHeadingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    }, children);
});
var $2b4e8b314a8e2773$export$2e2bcd8739ae039 = $2b4e8b314a8e2773$var$HeadingItem;

});


parcelRegister("bULPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b0e2e9c8007bba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $1RaV8 = parcelRequire("1RaV8");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $39b0e2e9c8007bba$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, cssFn: cssFn = (0, $5Q9wj.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    className: UNSAFE_className, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1RaV8.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("button", {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children));
}));
var $39b0e2e9c8007bba$export$2e2bcd8739ae039 = $39b0e2e9c8007bba$var$ButtonItem;

});
parcelRegister("1RaV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c2d88c5fd62aedd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $51sCz = parcelRequire("51sCz");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8jcoK = parcelRequire("8jcoK");
function $5c2d88c5fd62aedd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5c2d88c5fd62aedd$var$defaultRender = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)(Component, props);
const $5c2d88c5fd62aedd$var$beforeAfterElementStyles = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $5c2d88c5fd62aedd$var$contentStyles = (0, $1ZAYh.xcss)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
const $5c2d88c5fd62aedd$var$baseContentStyles = (0, $1ZAYh.xcss)({
    lineHeight: '16px'
});
const $5c2d88c5fd62aedd$var$truncateStyles = {
    name: "hdknak",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $5c2d88c5fd62aedd$var$titleStyles = {
    name: "183yev2",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $5c2d88c5fd62aedd$var$wordBreakStyles = {
    name: "1sdjnkx",
    styles: "word-break:break-word"
};
const $5c2d88c5fd62aedd$var$descriptionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
});
const $5c2d88c5fd62aedd$var$baseDescriptionStyles = {
    name: "11h50ev",
    styles: "font-size:12px;margin-block-start:var(--ds-space-050, 4px)"
};
const $5c2d88c5fd62aedd$var$tokenizedDescriptionStyles = {
    name: "z7wamg",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $5c2d88c5fd62aedd$var$disabledDescriptionStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
});
const $5c2d88c5fd62aedd$var$positionRelativeStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $5c2d88c5fd62aedd$var$primitiveStyles = {
    name: "vfenhj",
    styles: "display:flex;box-sizing:border-box;width:100%;min-height:40px;margin:var(--ds-space-0, 0px);align-items:center;border:0;outline:0;text-decoration:none;user-select:none;&::-moz-focus-inner{border:0;}&:hover{text-decoration:none;}"
};
const $5c2d88c5fd62aedd$var$primitiveBaseStyles = {
    name: "mmdt3g",
    styles: "font-size:14px"
};
const $5c2d88c5fd62aedd$var$spacingMapStyles = {
    cozy: {
        name: "1x13z0k",
        styles: "padding-block:var(--ds-space-100, 8px);padding-inline:var(--ds-space-200, 16px)"
    },
    compact: {
        name: "1xdhs5i",
        styles: "min-height:32px;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-150, 12px)"
    }
};
const $5c2d88c5fd62aedd$var$interactiveStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $5c2d88c5fd62aedd$var$unselectedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N20)})`,
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.N30)})`,
        boxShadow: 'none',
        color: 'currentColor'
    }
});
const $5c2d88c5fd62aedd$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
    }
});
const $5c2d88c5fd62aedd$var$selectedBorderStyles = {
    name: "1dgy7ry",
    styles: "&::before{width:2px;position:absolute;background:var(--ds-border-selected, transparent);content:\"\";inset-block-end:0;inset-block-start:0;inset-inline-start:0;}"
};
const $5c2d88c5fd62aedd$var$selectedNotchStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: `0 ${"var(--ds-border-radius, 4px)"} ${"var(--ds-border-radius, 4px)"} 0`,
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
const $5c2d88c5fd62aedd$var$selectedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.N20)})`,
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N20)})`,
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.N30)})`,
        color: "var(--ds-text-selected, currentColor)"
    }
});
const $5c2d88c5fd62aedd$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $5c2d88c5fd62aedd$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, testId: testId })=>{
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const spacing = (0, $eUqFw.useContext)((0, $8jcoK.SpacingContext));
    const selectionStyle = (0, $eUqFw.useContext)((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const renderTitle = overrides && overrides.Title && overrides.Title.render || $5c2d88c5fd62aedd$var$defaultRender;
    const UNSAFE_className = UNSAFE_externalClassName;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: cn, cx: cx })=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $5c2d88c5fd62aedd$var$positionRelativeStyles,
                    $5c2d88c5fd62aedd$var$primitiveStyles,
                    (0, $XHGTv.fg)('platform.design-system-team.menu-tokenised-typography-styles') ? undefined : $5c2d88c5fd62aedd$var$primitiveBaseStyles,
                    $5c2d88c5fd62aedd$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $5c2d88c5fd62aedd$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $5c2d88c5fd62aedd$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $5c2d88c5fd62aedd$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $5c2d88c5fd62aedd$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $5c2d88c5fd62aedd$var$disabledStyles : $5c2d88c5fd62aedd$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $5c2d88c5fd62aedd$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-elem-before": true,
                css: $5c2d88c5fd62aedd$var$beforeAfterElementStyles,
                "data-testid": testId && `${testId}--icon-before`
            }, iconBefore), title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $XHGTv.fg)('platform.design-system-team.menu-tokenised-typography-styles') ? $5c2d88c5fd62aedd$var$contentStyles : [
                    $5c2d88c5fd62aedd$var$contentStyles,
                    $5c2d88c5fd62aedd$var$baseContentStyles
                ]
            }, renderTitle('span', {
                children: title,
                className: cn((0, $XHGTv.fg)('platform.design-system-team.menu-tokenised-typography-styles') ? $5c2d88c5fd62aedd$var$titleStyles : undefined, shouldTitleWrap ? $5c2d88c5fd62aedd$var$wordBreakStyles : $5c2d88c5fd62aedd$var$truncateStyles),
                'data-item-title': true
            }), description && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-description": true,
                css: [
                    $5c2d88c5fd62aedd$var$descriptionStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    (0, $XHGTv.fg)('platform.design-system-team.menu-tokenised-typography-styles') ? $5c2d88c5fd62aedd$var$tokenizedDescriptionStyles : $5c2d88c5fd62aedd$var$baseDescriptionStyles,
                    isDisabled && $5c2d88c5fd62aedd$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $5c2d88c5fd62aedd$var$wordBreakStyles : $5c2d88c5fd62aedd$var$truncateStyles
                ]
            }, description)), iconAfter && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                "data-item-elem-after": true,
                css: $5c2d88c5fd62aedd$var$beforeAfterElementStyles,
                "data-testid": testId && `${testId}--icon-after`
            }, iconAfter))
        }));
    });
};
var $5c2d88c5fd62aedd$export$2e2bcd8739ae039 = $5c2d88c5fd62aedd$var$MenuItemPrimitive;

});
parcelRegister("8jcoK", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", () => $e3910e7f4549d599$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $e3910e7f4549d599$export$9ca534b70725964d);

var $eUqFw = parcelRequire("eUqFw");
const $e3910e7f4549d599$export$443076ec7ebce042 = /*#__PURE__*/ (0, $eUqFw.createContext)('cozy');
const $e3910e7f4549d599$export$9ca534b70725964d = /*#__PURE__*/ (0, $eUqFw.createContext)('border');

});



parcelRegister("e7PSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa38d104f225a0f2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $1RaV8 = parcelRequire("1RaV8");
const $aa38d104f225a0f2$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $aa38d104f225a0f2$var$CustomItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ component: Component, cssFn: cssFn = (0, $5Q9wj.default), isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    if (!Component) return null;
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1RaV8.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $aa38d104f225a0f2$var$preventEvent
            },
            onMouseDown: isDisabled ? $aa38d104f225a0f2$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $aa38d104f225a0f2$var$preventEvent : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }, children));
}));
var $aa38d104f225a0f2$export$2e2bcd8739ae039 = $aa38d104f225a0f2$var$CustomItem;

});

parcelRegister("bo4OB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4d17ce40ea0b32$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9ENjd = parcelRequire("9ENjd");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $XHGTv = parcelRequire("XHGTv");

var $1RaV8 = parcelRequire("1RaV8");
const $fa4d17ce40ea0b32$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $fa4d17ce40ea0b32$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $fa4d17ce40ea0b32$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $fa4d17ce40ea0b32$var$LinkItem = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, href: href, cssFn: cssFn = (0, $5Q9wj.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, // Although this isn't defined on props it is available because we've used
    // Spread props below and on the jsx element. To forcibly block usage I've
    // picked it out and supressed the expected type error.
    // @ts-expect-error
    className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $9ENjd.default)();
    if (!children) return null;
    const isExternal = typeof href === 'string' && $fa4d17ce40ea0b32$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $fa4d17ce40ea0b32$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased;
    const Component = isRouterLink && (0, $XHGTv.fg)('platform.wanjel.use-router-links-for-the-linkitem-component') ? RouterLink : 'a';
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1RaV8.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // @ts-expect-error
            href: isDisabled ? undefined : href,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $fa4d17ce40ea0b32$var$preventEvent
            },
            onMouseDown: isDisabled ? $fa4d17ce40ea0b32$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $fa4d17ce40ea0b32$var$preventEvent : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }, children));
}));
var $fa4d17ce40ea0b32$export$2e2bcd8739ae039 = $fa4d17ce40ea0b32$var$LinkItem;

});

parcelRegister("8PFhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b5e9dfb8fd0d85$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8jcoK = parcelRequire("8jcoK");
function $44b5e9dfb8fd0d85$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44b5e9dfb8fd0d85$var$baseStyles = {
    name: "1u0qf12",
    styles: "display:flex;position:static;flex-direction:column;overflow:auto"
};
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $44b5e9dfb8fd0d85$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8jcoK.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $44b5e9dfb8fd0d85$var$baseStyles,
        "data-testid": testId,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    })));
var $44b5e9dfb8fd0d85$export$2e2bcd8739ae039 = $44b5e9dfb8fd0d85$var$MenuGroup;

});

parcelRegister("6zOB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8bd316b08fe19e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ZL0y = parcelRequire("4ZL0y");

var $3Ucf8 = parcelRequire("3Ucf8");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $4a8bd316b08fe19e$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $3Ucf8.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }, baseProps.children);
}));
$4a8bd316b08fe19e$var$Button.displayName = 'Button';
var $4a8bd316b08fe19e$export$2e2bcd8739ae039 = $4a8bd316b08fe19e$var$Button;

});
parcelRegister("3Ucf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $84f5605b031ec678$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3ICHT = parcelRequire("3ICHT");

var $1Pq75 = parcelRequire("1Pq75");

var $fE1y3 = parcelRequire("fE1y3");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ const $84f5605b031ec678$var$useDefaultButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
    const baseProps = (0, $fE1y3.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Pq75.default), {
            icon: iconBefore
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ICHT.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Pq75.default), {
            icon: iconAfter
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $84f5605b031ec678$export$2e2bcd8739ae039 = $84f5605b031ec678$var$useDefaultButton;

});


parcelRegister("ffiyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee4547c882ae1a52$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $ee4547c882ae1a52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ee4547c882ae1a52$var$baseStylesOld = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $ee4547c882ae1a52$var$styles = {
    container: {
        name: "1s8rs5f",
        styles: "display:inline-flex;box-sizing:border-box;position:static;block-size:min-content;border-radius:3px;overflow:hidden;padding-inline:var(--ds-space-050, 4px)"
    },
    background: {
        bold: {
            default: {
                name: "1007ca",
                styles: "background-color:#DDDEE1"
            },
            inprogress: {
                name: "5nwhd8",
                styles: "background-color:#8FB8F6"
            },
            moved: {
                name: "1v45608",
                styles: "background-color:#F9C84E"
            },
            new: {
                name: "1ra4w2w",
                styles: "background-color:#D8A0F7"
            },
            removed: {
                name: "1y25gsq",
                styles: "background-color:#FD9891"
            },
            success: {
                name: "2bpbki",
                styles: "background-color:#B3DF72"
            }
        },
        subtle: {
            default: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            inprogress: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            moved: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            new: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            removed: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            success: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    },
    border: {
        subtle: {
            default: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $byn9U.css)({
                border: `1px solid #94C748`
            })
        }
    },
    text: {
        subtle: {
            name: "nws7uq",
            styles: "color:var(--ds-text, #172B4D)"
        },
        bold: {
            name: "14qj9ca",
            styles: "color:#292A2E"
        }
    }
};
const $ee4547c882ae1a52$var$textStyles = {
    name: "1bkq1y7",
    styles: "font-family:ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif;font-size:11px;font-style:normal;font-weight:var(--ds-font-weight-bold, 700);line-height:16px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $ee4547c882ae1a52$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $ee4547c882ae1a52$var$styles.background[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $ee4547c882ae1a52$var$styles.container,
            $ee4547c882ae1a52$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && $ee4547c882ae1a52$var$styles.border.subtle[appearanceType]
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $ee4547c882ae1a52$var$textStyles,
            $ee4547c882ae1a52$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
    const appearanceTypeOld = appearance in $ee4547c882ae1a52$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        as: "span",
        backgroundColor: $ee4547c882ae1a52$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $ee4547c882ae1a52$var$baseStylesOld,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $ee4547c882ae1a52$var$textStyles,
            $ee4547c882ae1a52$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$ee4547c882ae1a52$var$Lozenge.displayName = 'Lozenge';
var $ee4547c882ae1a52$export$2e2bcd8739ae039 = $ee4547c882ae1a52$var$Lozenge;
const $ee4547c882ae1a52$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $ee4547c882ae1a52$var$textColorsOld = {
    bold: {
        default: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        inprogress: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        moved: {
            name: "tgubtb",
            styles: "color:var(--ds-text-warning-inverse, #172B4D)"
        },
        new: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        removed: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        success: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        default: {
            name: "kmxsjg",
            styles: "color:var(--ds-text-subtle, #42526E)"
        },
        inprogress: {
            name: "3j31nl",
            styles: "color:var(--ds-text-information, #0052CC)"
        },
        moved: {
            name: "1g2i1rp",
            styles: "color:var(--ds-text-warning, #974F0C)"
        },
        new: {
            name: "3juofh",
            styles: "color:var(--ds-text-discovery, #403294)"
        },
        removed: {
            name: "18zo14t",
            styles: "color:var(--ds-text-danger, #DE350B)"
        },
        success: {
            name: "1ychrch",
            styles: "color:var(--ds-text-success, #006644)"
        }
    }
};

});

parcelRegister("aVkzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde2ba376b255ed5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $73N4g = parcelRequire("73N4g");
function $cde2ba376b255ed5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cde2ba376b255ed5$var$gridSize = (0, $lcnyw.gridSize)();
const $cde2ba376b255ed5$var$borderRadius = (0, $lcnyw.borderRadius)();
const $cde2ba376b255ed5$var$itemElemSpacing = $cde2ba376b255ed5$var$gridSize * 1.5;
const $cde2ba376b255ed5$var$itemExpectedElemSize = $cde2ba376b255ed5$var$gridSize * 3;
const $cde2ba376b255ed5$var$itemMinHeight = $cde2ba376b255ed5$var$gridSize * 5;
const $cde2ba376b255ed5$var$skeletonItemElemSize = $cde2ba376b255ed5$var$gridSize * 2.5;
const $cde2ba376b255ed5$var$itemElemSkeletonOffset = ($cde2ba376b255ed5$var$itemExpectedElemSize - $cde2ba376b255ed5$var$skeletonItemElemSize) / 2;
const $cde2ba376b255ed5$var$skeletonTextBorderRadius = 100;
const $cde2ba376b255ed5$var$skeletonContentHeight = 9;
const $cde2ba376b255ed5$var$skeletonColor = `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`;
const $cde2ba376b255ed5$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: $cde2ba376b255ed5$var$itemMinHeight,
    padding: `0 ${"var(--ds-space-250, 20px)"}`,
    alignItems: 'center',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        height: $cde2ba376b255ed5$var$skeletonContentHeight,
        backgroundColor: $cde2ba376b255ed5$var$skeletonColor,
        borderRadius: $cde2ba376b255ed5$var$skeletonTextBorderRadius,
        content: '""',
        // This is a little bespoke but we need to push everything down 1px
        // because the skeleton content should align to the bottom of the text.
        // Confirm VR test failures before accepting a change.
        marginBlockStart: 1
    }
});
const $cde2ba376b255ed5$var$defaultWidthStyles = {
    name: "sljcv5",
    styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
};
const $cde2ba376b255ed5$var$customWidthStyles = {
    name: "nsk3fe",
    styles: "::after{flex-basis:var(--width);}"
};
const $cde2ba376b255ed5$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: $cde2ba376b255ed5$var$skeletonItemElemSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $cde2ba376b255ed5$var$skeletonItemElemSize,
        flexShrink: 0,
        backgroundColor: $cde2ba376b255ed5$var$skeletonColor,
        content: '""',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginInlineEnd: $cde2ba376b255ed5$var$itemElemSpacing + $cde2ba376b255ed5$var$itemElemSkeletonOffset,
        marginInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $cde2ba376b255ed5$var$avatarStyles = {
    name: "lz1zvf",
    styles: "::before{border-radius:100%;}"
};
const $cde2ba376b255ed5$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $cde2ba376b255ed5$var$borderRadius
    }
});
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $cde2ba376b255ed5$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $5Q9wj.default) })=>{
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $byn9U.css)(cssFn());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $73N4g.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $cde2ba376b255ed5$var$skeletonStyles,
                (hasAvatar || hasIcon) && $cde2ba376b255ed5$var$beforeElementStyles,
                hasAvatar && $cde2ba376b255ed5$var$avatarStyles,
                hasIcon && $cde2ba376b255ed5$var$iconStyles,
                width ? $cde2ba376b255ed5$var$customWidthStyles : $cde2ba376b255ed5$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-testid": testId
        }));
};
var $cde2ba376b255ed5$export$2e2bcd8739ae039 = $cde2ba376b255ed5$var$SkeletonItem;

});
parcelRegister("73N4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c3e4cd190ecc73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
/**
 * These keyframes are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $c1c3e4cd190ecc73$var$shimmerKeyframes = (0, $byn9U.keyframes)({
    from: {
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`
    },
    to: {
        backgroundColor: `var(--ds-skeleton-subtle, ${(0, $PdmhA.N30A)})`
    }
});
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $c1c3e4cd190ecc73$var$shimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before, ::after': {
        animationDirection: 'alternate',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationName: `${$c1c3e4cd190ecc73$var$shimmerKeyframes}`,
        animationTimingFunction: 'linear',
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`
    }
});
/**
 * __Skeleton shimmer__
 *
 * A skeleton shimmer is the animation shown on loading skeletons for
 * perceived performance and user satisfaction.
 *
 * This component provides a `className` through render props. This value will
 * have type:
 * + `string`, when `isShimmering={true}`.
 * + `undefined`, when `isShimmering={false}`.
 *
 * @internal
 */ const $c1c3e4cd190ecc73$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
            className: isShimmering ? css($c1c3e4cd190ecc73$var$shimmerStyles) : undefined
        }));
};
var $c1c3e4cd190ecc73$export$2e2bcd8739ae039 = $c1c3e4cd190ecc73$var$SkeletonShimmer;

});


parcelRegister("bgY86", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c7adfaa99dd93b$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $kyri3 = parcelRequire("kyri3");

var $31snR = parcelRequire("31snR");

var $iednx = parcelRequire("iednx");

var $fw2Om = parcelRequire("fw2Om");

var $1UQcZ = parcelRequire("1UQcZ");
const $36c7adfaa99dd93b$var$defaultColorMode = 'light';
const $36c7adfaa99dd93b$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $36c7adfaa99dd93b$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $31snR.themeStateDefaults)['colorMode'], dark: dark = (0, $31snR.themeStateDefaults)['dark'], light: light = (0, $31snR.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $31snR.themeStateDefaults)['contrastMode'], shape: shape = (0, $31snR.themeStateDefaults)['shape'], spacing: spacing = (0, $31snR.themeStateDefaults)['spacing'], typography: typography = (0, $31snR.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $31snR.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $iednx.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $kyri3.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $kyri3.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $36c7adfaa99dd93b$var$defaultColorMode : colorMode
    };
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $kyri3.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $36c7adfaa99dd93b$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $fw2Om.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $1UQcZ.hash)(optionString);
        result[0, $kyri3.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $36c7adfaa99dd93b$export$2e2bcd8739ae039 = $36c7adfaa99dd93b$var$getThemeHtmlAttrs;

});
parcelRegister("fw2Om", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $2174d67c292df557$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $2174d67c292df557$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $2174d67c292df557$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $2174d67c292df557$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $2174d67c292df557$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $2174d67c292df557$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $2174d67c292df557$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $2174d67c292df557$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $2174d67c292df557$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $2174d67c292df557$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $2174d67c292df557$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $2174d67c292df557$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $2174d67c292df557$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $2174d67c292df557$export$b36dbdb4f463f05c(hex) {
    if (!$2174d67c292df557$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $2174d67c292df557$export$1212645cf40ebf71(hex)
    ];
}
function $2174d67c292df557$export$5a544e13ad4e1fa5(hex) {
    if (!$2174d67c292df557$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $2174d67c292df557$export$47ea145a83f50dc0(hex) {
    if (!$2174d67c292df557$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $2174d67c292df557$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $2174d67c292df557$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $2174d67c292df557$export$d061e26956a60b0a(foreground, background) {
    if (!$2174d67c292df557$var$isValidHex(foreground) || !$2174d67c292df557$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $2174d67c292df557$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $2174d67c292df557$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $2174d67c292df557$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $2174d67c292df557$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $2174d67c292df557$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $2174d67c292df557$var$rgbToLab(rgbA);
    let labB = $2174d67c292df557$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $2174d67c292df557$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("1UQcZ", function(module, exports) {

$parcel$export(module.exports, "hash", () => $64b7133bcbaaaeb2$export$d6af199866bfb566);
const $64b7133bcbaaaeb2$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("hjabr", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", () => $3abf8d5c3a2ef22f$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $3abf8d5c3a2ef22f$export$5d76d7014f4a5d08);

var $XHGTv = parcelRequire("XHGTv");

var $iXSlm = parcelRequire("iXSlm");
const $3abf8d5c3a2ef22f$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $XHGTv.fg)('platform.design-system-team.increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $iXSlm.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $XHGTv.fg)('platform.design-system-team.increased-contrast-themes')) {
            const increasedContrastTheme = (0, $iXSlm.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $3abf8d5c3a2ef22f$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("iXSlm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e7547266d0674$export$2e2bcd8739ae039);

var $31snR = parcelRequire("31snR");
function $fb1e7547266d0674$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $31snR.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("2Mf9s", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", () => $318d44fe11a01223$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $318d44fe11a01223$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $318d44fe11a01223$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $318d44fe11a01223$export$8662df6937d86fcb);

var $XHGTv = parcelRequire("XHGTv");

var $luyTl = parcelRequire("luyTl");

var $kyri3 = parcelRequire("kyri3");
const $318d44fe11a01223$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $kyri3.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $kyri3.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $318d44fe11a01223$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $318d44fe11a01223$export$8a48286ed7df6720 = async (themeId)=>{
    if ((themeId === 'light' || themeId === 'dark') && (0, $XHGTv.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
    const { default: themeCss } = await (0, $luyTl.default)[themeId]();
    return themeCss;
};
const $318d44fe11a01223$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $318d44fe11a01223$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("luyTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d324c79f1f06e69$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::1178d8004df8fd52edec31241e55e33a>>
 * @codegenCommand yarn build tokens
 */ 













const $7d324c79f1f06e69$var$themeImportsMap = {
    'light': ()=>(parcelRequire("hvw40")),
    'light-future': ()=>(parcelRequire("iaUUt")),
    'light-increased-contrast': ()=>(parcelRequire("hMOJ2")),
    'dark': ()=>(parcelRequire("jRtSp")),
    'dark-future': ()=>(parcelRequire("86j4U")),
    'dark-increased-contrast': ()=>(parcelRequire("hXNOO")),
    'legacy-light': ()=>(parcelRequire("6FI2x")),
    'legacy-dark': ()=>(parcelRequire("5YiOb")),
    'spacing': ()=>(parcelRequire("jWDAg")),
    'typography-adg3': ()=>(parcelRequire("lKOxc")),
    'shape': ()=>(parcelRequire("gYJYi")),
    'typography-modernized': ()=>(parcelRequire("aqbbG")),
    'light-brand-refresh': ()=>(parcelRequire("2zbe4")),
    'dark-brand-refresh': ()=>(parcelRequire("2IivL"))
};
var $7d324c79f1f06e69$export$2e2bcd8739ae039 = $7d324c79f1f06e69$var$themeImportsMap;

});
parcelRegister("hvw40", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fu4Ju');
        const value = parcelRequire('IqkkX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fu4Ju").then(()=>parcelRequire('IqkkX'));
}

});
parcelRegister("chRvw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    const retry_state = {};
    module.exports = async function(id) {
        if (!globalThis.navigator.onLine) await new Promise((res)=>{
            const callback = ()=>(globalThis.removeEventListener('online', callback), res());
            globalThis.addEventListener('online', callback);
        });
        let bundle_src = (parcelRequire("bjqNS")).resolve(id);
        let src = bundle_src;
        retry_state[bundle_src] = retry_state[bundle_src] || {
            should_retry: false,
            param: undefined
        };
        if (retry_state[bundle_src].should_retry) retry_state[bundle_src].param = Date.now();
        if (retry_state[bundle_src].param) src = src + "?retry=" + retry_state[bundle_src].param;
        try {
            retry_state[bundle_src].should_retry = false;
            return await import(src);
        } catch (error) {
            retry_state[bundle_src].should_retry = true;
            throw error;
        }
    };
} else {
    "use strict";
    function load(id) {
        // eslint-disable-next-line no-undef
        return import((parcelRequire("bjqNS")).resolve(id));
    }
    module.exports = load;
}

});
parcelRegister("bjqNS", function(module, exports) {

$parcel$export(module.exports, "register", () => $83c642ad29ddccba$export$6503ec6e8aabbaf, (v) => $83c642ad29ddccba$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $83c642ad29ddccba$export$f7ad0328861e2f03, (v) => $83c642ad29ddccba$export$f7ad0328861e2f03 = v);
var $83c642ad29ddccba$export$6503ec6e8aabbaf;
var $83c642ad29ddccba$export$f7ad0328861e2f03;
"use strict";
var $83c642ad29ddccba$var$mapping = new Map();
function $83c642ad29ddccba$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$83c642ad29ddccba$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $83c642ad29ddccba$var$resolve(id) {
    var resolved = $83c642ad29ddccba$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$83c642ad29ddccba$export$6503ec6e8aabbaf = $83c642ad29ddccba$var$register;
$83c642ad29ddccba$export$f7ad0328861e2f03 = $83c642ad29ddccba$var$resolve;

});



parcelRegister("iaUUt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dgsHK');
        const value = parcelRequire('aAqzu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dgsHK").then(()=>parcelRequire('aAqzu'));
}

});

parcelRegister("hMOJ2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bWPWA');
        const value = parcelRequire('5C2sE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bWPWA").then(()=>parcelRequire('5C2sE'));
}

});

parcelRegister("jRtSp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('deyYz');
        const value = parcelRequire('4oSgK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("deyYz").then(()=>parcelRequire('4oSgK'));
}

});

parcelRegister("86j4U", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gSwR6');
        const value = parcelRequire('6Bhb7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gSwR6").then(()=>parcelRequire('6Bhb7'));
}

});

parcelRegister("hXNOO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2TWkc');
        const value = parcelRequire('6pLwM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2TWkc").then(()=>parcelRequire('6pLwM'));
}

});

parcelRegister("6FI2x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bcp5i');
        const value = parcelRequire('kp7mA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bcp5i").then(()=>parcelRequire('kp7mA'));
}

});

parcelRegister("5YiOb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gPFC2');
        const value = parcelRequire('bImqC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gPFC2").then(()=>parcelRequire('bImqC'));
}

});

parcelRegister("jWDAg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fkg0O');
        const value = parcelRequire('bq3w1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fkg0O").then(()=>parcelRequire('bq3w1'));
}

});

parcelRegister("lKOxc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gaxrs');
        const value = parcelRequire('hFNZG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gaxrs").then(()=>parcelRequire('hFNZG'));
}

});

parcelRegister("gYJYi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lvh4t');
        const value = parcelRequire('14YNO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lvh4t").then(()=>parcelRequire('14YNO'));
}

});

parcelRegister("aqbbG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('icO0C');
        const value = parcelRequire('icVT4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("icO0C").then(()=>parcelRequire('icVT4'));
}

});

parcelRegister("2zbe4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ctDwD');
        const value = parcelRequire('fozTL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ctDwD").then(()=>parcelRequire('fozTL'));
}

});

parcelRegister("2IivL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('i2MKz');
        const value = parcelRequire('ZHIQm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("i2MKz").then(()=>parcelRequire('ZHIQm'));
}

});



parcelRegister("IlKAE", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $be3afd95cc5f332e$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $be3afd95cc5f332e$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $be3afd95cc5f332e$export$e673f367da2ff23e);

var $h6fut = parcelRequire("h6fut");

var $kyri3 = parcelRequire("kyri3");

var $1UQcZ = parcelRequire("1UQcZ");
function $be3afd95cc5f332e$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $1UQcZ.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $kyri3.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $kyri3.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $be3afd95cc5f332e$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $kyri3.CUSTOM_THEME_ATTRIBUTE)}][${(0, $kyri3.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $be3afd95cc5f332e$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $h6fut.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("h6fut", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e8cf667c414b31b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ const $1e8cf667c414b31b$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $1e8cf667c414b31b$export$2e2bcd8739ae039 = $1e8cf667c414b31b$var$tokens;

});


parcelRegister("8hqCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d87c26b453d66d$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $31snR = parcelRequire("31snR");

var $fw2Om = parcelRequire("fw2Om");

var $7FsR2 = parcelRequire("7FsR2");

var $IlKAE = parcelRequire("IlKAE");

var $hjabr = parcelRequire("hjabr");

var $2Mf9s = parcelRequire("2Mf9s");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $33d87c26b453d66d$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $31snR.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $31snR.themeStateDefaults)['contrastMode'], dark: dark = (0, $31snR.themeStateDefaults)['dark'], light: light = (0, $31snR.themeStateDefaults)['light'], shape: shape = (0, $31snR.themeStateDefaults)['shape'], spacing: spacing = (0, $31snR.themeStateDefaults)['spacing'], typography: typography = (0, $31snR.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $31snR.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $XHGTv.fg)('platform.design-system-team.increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $hjabr.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $2Mf9s.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $fw2Om.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $31snR.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $IlKAE.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("2qx7E"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $hjabr.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $7FsR2.default)(themeState);
    return autoUnbind;
};
var $33d87c26b453d66d$export$2e2bcd8739ae039 = $33d87c26b453d66d$var$setGlobalTheme;

});
parcelRegister("7FsR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8ad4c9c8a5ee06$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $bgY86 = parcelRequire("bgY86");

var $IANmN = parcelRequire("IANmN");

var $hU16G = parcelRequire("hU16G");
function $fe8ad4c9c8a5ee06$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $IANmN.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $IANmN.default).bind();
    } else (0, $IANmN.default).unbind();
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $hU16G.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $hU16G.default).bind();
        } else (0, $hU16G.default).unbind();
    }
    const themeAttributes = (0, $bgY86.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $IANmN.default).unbind();
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.increased-contrast-themes')) (0, $hU16G.default).unbind();
    };
}

});
parcelRegister("IANmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $412ce3ddd2f56cdc$export$2e2bcd8739ae039);

var $74BVL = parcelRequire("74BVL");

var $kyri3 = parcelRequire("kyri3");

var $2Mf9s = parcelRequire("2Mf9s");
const $412ce3ddd2f56cdc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $412ce3ddd2f56cdc$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $kyri3.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $412ce3ddd2f56cdc$var$darkModeMql = $412ce3ddd2f56cdc$var$isMatchMediaAvailable && window.matchMedia((0, $2Mf9s.darkModeMediaQuery));
class $412ce3ddd2f56cdc$var$ColorModeObserver {
    getColorMode() {
        if (!$412ce3ddd2f56cdc$var$darkModeMql) return 'light';
        return $412ce3ddd2f56cdc$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($412ce3ddd2f56cdc$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $74BVL.bind)($412ce3ddd2f56cdc$var$darkModeMql, {
            type: 'change',
            listener: $412ce3ddd2f56cdc$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $412ce3ddd2f56cdc$var$SingletonColorModeObserver = new $412ce3ddd2f56cdc$var$ColorModeObserver();
var $412ce3ddd2f56cdc$export$2e2bcd8739ae039 = $412ce3ddd2f56cdc$var$SingletonColorModeObserver;

});

parcelRegister("hU16G", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1603c7b460b130$export$2e2bcd8739ae039);

var $74BVL = parcelRequire("74BVL");

var $kyri3 = parcelRequire("kyri3");

var $2Mf9s = parcelRequire("2Mf9s");
const $0a1603c7b460b130$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $0a1603c7b460b130$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $kyri3.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $0a1603c7b460b130$var$contrastModeMql = $0a1603c7b460b130$var$isMatchMediaAvailable && window.matchMedia((0, $2Mf9s.moreContrastMediaQuery));
class $0a1603c7b460b130$var$ContrastModeObserver {
    getContrastMode() {
        if (!$0a1603c7b460b130$var$contrastModeMql) return 'no-preference';
        return $0a1603c7b460b130$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($0a1603c7b460b130$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $74BVL.bind)($0a1603c7b460b130$var$contrastModeMql, {
            type: 'change',
            listener: $0a1603c7b460b130$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $0a1603c7b460b130$var$SingletonContrastModeObserver = new $0a1603c7b460b130$var$ContrastModeObserver();
var $0a1603c7b460b130$export$2e2bcd8739ae039 = $0a1603c7b460b130$var$SingletonContrastModeObserver;

});


parcelRegister("2qx7E", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4n7Rc');
        const value = parcelRequire('9EX02');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4n7Rc").then(()=>parcelRequire('9EX02'));
}

});


parcelRegister("cgrgx", function(module, exports) {

$parcel$export(module.exports, "NestedContext", () => $859a6debe363fd1f$export$46b2c2071c8c725a);
$parcel$export(module.exports, "useNestedContext", () => $859a6debe363fd1f$export$f24166abe9ed712b);
$parcel$export(module.exports, "useShouldNestedElementRender", () => $859a6debe363fd1f$export$37e8646a1abfc3e6);

var $eUqFw = parcelRequire("eUqFw");
const $859a6debe363fd1f$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $859a6debe363fd1f$export$f24166abe9ed712b = ()=>{
    const context = (0, $eUqFw.useContext)($859a6debe363fd1f$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $859a6debe363fd1f$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $eUqFw.useContext)($859a6debe363fd1f$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});

parcelRegister("cS2gQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95ec4a15ab979162$var$_react = $95ec4a15ab979162$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $95ec4a15ab979162$var$_UNSAFE_baseNew = $95ec4a15ab979162$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $95ec4a15ab979162$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Add".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95ec4a15ab979162$var$AddIcon = (props)=>/*#__PURE__*/ $95ec4a15ab979162$var$_react.default.createElement($95ec4a15ab979162$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
    }, props));
$95ec4a15ab979162$var$AddIcon.displayName = 'AddIcon';
var $95ec4a15ab979162$var$_default = module.exports.default = $95ec4a15ab979162$var$AddIcon;

});

parcelRegister("5qTKr", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $c6f750a76324ffb4$export$b2ad68b9bc407b80);

var $eUqFw = parcelRequire("eUqFw");

var $fcMY9 = parcelRequire("fcMY9");
const $c6f750a76324ffb4$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fcMY9.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $c6f750a76324ffb4$export$2e2bcd8739ae039 = $c6f750a76324ffb4$export$b2ad68b9bc407b80;

});
parcelRegister("fcMY9", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $6aaee5d21d622db3$export$ff983d2a2b6112ea);

var $eUqFw = parcelRequire("eUqFw");

var $5SGY2 = parcelRequire("5SGY2");
const $6aaee5d21d622db3$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5SGY2.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("5SGY2", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $7aaf8da200479bd8$export$2f62ee6831462844);

var $eUqFw = parcelRequire("eUqFw");
function $7aaf8da200479bd8$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("d3fGG", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $a14dd8b44b444cc0$export$21bfbeb62fdcce8d);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $a14dd8b44b444cc0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $a14dd8b44b444cc0$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $a14dd8b44b444cc0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ecIoc", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $03f4c1478d7047c7$export$3c6158790f5e01c4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $03f4c1478d7047c7$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $03f4c1478d7047c7$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $03f4c1478d7047c7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eT0WN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $a1f7fbebb8f5db6b$export$49e55ae2c03d6045);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $4Ywu9 = parcelRequire("4Ywu9");
const $a1f7fbebb8f5db6b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $4Ywu9.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $a1f7fbebb8f5db6b$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $eUqFw.useRef)(listener);
    (0, $eUqFw.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $a1f7fbebb8f5db6b$var$queries[queryString];
    (0, $eUqFw.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $74BVL.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("fkzy8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2944cac94194295$var$_react = $b2944cac94194295$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b2944cac94194295$var$_UNSAFE_baseNew = $b2944cac94194295$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $b2944cac94194295$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "SidebarExpand".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2944cac94194295$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $b2944cac94194295$var$_react.default.createElement($b2944cac94194295$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 2.75H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25h-2.75m0-10.5H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h9.25m0-10.5v10.5M5 5.5 7.5 8 5 10.5"/>`
    }, props));
$b2944cac94194295$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $b2944cac94194295$var$_default = module.exports.default = $b2944cac94194295$var$SidebarExpandIcon;

});

parcelRegister("grIru", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $2780e76024f3b673$export$6d3c345ce7c38fd9);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $cS2gQ = parcelRequire("cS2gQ");
const $2780e76024f3b673$export$6d3c345ce7c38fd9 = ({ children: children, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cS2gQ))),
        onClick: onClick,
        testId: testId
    }, children);

});

parcelRegister("dB8Wo", function(module, exports) {

$parcel$export(module.exports, "Help", () => $f8eb4a4fe98331ca$export$1be7516c0280bee8);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $8MkOl = parcelRequire("8MkOl");

var $kTl03 = parcelRequire("kTl03");

var $7MHzS = parcelRequire("7MHzS");
const $f8eb4a4fe98331ca$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $f8eb4a4fe98331ca$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected }, forwardedRef)=>{
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8MkOl))),
        label: label,
        onClick: onClick,
        appearance: "subtle",
        isSelected: isSelected,
        ref: forwardedRef
    });
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7MHzS.ListItem), null, button);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kTl03.BadgeContainer), {
        id: $f8eb4a4fe98331ca$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button);
});

});
parcelRegister("kTl03", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $b11777848fe817a5$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b11777848fe817a5$var$styles = {
    root: "_kqswh2mm",
    badgeContainer: "_kqswstnw _152tr5cr _rjxp1i6y _lcxvglyw"
};
const $b11777848fe817a5$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, role: role })=>/*#__PURE__*/ $eUqFw.createElement("div", {
        role: role,
        className: (0, $7JEyt.default)([
            $b11777848fe817a5$var$styles.root
        ])
    }, children, /*#__PURE__*/ $eUqFw.createElement("div", {
        id: badgeId,
        "aria-hidden": true,
        className: (0, $7JEyt.default)([
            $b11777848fe817a5$var$styles.badgeContainer
        ])
    }, /*#__PURE__*/ $eUqFw.createElement(Badge, null)));

});

parcelRegister("7MHzS", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $c9c5c74ccd1b727b$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $c9c5c74ccd1b727b$var$styles = {
    root: "_2mzuglyw _18s8ze3t"
};
function $c9c5c74ccd1b727b$var$_ListItem({ children: children, xcss: xcss }, ref) {
    return /*#__PURE__*/ $eUqFw.createElement("li", {
        ref: ref,
        className: (0, $7JEyt.default)([
            $c9c5c74ccd1b727b$var$styles.root,
            xcss
        ])
    }, children);
}
const $c9c5c74ccd1b727b$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($c9c5c74ccd1b727b$var$_ListItem);

});


parcelRegister("19w0L", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $e903e7706c027e33$export$36ba2f559d49a8f6);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $kTl03 = parcelRequire("kTl03");

var $jVJ59 = parcelRequire("jVJ59");
const $e903e7706c027e33$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $e903e7706c027e33$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected }, forwardedRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kTl03.BadgeContainer), {
        id: $e903e7706c027e33$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, $jVJ59.default),
        label: label,
        onClick: onClick,
        appearance: "subtle",
        isSelected: isSelected,
        ref: forwardedRef
    })));

});
parcelRegister("jVJ59", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef81e2e5ab01993f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
// DSP-13954 Navigation / Notification
const $ef81e2e5ab01993f$var$Notifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.50002 8.5C6.50002 5.46243 8.96245 3 12 3C15.0376 3 17.5 5.46243 17.5 8.5V13.0229L19.7263 16.3623C20.3354 17.276 19.6804 18.5 18.5822 18.5H15.1631C14.8245 19.9333 13.5368 21 12 21C10.4632 21 9.17556 19.9333 8.83698 18.5H5.41784C4.31963 18.5 3.66459 17.276 4.27377 16.3623L6.50002 13.0229V8.5ZM10.4184 18.5C10.6993 19.0912 11.3019 19.5 12 19.5C12.6981 19.5 13.3007 19.0912 13.5816 18.5H10.4184ZM12 4.5C9.79088 4.5 8.00002 6.29086 8.00002 8.5V13.1069C8.00002 13.3483 7.92857 13.5842 7.79469 13.7851L5.6514 17H18.3486L16.2053 13.7851C16.0715 13.5842 16 13.3483 16 13.1069V8.5C16 6.29086 14.2092 4.5 12 4.5Z",
        fill: "#44546F"
    }));
var $ef81e2e5ab01993f$export$2e2bcd8739ae039 = $ef81e2e5ab01993f$var$Notifications;

});


parcelRegister("27KYr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff125957ff3df11$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9seLS = parcelRequire("9seLS");

var $1ZAYh = parcelRequire("1ZAYh");
function $bff125957ff3df11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bff125957ff3df11$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $bff125957ff3df11$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $bff125957ff3df11$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $bff125957ff3df11$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $bff125957ff3df11$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $bff125957ff3df11$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $bff125957ff3df11$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $bff125957ff3df11$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$bff125957ff3df11$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$bff125957ff3df11$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$bff125957ff3df11$var$gridTemplateRowsVar})`
});
const $bff125957ff3df11$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $bff125957ff3df11$var$Grid = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $eUqFw.useMemo)(()=>({
            [$bff125957ff3df11$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$bff125957ff3df11$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$bff125957ff3df11$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $bff125957ff3df11$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $9seLS.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $9seLS.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $9seLS.spaceStylesMap).rowGap[rowGap],
            alignItems && $bff125957ff3df11$var$alignItemsMap[alignItems],
            alignContent && $bff125957ff3df11$var$alignContentMap[alignContent],
            justifyContent && $bff125957ff3df11$var$justifyContentMap[justifyContent],
            autoFlow && $bff125957ff3df11$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$bff125957ff3df11$var$Grid.displayName = 'Grid';
var $bff125957ff3df11$export$2e2bcd8739ae039 = $bff125957ff3df11$var$Grid;

});

parcelRegister("ltfxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8adb8df677de497$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbDTY = parcelRequire("lbDTY");

var $aOINP = parcelRequire("aOINP");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $f8adb8df677de497$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.TargetConsumer), null, (targetRef)=>targetRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: targetRef(name)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)) : children);
var $f8adb8df677de497$export$2e2bcd8739ae039 = $f8adb8df677de497$var$SpotlightTarget;

});

parcelRegister("gVRsf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c53b6f340c571c72$var$_react = $c53b6f340c571c72$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c53b6f340c571c72$var$_UNSAFE_baseNew = $c53b6f340c571c72$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c53b6f340c571c72$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Warning".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c53b6f340c571c72$var$WarningIcon = (props)=>/*#__PURE__*/ $c53b6f340c571c72$var$_react.default.createElement($c53b6f340c571c72$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" fill-rule="evenodd" d="M11.702 9.137A1.25 1.25 0 0 1 10.612 11H1.388a1.25 1.25 0 0 1-1.09-1.863l4.614-8.2a1.25 1.25 0 0 1 2.178 0zM6.75 2.75V6.5h-1.5V2.75zm-.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$c53b6f340c571c72$var$WarningIcon.displayName = 'WarningIcon';
var $c53b6f340c571c72$var$_default = module.exports.default = $c53b6f340c571c72$var$WarningIcon;

});

parcelRegister("fI650", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b28527f26e4865$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");

var $3Ucf8 = parcelRequire("3Ucf8");
const $f7b28527f26e4865$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $3Ucf8.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $f7b28527f26e4865$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($f7b28527f26e4865$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $f7b28527f26e4865$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.memo)($f7b28527f26e4865$var$WithRef);
var $f7b28527f26e4865$export$2e2bcd8739ae039 = $f7b28527f26e4865$var$LinkButton;

});

parcelRegister("lkO3b", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $b60a688757c87c05$export$c49a2b642fe9eef4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $b60a688757c87c05$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $b60a688757c87c05$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $b60a688757c87c05$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kGoGz", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $70a39fd4831fabac$export$dabef2be6cd28c20);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $70a39fd4831fabac$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $70a39fd4831fabac$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $70a39fd4831fabac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iFmgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $69346126ecba512c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kk8oa = parcelRequire("kk8oa");

var $4q38b = parcelRequire("4q38b");
function $69346126ecba512c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $69346126ecba512c$var$baseImageStyles = {
    name: "1hyxgad",
    styles: "max-width:100%;height:auto"
};
const $69346126ecba512c$var$themedImageStyles = /*#__PURE__*/ (0, $byn9U.css)({
    content: `var(--img-source)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'html[data-color-mode=dark] &': {
        content: `var(--img-source-dark)`
    }
});
function $69346126ecba512c$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, ...props }) {
    const imgRef = (0, $eUqFw.useRef)(null);
    const providedColorMode = (0, $kk8oa.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $4q38b.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $eUqFw.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--img-source': `url(${src})`,
            '--img-source-dark': `url(${srcDark || src})`
        },
        css: [
            $69346126ecba512c$var$baseImageStyles,
            $69346126ecba512c$var$themedImageStyles
        ],
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("kk8oa", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $4c5a5058c6e3c5b3$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $4c5a5058c6e3c5b3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $8hqCp = parcelRequire("8hqCp");
const $4c5a5058c6e3c5b3$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing'
};
const $4c5a5058c6e3c5b3$var$ColorModeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $4c5a5058c6e3c5b3$var$SetColorModeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $4c5a5058c6e3c5b3$var$ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $4c5a5058c6e3c5b3$var$SetThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
function $4c5a5058c6e3c5b3$export$ce91654eb9fea460() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$ColorModeContext);
    return value;
}
function $4c5a5058c6e3c5b3$export$20f3076712c8dfa() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $4c5a5058c6e3c5b3$export$e2afe7397c3d11c7() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $4c5a5058c6e3c5b3$export$93d4e7f90805808f() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$ThemeContext);
    if (!value) throw new Error('useTheme must be used within AppProvider.');
    return value;
}
function $4c5a5058c6e3c5b3$export$501aa0dcd5527a48() {
    const value = (0, $eUqFw.useContext)($4c5a5058c6e3c5b3$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $4c5a5058c6e3c5b3$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $4c5a5058c6e3c5b3$var$prefersDarkModeMql = $4c5a5058c6e3c5b3$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $4c5a5058c6e3c5b3$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $4c5a5058c6e3c5b3$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
function $4c5a5058c6e3c5b3$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode, defaultTheme: { dark: dark = 'dark', light: light = 'light', spacing: spacing = 'spacing', typography: typography, shape: shape } = $4c5a5058c6e3c5b3$var$defaultThemeSettings }) {
    const [chosenColorMode, setChosenColorMode] = (0, $eUqFw.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $eUqFw.useState)($4c5a5058c6e3c5b3$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $eUqFw.useState)({
        dark: dark,
        light: light,
        spacing: spacing,
        typography: typography,
        shape: shape
    });
    const setColorMode = (0, $eUqFw.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($4c5a5058c6e3c5b3$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $eUqFw.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        (0, $8hqCp.default)({
            ...theme,
            colorMode: reconciledColorMode
        });
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!$4c5a5058c6e3c5b3$var$prefersDarkModeMql) return;
        const unbindListener = (0, $74BVL.bind)($4c5a5058c6e3c5b3$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c5a5058c6e3c5b3$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $4c5a5058c6e3c5b3$export$2e2bcd8739ae039 = $4c5a5058c6e3c5b3$export$d8964aec282183a3;

});


parcelRegister("82CV1", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $f879c0390ad93f32$export$17d3acb0b4379d02);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $f879c0390ad93f32$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $f879c0390ad93f32$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f879c0390ad93f32$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iX87Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $88f6ea40791e81a2$export$2e2bcd8739ae039);



var $h6fut = parcelRequire("h6fut");

var $2fFJv = parcelRequire("2fFJv");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $88f6ea40791e81a2$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $h6fut.default)[tokenId];
    let tokenValue = fallback;
    typeof $2fFJv;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $88f6ea40791e81a2$export$2e2bcd8739ae039 = $88f6ea40791e81a2$var$getTokenValue;

});

parcelRegister("gib2Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bdc6e5161a9dd574$var$_react = $bdc6e5161a9dd574$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bdc6e5161a9dd574$var$_UNSAFE_baseNew = $bdc6e5161a9dd574$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $bdc6e5161a9dd574$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Teams".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bdc6e5161a9dd574$var$TeamsIcon = (props)=>/*#__PURE__*/ $bdc6e5161a9dd574$var$_react.default.createElement($bdc6e5161a9dd574$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M6 14.25H2c-.69 0-1.25-.56-1.25-1.25v-1.25a3 3 0 0 1 3-3h1.149a3 3 0 0 1 2.82 1.975l.563 1.55a3 3 0 0 0 2.82 1.975H14c.69 0 1.25-.56 1.25-1.25v-1.25a3 3 0 0 0-3-3H12c-1.625 0-2.125.25-2.125.25M6.25 4a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm8 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$bdc6e5161a9dd574$var$TeamsIcon.displayName = 'TeamsIcon';
var $bdc6e5161a9dd574$var$_default = module.exports.default = $bdc6e5161a9dd574$var$TeamsIcon;

});

parcelRegister("cnPHV", function(module, exports) {

$parcel$export(module.exports, "default", () => $47227269f9075bad$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");
function $47227269f9075bad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $47227269f9075bad$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $47227269f9075bad$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $47227269f9075bad$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $47227269f9075bad$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $47227269f9075bad$var$baseStyles,
            (inline || all) && $47227269f9075bad$var$inlineBleedMap[inline || all],
            (block || all) && $47227269f9075bad$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$47227269f9075bad$var$Bleed.displayName = 'Bleed';
var $47227269f9075bad$export$2e2bcd8739ae039 = $47227269f9075bad$var$Bleed;

});

parcelRegister("3EqqU", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $695e689479cb6363$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $9SiaN = parcelRequire("9SiaN");
const $695e689479cb6363$var$hideAboveQueries = (0, $9SiaN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $695e689479cb6363$var$hideBelowQueries = (0, $9SiaN.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $695e689479cb6363$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $695e689479cb6363$var$hideAboveQueries[above],
            below && $695e689479cb6363$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("9SiaN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $gnQiH = parcelRequire("gnQiH");

var $4Ywu9 = parcelRequire("4Ywu9");
const $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("gnQiH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $8ce21554f3c8bfb7$export$2d293d9871c38e91);
const $8ce21554f3c8bfb7$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $8ce21554f3c8bfb7$export$2d293d9871c38e91 = Object.keys($8ce21554f3c8bfb7$export$e5ee4fe8b989fd09);
const $8ce21554f3c8bfb7$export$b7ed752a57b4177b = $8ce21554f3c8bfb7$export$2d293d9871c38e91[0];

});



parcelRegister("5ARvW", function(module, exports) {

$parcel$export(module.exports, "Show", () => $c749d80f6b8dab23$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $9SiaN = parcelRequire("9SiaN");
function $c749d80f6b8dab23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c749d80f6b8dab23$var$showAboveQueries = (0, $9SiaN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$showBelowQueries = (0, $9SiaN.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $c749d80f6b8dab23$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $c749d80f6b8dab23$var$defaultHiddenStyles,
            above && $c749d80f6b8dab23$var$showAboveQueries[above],
            below && $c749d80f6b8dab23$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});

parcelRegister("lV9rH", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c9fdfb00b3c9dc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $1Ivg5 = parcelRequire("1Ivg5");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");

var $73N4g = parcelRequire("73N4g");
function $08c9fdfb00b3c9dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $08c9fdfb00b3c9dc$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'block',
        width: '30%',
        height: "var(--ds-space-100, 8px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA.N20A)})`,
        borderRadius: 100,
        content: '""'
    }
});
const $08c9fdfb00b3c9dc$var$defaultWidthStyles = {
    name: "me8tg7",
    styles: "::after{width:30%;}"
};
const $08c9fdfb00b3c9dc$var$customWidthStyles = {
    name: "ms0ivw",
    styles: "::after{width:var(--width);}"
};
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $08c9fdfb00b3c9dc$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $5Q9wj.default) })=>{
    (0, $1Ivg5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $5Q9wj.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $byn9U.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $73N4g.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $08c9fdfb00b3c9dc$var$skeletonStyles,
                width ? $08c9fdfb00b3c9dc$var$customWidthStyles : $08c9fdfb00b3c9dc$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-ds--menu--skeleton-heading-item": true,
            "data-testid": testId
        }));
};
var $08c9fdfb00b3c9dc$export$2e2bcd8739ae039 = $08c9fdfb00b3c9dc$var$SkeletonHeadingItem;

});

parcelRegister("i4sif", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d27e8c2ea5410565$var$_react = $d27e8c2ea5410565$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d27e8c2ea5410565$var$_UNSAFE_baseNew = $d27e8c2ea5410565$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d27e8c2ea5410565$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "AiChat".
 * Category: Single-purpose
 * Location: Icon contributions
 * Usage guidance: Reserved for Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d27e8c2ea5410565$var$AiChatIcon = (props)=>/*#__PURE__*/ $d27e8c2ea5410565$var$_react.default.createElement($d27e8c2ea5410565$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" d="M6 12.25v-.75h-.22l-.19.12zM1.75 15H1a.75.75 0 0 0 1.16.63zM3 2.5h10V1H3zm10.5.5v8H15V3zm-.5 8.5H6V13h7zm-7.41.12-4.25 2.75.81 1.26 4.25-2.75zM2.5 15V3H1v12zm11-4a.5.5 0 0 1-.5.5V13a2 2 0 0 0 2-2zM13 2.5a.5.5 0 0 1 .5.5H15a2 2 0 0 0-2-2zM3 1a2 2 0 0 0-2 2h1.5a.5.5 0 0 1 .5-.5zm3 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d27e8c2ea5410565$var$AiChatIcon.displayName = 'AiChatIcon';
var $d27e8c2ea5410565$var$_default = module.exports.default = $d27e8c2ea5410565$var$AiChatIcon;

});

parcelRegister("3VeBC", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $da3cafce4e49cea8$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $dcbVh = parcelRequire("dcbVh");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");


var $iMTf6 = parcelRequire("iMTf6");
var $g668r = parcelRequire("g668r");

var $gAfsE = parcelRequire("gAfsE");

var $8yw9O = parcelRequire("8yw9O");
function $da3cafce4e49cea8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $da3cafce4e49cea8$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $cbe92d4f348ad4dd$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N30)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $da3cafce4e49cea8$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $da3cafce4e49cea8$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $da3cafce4e49cea8$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $da3cafce4e49cea8$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $da3cafce4e49cea8$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $iMTf6.defaultTheme), testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $g668r.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dcbVh.NavigationAnalyticsContext), {
        data: $da3cafce4e49cea8$var$analyticsData
    }, /*#__PURE__*/ (0, $byn9U.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $da3cafce4e49cea8$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
        css: $da3cafce4e49cea8$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $byn9U.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $byn9U.jsx)(ProductHome, null), (0, $XHGTv.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8yw9O.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $gAfsE.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da3cafce4e49cea8$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $byn9U.jsx)(Search, null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "list",
        css: [
            $da3cafce4e49cea8$var$rightStyles,
            $da3cafce4e49cea8$var$noRightMarginStyles
        ]
    }, Notifications && /*#__PURE__*/ (0, $byn9U.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $byn9U.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $byn9U.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $byn9U.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $byn9U.jsx)(Profile, null))))));
};
var $da3cafce4e49cea8$export$2e2bcd8739ae039 = $da3cafce4e49cea8$export$f66ccb39f60980e5;

});
const $cbe92d4f348ad4dd$export$30fa7cc5f2690a43 = 56;
const $cbe92d4f348ad4dd$export$4033a111ca79977d = 1280;
const $cbe92d4f348ad4dd$export$24ec62cee78b7042 = 1130;
const $cbe92d4f348ad4dd$export$d8bde68ac946124f = '--ds--ans--fbc';
const $cbe92d4f348ad4dd$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $cbe92d4f348ad4dd$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $cbe92d4f348ad4dd$export$d81606c1fc5119bc = '--ds--ans--c';
const $cbe92d4f348ad4dd$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("iMTf6", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $442823d140399238$export$164de7ab8df77ef0);

var $PdmhA = parcelRequire("PdmhA");

var $i6ige = parcelRequire("i6ige");

var $7slJv = parcelRequire("7slJv");
const $442823d140399238$export$eeee8619e1b91cb0 = (0, $7slJv.generateTheme)({
    name: (0, $i6ige.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $PdmhA.N0),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $PdmhA.B400)
});
const $442823d140399238$export$164de7ab8df77ef0 = $442823d140399238$export$eeee8619e1b91cb0;

});
parcelRegister("i6ige", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $643b966426f86ee9$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $643b966426f86ee9$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $ldbAc = parcelRequire("ldbAc");
const $643b966426f86ee9$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B400), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $PdmhA.B400)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B400), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $PdmhA.N0)})`,
            color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $PdmhA.B400)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N700)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.N200), 0.3)})`}`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: '#357DE8' // TODO: replace with token after brand refresh
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N600)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $ldbAc.hexToRGBA)((0, $PdmhA.B50), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $PdmhA.N0)})`,
                color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
                borderColor: `var(--ds-border-input, ${(0, $PdmhA.N100)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $PdmhA.N0)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
            opacity: 1
        }
    }
};
const $643b966426f86ee9$export$2491e13b198e597d = 'atlassian';
var $643b966426f86ee9$export$2e2bcd8739ae039 = $643b966426f86ee9$var$defaultTheme;

});
parcelRegister("ldbAc", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $673b351980c7e420$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $673b351980c7e420$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $673b351980c7e420$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $673b351980c7e420$export$77a1051494882576);

var $taXj4 = parcelRequire("taXj4");
const $673b351980c7e420$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $taXj4.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $673b351980c7e420$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $673b351980c7e420$var$hex = '[a-z0-9]';
const $673b351980c7e420$var$shortHandHexColorPattern = new RegExp(`#(${$673b351980c7e420$var$hex})(${$673b351980c7e420$var$hex})(${$673b351980c7e420$var$hex})`, 'i');
const $673b351980c7e420$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $673b351980c7e420$var$isShortHexColor = (color)=>color && color.length === 4;
const $673b351980c7e420$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$673b351980c7e420$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $673b351980c7e420$var$completeTriplet = (colors)=>`#${$673b351980c7e420$var$repeat(colors[1], 6)}`;
const $673b351980c7e420$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $673b351980c7e420$export$db8d2130677f868c = (color)=>{
    if ($673b351980c7e420$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($673b351980c7e420$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($673b351980c7e420$var$isTriplet(colors)) return $673b351980c7e420$var$completeTriplet(colors);
            else return $673b351980c7e420$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $673b351980c7e420$export$10a10e7cd1193377 = (color)=>{
    const converted = $673b351980c7e420$export$db8d2130677f868c(color);
    return (0, $taXj4.default).contrastRatio(converted).hex;
};
const $673b351980c7e420$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$673b351980c7e420$export$7229be6d7219ee6a((0, $taXj4.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("7slJv", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $bd4aea7b5824a84d$export$2e4ecffaca289a18);

var $i6ige = parcelRequire("i6ige");

var $ldbAc = parcelRequire("ldbAc");
const $bd4aea7b5824a84d$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $bd4aea7b5824a84d$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $bd4aea7b5824a84d$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $ldbAc.hexToRGBA)(backgroundColor, 0.65) : (0, $ldbAc.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $ldbAc.hexToRGBA)(backgroundColor, 0.8) : (0, $ldbAc.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $ldbAc.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $ldbAc.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $ldbAc.getBoxShadow)('transparent')
        }
    };
};
const $bd4aea7b5824a84d$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $ldbAc.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $bd4aea7b5824a84d$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $ldbAc.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $i6ige.DEFAULT_THEME_NAME)) return 0, $i6ige.default;
    return {
        mode: {
            create: $bd4aea7b5824a84d$var$generateButtonCSSStates($bd4aea7b5824a84d$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $bd4aea7b5824a84d$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $bd4aea7b5824a84d$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $ldbAc.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $ldbAc.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $ldbAc.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $ldbAc.getBoxShadow)((0, $ldbAc.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $ldbAc.getContrastColor)(0.1, $bd4aea7b5824a84d$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $bd4aea7b5824a84d$export$2e2bcd8739ae039 = $bd4aea7b5824a84d$export$2e4ecffaca289a18;

});


parcelRegister("g668r", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $6bc18f940f437c27$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $6bc18f940f437c27$export$d8964aec282183a3);

var $eUqFw = parcelRequire("eUqFw");

var $iMTf6 = parcelRequire("iMTf6");
const $6bc18f940f437c27$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $iMTf6.defaultTheme));
const $6bc18f940f437c27$export$d8964aec282183a3 = $6bc18f940f437c27$export$2c657da244d00bd6.Provider;

});

parcelRegister("gAfsE", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $73c01b7a2db8a3a0$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");

var $5qTKr = parcelRequire("5qTKr");

var $cTgSO = parcelRequire("cTgSO");

var $hTs14 = parcelRequire("hTs14");
function $73c01b7a2db8a3a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $73c01b7a2db8a3a0$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $73c01b7a2db8a3a0$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $73c01b7a2db8a3a0$var$overflowItemsStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text, ${(0, $PdmhA.N700)})`
});
const $73c01b7a2db8a3a0$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $cTgSO.useOverflowController)(items);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $eUqFw.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hTs14.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $cTgSO.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $73c01b7a2db8a3a0$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $73c01b7a2db8a3a0$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $cTgSO.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $byn9U.jsx)(Create, null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $73c01b7a2db8a3a0$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5qTKr.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("cTgSO", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", () => $b860eec20ab2684d$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowStatus", () => $b860eec20ab2684d$export$3fcfc71fab3314f2);
$parcel$export(module.exports, "useOverflowController", () => $b860eec20ab2684d$export$705aa66a39c35bf7);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $5Q9wj = parcelRequire("5Q9wj");
// Prevent width detector from triggering too many re-renders
const $b860eec20ab2684d$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH = 70;
const $b860eec20ab2684d$var$calculateHash = (w, n)=>w + '#' + n;
const $b860eec20ab2684d$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $b860eec20ab2684d$var$OverflowContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $5Q9wj.default),
    closeOverflowMenu: (0, $5Q9wj.default)
});
const $b860eec20ab2684d$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $b860eec20ab2684d$var$OverflowContext;
    const value = (0, $eUqFw.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Provider, {
        value: value
    }, children);
};
const $b860eec20ab2684d$export$3fcfc71fab3314f2 = ()=>(0, $eUqFw.useContext)($b860eec20ab2684d$var$OverflowContext);
const $b860eec20ab2684d$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(nodes);
    const [width, setWidth] = (0, $eUqFw.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $eUqFw.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $eUqFw.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $eUqFw.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $eUqFw.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(setWidth, $b860eec20ab2684d$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $b860eec20ab2684d$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $b860eec20ab2684d$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $b860eec20ab2684d$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH * 2), $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $b860eec20ab2684d$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $b860eec20ab2684d$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
		 * This is not necessarily equal to `lastItemWidth` because the
		 * ```js
		 * if (wasJustLimited) {}
		 * ```
		 * branch above modifies `itemsWidths`.
		 *
		 * Using `lastItemWidth` here can cause collapsing behavior to fail,
		 * such as the issue reported in DSP-7329.
		 */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $b860eec20ab2684d$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $b860eec20ab2684d$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $b860eec20ab2684d$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$b860eec20ab2684d$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("hTs14", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $1cc932bd377d0f16$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $86Ndv = parcelRequire("86Ndv");

var $cnPHV = parcelRequire("cnPHV");
var $1ZAYh = parcelRequire("1ZAYh");

var $dA9yl = parcelRequire("dA9yl");
const $1cc932bd377d0f16$var$chevronIconStylesWithSpacingFixStyles = (0, $1ZAYh.xcss)({
    marginInlineEnd: 'space.negative.050'
});
const $1cc932bd377d0f16$export$bb3af89fb196520d = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $dA9yl.PrimaryButton), {
        iconAfter: /*#__PURE__*/ (0, $byn9U.jsx)((0, $cnPHV.default), {
            xcss: $1cc932bd377d0f16$var$chevronIconStylesWithSpacingFixStyles,
            inline: "space.100"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        })),
        ref: ref,
        ...props
    });
});
var $1cc932bd377d0f16$export$2e2bcd8739ae039 = $1cc932bd377d0f16$export$bb3af89fb196520d;

});
parcelRegister("dA9yl", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $217256b33c00b585$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $8cU5f = parcelRequire("8cU5f");

var $9JmWF = parcelRequire("9JmWF");

var $2FG3A = parcelRequire("2FG3A");
function $217256b33c00b585$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $217256b33c00b585$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $217256b33c00b585$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $217256b33c00b585$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $217256b33c00b585$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$217256b33c00b585$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$217256b33c00b585$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $217256b33c00b585$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, tooltip: tooltip, isSelected: isSelected, isHighlighted: isHighlighted, ...buttonProps } = props;
    const theme = (0, $9JmWF.useTheme)();
    const button = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$217256b33c00b585$var$VAR_BUTTON_SELECTED_COLOR]: theme.mode.primaryButton.selected.color,
            [$217256b33c00b585$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: theme.mode.primaryButton.selected.borderColor
        },
        css: [
            $217256b33c00b585$var$buttonBaseStyles,
            isHighlighted && $217256b33c00b585$var$buttonHighlightedStyles
        ],
        role: "listitem"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $2FG3A.getPrimaryButtonTheme)(theme),
        ...buttonProps
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $217256b33c00b585$export$2e2bcd8739ae039 = $217256b33c00b585$export$ac16a6a04d9b7c84;

});
parcelRegister("9JmWF", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $154fed23e1052565$export$93d4e7f90805808f);

var $eUqFw = parcelRequire("eUqFw");

var $g668r = parcelRequire("g668r");
const $154fed23e1052565$export$93d4e7f90805808f = ()=>(0, $eUqFw.useContext)((0, $g668r.ThemeContext));

});

parcelRegister("2FG3A", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $60a6b0f596b8ed55$export$14dd6915caf431fe);
const $60a6b0f596b8ed55$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});




parcelRegister("8yw9O", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $c873e6b515a01150$export$43e704064d596a9e);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Ywu9 = parcelRequire("4Ywu9");
var $eT0WN = parcelRequire("eT0WN");

var $cTgSO = parcelRequire("cTgSO");

var $hTs14 = parcelRequire("hTs14");
const $c873e6b515a01150$var$containerWrapperStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $c873e6b515a01150$var$sharedContainerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    alignItems: 'stretch',
    paddingInlineEnd: 'space.050',
    gap: 'space.100'
});
const $c873e6b515a01150$var$smallContainerStyles = (0, $1ZAYh.xcss)({
    [(0, $4Ywu9.media).above.sm]: {
        display: 'none'
    }
});
const $c873e6b515a01150$var$mediumContainerStyles = (0, $1ZAYh.xcss)({
    display: 'none',
    [(0, $4Ywu9.media).above.sm]: {
        display: 'flex'
    },
    [(0, $4Ywu9.media).above.lg]: {
        display: 'none'
    }
});
const $c873e6b515a01150$var$largeContainerStyles = (0, $1ZAYh.xcss)({
    display: 'none',
    [(0, $4Ywu9.media).above.lg]: {
        display: 'flex'
    }
});
const $c873e6b515a01150$var$overflowItemsStyles = (0, $1ZAYh.xcss)({
    color: 'color.text'
});
const $c873e6b515a01150$var$MoreItemsPopup = ({ moreLabel: moreLabel, testId: testId, items: items })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
    const onMoreClose = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(false), []);
    const onMoreClick = (0, $eUqFw.useCallback)(()=>setIsMoreOpen((current)=>!current), []);
    const openOverflowMenu = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(true), []);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTs14.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTgSO.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $c873e6b515a01150$var$overflowItemsStyles
        }, items)), [
        items,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        content: content,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    });
};
const $c873e6b515a01150$export$43e704064d596a9e = /*#__PURE__*/ (0, $eUqFw.memo)(({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    // We render a CSS media query based nav at first to handle SSR, then use
    // our useMediaQuery hook once we are hydrated so there is only one set of nav items
    const [isClient, setIsClient] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setIsClient(true);
    }, []);
    // Setting up our media queries to use once app is hydrated
    const mqSm = (0, $eT0WN.UNSAFE_useMediaQuery)('above.sm', (event)=>setIsAboveSm(event.matches));
    const [isAboveSm, setIsAboveSm] = (0, $eUqFw.useState)(mqSm?.matches);
    const mqLg = (0, $eT0WN.UNSAFE_useMediaQuery)('above.lg', (event)=>setIsAboveLg(event.matches));
    const [isAboveLg, setIsAboveLg] = (0, $eUqFw.useState)(mqLg?.matches);
    // Filter out any falsy items passed in
    const filteredItems = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(items).filter((item)=>!!item), [
        items
    ]);
    // NOTE: we could make these max items configurable in the future. For now
    // we are using sensible defaults. Anything over the max gets put in the
    // overflow menu for that screen size.
    // While it may be tempting to use more than 3 items for the medium nav when
    // you see the available space, you need to consider internationalistion.
    // 3 is the safe, defensive choice across many languages and scripts.
    const smallMaxItems = 0;
    const mediumMaxItems = 3;
    const largeMaxItems = 8;
    // We re-use this in both the CSS media query nav that loads in for SSR,
    // and the JS/hook media query nav that is used once hydrated
    const navItems = (0, $eUqFw.useMemo)(()=>{
        return {
            small: {
                navBarItems: [],
                overflowItems: filteredItems
            },
            medium: {
                navBarItems: filteredItems.slice(0, mediumMaxItems),
                overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
            },
            large: {
                navBarItems: filteredItems.slice(0, largeMaxItems),
                overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
            }
        };
    }, [
        filteredItems
    ]);
    const hydratedNavItems = (0, $eUqFw.useMemo)(()=>{
        if (isAboveLg) return navItems.large;
        if (isAboveSm && !isAboveLg) return navItems.medium;
        return navItems.small;
    }, [
        isAboveLg,
        isAboveSm,
        navItems.large,
        navItems.medium,
        navItems.small
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isClient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "list",
        xcss: $c873e6b515a01150$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        testId: testId && `${testId}-primary-actions`,
        xcss: $c873e6b515a01150$var$sharedContainerStyles
    }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        items: hydratedNavItems.overflowItems,
        testId: testId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "list",
        xcss: $c873e6b515a01150$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $c873e6b515a01150$var$sharedContainerStyles,
            $c873e6b515a01150$var$smallContainerStyles
        ]
    }, filteredItems.length > smallMaxItems && // We don't need to pass items into popup, it won't be interactive (SSR only)
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $c873e6b515a01150$var$sharedContainerStyles,
            $c873e6b515a01150$var$mediumContainerStyles
        ]
    }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: [
            $c873e6b515a01150$var$sharedContainerStyles,
            $c873e6b515a01150$var$largeContainerStyles
        ]
    }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c873e6b515a01150$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    }))), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Create, null));
});

});


parcelRegister("eYynb", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $f4c8f2ec6ed8b3c5$export$9923361bd43fa030);

var $eUqFw = parcelRequire("eUqFw");

var $eLhcP = parcelRequire("eLhcP");

var $iMRBA = parcelRequire("iMRBA");
const $f4c8f2ec6ed8b3c5$export$9923361bd43fa030 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eLhcP))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        tooltip: tooltip,
        ref: ref,
        ...iconButtonProps
    });
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$f4c8f2ec6ed8b3c5$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("iMRBA", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $bfb303b126efaaf7$export$c25acd513dcc8062);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $8cU5f = parcelRequire("8cU5f");

var $9JmWF = parcelRequire("9JmWF");

var $lvs6t = parcelRequire("lvs6t");
const $bfb303b126efaaf7$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, ...buttonProps } = props;
    const theme = (0, $9JmWF.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "primary",
        "aria-label": label,
        testId: testId,
        iconBefore: icon,
        ref: ref,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $lvs6t.getIconButtonTheme)(theme),
        ...buttonProps
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("lvs6t", function(module, exports) {

$parcel$export(module.exports, "getIconButtonTheme", () => $e115731cfc5173be$export$f32bddcb857301f3);
const $e115731cfc5173be$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("6JrXy", function(module, exports) {

$parcel$export(module.exports, "SkeletonSwitcherButton", () => $9bb205d6dddc34f9$export$41b1bb24b7702cc2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eLhcP = parcelRequire("eLhcP");

var $9JmWF = parcelRequire("9JmWF");
const $9bb205d6dddc34f9$var$skeletonSwitcherButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:only-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        marginRight: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $9bb205d6dddc34f9$export$41b1bb24b7702cc2 = ({ label: label = '', testId: testId })=>{
    const theme = (0, $9JmWF.useTheme)();
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $9bb205d6dddc34f9$var$skeletonSwitcherButtonStyles,
        type: "button"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eLhcP))), {
        label: label
    })));
};

});

parcelRegister("9KTWV", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $ce1123f26f884b7c$export$36ba2f559d49a8f6);

var $eUqFw = parcelRequire("eUqFw");

var $aLjrh = parcelRequire("aLjrh");

var $3aZfW = parcelRequire("3aZfW");

var $iMRBA = parcelRequire("iMRBA");
const $ce1123f26f884b7c$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $ce1123f26f884b7c$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aZfW.BadgeContainer), {
        id: $ce1123f26f884b7c$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aLjrh))), {
            label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
        }),
        tooltip: tooltip,
        ref: ref,
        "aria-describedby": $ce1123f26f884b7c$var$NOTIFICATIONS_BADGE_ID,
        ...iconButtonProps
    }));
});
var $ce1123f26f884b7c$export$2e2bcd8739ae039 = $ce1123f26f884b7c$export$36ba2f559d49a8f6;

});
parcelRegister("3aZfW", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $1e44b494a510a8f0$export$f710265eb5a003da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $1e44b494a510a8f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e44b494a510a8f0$var$badgeContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $1e44b494a510a8f0$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $1e44b494a510a8f0$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1e44b494a510a8f0$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1e44b494a510a8f0$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Badge, null)));
};

});


parcelRegister("lys1A", function(module, exports) {

$parcel$export(module.exports, "SkeletonNotificationButton", () => $82aeaf4ac6d376a3$export$a14f01df37978534);

var $eUqFw = parcelRequire("eUqFw");

var $aLjrh = parcelRequire("aLjrh");

var $ctFws = parcelRequire("ctFws");
const $82aeaf4ac6d376a3$export$a14f01df37978534 = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctFws.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aLjrh))), {
        label: label
    }));

});
parcelRegister("ctFws", function(module, exports) {

$parcel$export(module.exports, "SkeletonIconButton", () => $7e6127880403327f$export$7b398af37f6177e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
function $7e6127880403327f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7e6127880403327f$var$skeletonIconButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: 0,
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $7e6127880403327f$var$buttonWrapperStyles = {
    name: "khzvr",
    styles: "margin-inline-end:var(--ds-space-050, 4px);&:only-of-type{margin-inline-end:0;}"
};
const $7e6127880403327f$export$7b398af37f6177e = ({ children: children, testId: testId })=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "listitem",
        css: $7e6127880403327f$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $7e6127880403327f$var$skeletonIconButtonStyles,
        type: "button"
    }, children));
};

});


parcelRegister("510qR", function(module, exports) {

$parcel$export(module.exports, "default", () => $870e46b317f6aa1b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");


var $9JmWF = parcelRequire("9JmWF");

var $9KvU8 = parcelRequire("9KvU8");
function $870e46b317f6aa1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $870e46b317f6aa1b$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $870e46b317f6aa1b$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $870e46b317f6aa1b$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $870e46b317f6aa1b$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $870e46b317f6aa1b$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
const $870e46b317f6aa1b$var$hideSiteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
/**
 * __Custom product home__
 *
 * Use `CustomProductHome` to provide a custom logo and icon with URLs.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#custom-product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $870e46b317f6aa1b$var$CustomProductHome = (props)=>{
    const { iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoUrl: logoUrl, href: href, onClick: onClick, siteTitle: siteTitle, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest } = props;
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const Tag = (0, $9KvU8.getTag)(onClick, href);
    const preventFocusRing = (event)=>{
        event.preventDefault();
        onMouseDown && onMouseDown(event);
    };
    const productHomeButtonDynamicStyles = {
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$870e46b317f6aa1b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $870e46b317f6aa1b$var$productHomeButtonStyles,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, logoUrl && /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $870e46b317f6aa1b$var$customMaxHeightStyles,
            $870e46b317f6aa1b$var$productLogoStyles
        ],
        src: logoUrl,
        alt: logoAlt,
        "data-testid": testId && `${testId}-logo`
    }), iconUrl && /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $870e46b317f6aa1b$var$customMaxHeightStyles,
            $870e46b317f6aa1b$var$productIconStyles
        ],
        src: iconUrl,
        alt: iconAlt,
        "data-testid": testId && `${testId}-icon`
    })), siteTitle && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $870e46b317f6aa1b$var$siteTitleStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $870e46b317f6aa1b$var$hideSiteTitleStyles
        ],
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $870e46b317f6aa1b$export$2e2bcd8739ae039 = $870e46b317f6aa1b$var$CustomProductHome;

});
parcelRegister("9KvU8", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $911b89f4364332ea$export$dad497fe1f6e27c0);
const $911b89f4364332ea$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("jHY0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $904a0eb4f83abc9e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");


var $9JmWF = parcelRequire("9JmWF");

var $jvgG9 = parcelRequire("jvgG9");

var $9KvU8 = parcelRequire("9KvU8");
function $904a0eb4f83abc9e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $904a0eb4f83abc9e$var$productHomeButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $904a0eb4f83abc9e$var$productLogoStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $904a0eb4f83abc9e$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $904a0eb4f83abc9e$var$productIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $904a0eb4f83abc9e$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
// When cleaning up feature flag, these styles can be moved into the above block
const $904a0eb4f83abc9e$var$featureFlaggedSiteTitleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // Under the FF, we've made the site title handle it's spacing, with the
    // PrimaryItemsContainer not needing to worry about its paddingInlineStart.
    // This makes it cleaner for the title styles to appear and disappear with mq's
    marginInlineEnd: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $904a0eb4f83abc9e$var$ProductHome = ({ icon: Icon, logo: Logo, siteTitle: siteTitle, onClick: onClick, href: href, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest })=>{
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const { iconColor: iconColor = 'inherit', textColor: textColor = theme.mode.productHome.color } = theme.mode.productHome;
    const Tag = (0, $9KvU8.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $jvgG9.stripEmptyProperties)({
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$904a0eb4f83abc9e$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$904a0eb4f83abc9e$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $904a0eb4f83abc9e$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $904a0eb4f83abc9e$var$customMaxHeightStyles,
            $904a0eb4f83abc9e$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $904a0eb4f83abc9e$var$customMaxHeightStyles,
            $904a0eb4f83abc9e$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        iconColor: iconColor
    }))), siteTitle && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $904a0eb4f83abc9e$var$siteTitleStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $904a0eb4f83abc9e$var$featureFlaggedSiteTitleStyles
        ],
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $904a0eb4f83abc9e$export$2e2bcd8739ae039 = $904a0eb4f83abc9e$var$ProductHome;

});
parcelRegister("jvgG9", function(module, exports) {

$parcel$export(module.exports, "stripEmptyProperties", () => $5771ab878216071c$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $5771ab878216071c$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("jurso", function(module, exports) {

$parcel$export(module.exports, "NavLogo", () => $1373c7ea10d8e06a$export$b6394419753329e);
$parcel$export(module.exports, "HomeActions", () => $1373c7ea10d8e06a$export$ae2177c1f0d2b72c);
$parcel$export(module.exports, "CommonActions", () => $1373c7ea10d8e06a$export$deb4c0713194b9f5);
$parcel$export(module.exports, "UserActions", () => $1373c7ea10d8e06a$export$2fb70d5e506c6bc2);
/* top-navigation.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");

var $i4sif = parcelRequire("i4sif");

var $9IsWp = parcelRequire("9IsWp");

var $fkzy8 = parcelRequire("fkzy8");

var $c6CvK = parcelRequire("c6CvK");

var $4kMup = parcelRequire("4kMup");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1Yimi = parcelRequire("1Yimi");

var $3EqqU = parcelRequire("3EqqU");
var $5ARvW = parcelRequire("5ARvW");

var $1XEld = parcelRequire("1XEld");

var $7MHzS = parcelRequire("7MHzS");

var $i7EPC = parcelRequire("i7EPC");
const $1373c7ea10d8e06a$var$styles = {
    imageContainer: "_1e0c1txw _4cvr1h6o _4t3izwfg _2rkoiti9",
    commonActionsContainer: "_1e0c1txw _zulpu2gc _1bah1h6o _1bsb1osq _yyhycs5v",
    searchButtonRoot: "_yv0e1mfv _4cvr1h6o _11q71j9a _2rkoiti9 _vchhusvi _80om1kdv _1e0cglyw _4t3izwfg _p12f1kvu _1rjcze3t _18zr12x7 _1bsb1osq _19lc1d5g _j6xtr01l _181n11p5",
    searchButtonText: "_yyhyjvu9 _1ii7kb7n",
    searchIconBefore: "_1e0c1txw _yyhykb7n _1ii7kb7n",
    searchElemAfter: "_1e0c1txw _yyhy11wp _1ii7kb7n",
    mobileUserActions: "_bfhk18uv",
    userActions: "_yyhy11wp",
    userActionsList: "_4cvr1h6o _1e0c1txw _zulp1b66",
    homeActions: "_4cvr1h6o _1e0c1txw _zulp1b66 _yyhykb7n",
    hiddenForSmallViewports: "_1e0cglyw _181n18uv"
};
const $1373c7ea10d8e06a$export$b6394419753329e = ({ href: href, logo: logo, mobileLogo: mobileLogo, onClick: onClick, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        "aria-label": label,
        href: href,
        xcss: $1373c7ea10d8e06a$var$styles.imageContainer,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: "sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center"
    }, mobileLogo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EqqU.Hide), {
        below: "sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center"
    }, logo)));
const $1373c7ea10d8e06a$export$9923361bd43fa030 = ({ label: label = 'App switcher', onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EqqU.Hide), {
        below: "sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, $i7EPC.default),
        label: label,
        appearance: "subtle",
        onClick: onClick
    }));
const $1373c7ea10d8e06a$export$57c0a8b695a49ef3 = ({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: "sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fkzy8))),
        label: label,
        appearance: "subtle",
        onClick: onClick
    }));
const $1373c7ea10d8e06a$export$ae2177c1f0d2b72c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $1373c7ea10d8e06a$var$styles.homeActions
        ])
    }, children);
const $1373c7ea10d8e06a$export$4b85d3515bd863a5 = ({ label: label, onClick: onClick, iconBefore: IconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), elemAfter: elemAfter })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        style: {
            // To win the specificity war against Emotion we move this into inline styles
            // When Emotion has been stripped from the Design System move this to Compiled.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            cursor: 'text',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8590A2)"}`
        },
        onClick: onClick,
        xcss: $1373c7ea10d8e06a$var$styles.searchButtonRoot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            $1373c7ea10d8e06a$var$styles.searchIconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IconBefore, {
        color: "var(--ds-icon-subtle, #626F86)",
        spacing: "spacious",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $1373c7ea10d8e06a$var$styles.searchButtonText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtlest"
    }, label)), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            $1373c7ea10d8e06a$var$styles.searchElemAfter
        ])
    }, elemAfter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: "xs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        label: label,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))),
        onClick: onClick
    })));
const $1373c7ea10d8e06a$export$deb4c0713194b9f5 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $1373c7ea10d8e06a$var$styles.commonActionsContainer
        ])
    }, children);
const $1373c7ea10d8e06a$export$af9dc48491a7451d = ({ children: children, onClick: onClick, isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7MHzS.ListItem), {
        xcss: $1373c7ea10d8e06a$var$styles.hiddenForSmallViewports
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($i4sif))),
        onClick: onClick,
        isSelected: isSelected
    }, children));
const $1373c7ea10d8e06a$export$2fb70d5e506c6bc2 = ({ children: children, label: label = 'Actions' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("nav", {
        "aria-label": label,
        className: (0, $7JEyt.default)([
            $1373c7ea10d8e06a$var$styles.userActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XEld.List), {
        xcss: $1373c7ea10d8e06a$var$styles.userActionsList
    }, children));
const $1373c7ea10d8e06a$export$d344b04822cd68e8 = ({ children: children, icon: icon, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7MHzS.ListItem), {
        xcss: $1373c7ea10d8e06a$var$styles.hiddenForSmallViewports
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: icon,
        label: children,
        onClick: onClick,
        appearance: "subtle"
    }));
const $1373c7ea10d8e06a$export$ad3fe8af16946877 = ({ children: children, onClick: onClick, icon: Icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1373c7ea10d8e06a$export$d344b04822cd68e8, {
        icon: Icon,
        onClick: onClick
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: "sm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: onClick,
        "aria-label": children,
        xcss: $1373c7ea10d8e06a$var$styles.mobileUserActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))), {
        label: ""
    })))));
const $1373c7ea10d8e06a$export$8a421bddecb2bf5b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);

});
parcelRegister("1XEld", function(module, exports) {

$parcel$export(module.exports, "List", () => $fcbf4e01cfd96c34$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// Placing this const below the function breaks Compiled!
const $fcbf4e01cfd96c34$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkgrf3"
};
function $fcbf4e01cfd96c34$var$_List({ children: children, xcss: xcss }, ref) {
    return /*#__PURE__*/ $eUqFw.createElement("ul", {
        ref: ref,
        className: (0, $7JEyt.default)([
            $fcbf4e01cfd96c34$var$styles.root,
            xcss
        ])
    }, children);
}
const $fcbf4e01cfd96c34$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($fcbf4e01cfd96c34$var$_List);

});

parcelRegister("i7EPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0236368af12a53c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $f0236368af12a53c$var$AppSwitcher = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 6C4 4.89543 4.89543 4 6 4H8.75C9.85457 4 10.75 4.89543 10.75 6V8.75C10.75 9.85457 9.85457 10.75 8.75 10.75H6C4.89543 10.75 4 9.85457 4 8.75V6ZM6 5.5C5.72386 5.5 5.5 5.72386 5.5 6V8.75C5.5 9.02614 5.72386 9.25 6 9.25H8.75C9.02614 9.25 9.25 9.02614 9.25 8.75V6C9.25 5.72386 9.02614 5.5 8.75 5.5H6ZM13.25 6C13.25 4.89543 14.1454 4 15.25 4H18C19.1046 4 20 4.89543 20 6V8.75C20 9.85457 19.1046 10.75 18 10.75H15.25C14.1454 10.75 13.25 9.85457 13.25 8.75V6ZM15.25 5.5C14.9739 5.5 14.75 5.72386 14.75 6V8.75C14.75 9.02614 14.9739 9.25 15.25 9.25H18C18.2761 9.25 18.5 9.02614 18.5 8.75V6C18.5 5.72386 18.2761 5.5 18 5.5H15.25ZM4 15.25C4 14.1454 4.89543 13.25 6 13.25H8.75C9.85457 13.25 10.75 14.1454 10.75 15.25V18C10.75 19.1046 9.85457 20 8.75 20H6C4.89543 20 4 19.1046 4 18V15.25ZM6 14.75C5.72386 14.75 5.5 14.9739 5.5 15.25V18C5.5 18.2761 5.72386 18.5 6 18.5H8.75C9.02614 18.5 9.25 18.2761 9.25 18V15.25C9.25 14.9739 9.02614 14.75 8.75 14.75H6ZM13.25 15.25C13.25 14.1454 14.1454 13.25 15.25 13.25H18C19.1046 13.25 20 14.1454 20 15.25V18C20 19.1046 19.1046 20 18 20H15.25C14.1454 20 13.25 19.1046 13.25 18V15.25ZM15.25 14.75C14.9739 14.75 14.75 14.9739 14.75 15.25V18C14.75 18.2761 14.9739 18.5 15.25 18.5H18C18.2761 18.5 18.5 18.2761 18.5 18V15.25C18.5 14.9739 18.2761 14.75 18 14.75H15.25Z",
        fill: "#44546F"
    }));
var $f0236368af12a53c$export$2e2bcd8739ae039 = $f0236368af12a53c$var$AppSwitcher;

});


parcelRegister("fMzYK", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $02b21e5144076119$export$5120f2d0b8d4cab8);

var $eUqFw = parcelRequire("eUqFw");

var $iMRBA = parcelRequire("iMRBA");
const $02b21e5144076119$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { label: labelProp, tooltip: tooltip } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    // All other implementations of IconButton within the components are using spread props, so
    // to use explicit props could cause regressions.
    // TODO: Remove these spread props for better static analysis
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        label: label,
        ref: ref,
        ...props
    }));
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$02b21e5144076119$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("dCGmR", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $88af4992ef3c0b5b$export$c72f6eaae7b9adff);

var $eUqFw = parcelRequire("eUqFw");

var $iw0Y6 = parcelRequire("iw0Y6");

var $iMRBA = parcelRequire("iMRBA");
const $88af4992ef3c0b5b$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
            label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
        }),
        ref: ref,
        tooltip: tooltip,
        ...iconButtonProps
    }));
});
var $88af4992ef3c0b5b$export$2e2bcd8739ae039 = $88af4992ef3c0b5b$export$c72f6eaae7b9adff;

});

parcelRegister("8zTJt", function(module, exports) {

$parcel$export(module.exports, "SkeletonSettingsButton", () => $a2aededa28f90371$export$914093d4d181ff4d);

var $eUqFw = parcelRequire("eUqFw");

var $iw0Y6 = parcelRequire("iw0Y6");

var $ctFws = parcelRequire("ctFws");
const $a2aededa28f90371$export$914093d4d181ff4d = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctFws.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
        label: label
    }));

});

parcelRegister("jVbWM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e80c9b9b1b00c004$var$_react = $e80c9b9b1b00c004$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e80c9b9b1b00c004$var$_UNSAFE_baseNew = $e80c9b9b1b00c004$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $e80c9b9b1b00c004$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Apps".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e80c9b9b1b00c004$var$AppsIcon = (props)=>/*#__PURE__*/ $e80c9b9b1b00c004$var$_react.default.createElement($e80c9b9b1b00c004$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M12 9v6m-3-3h6M3 14.25h2c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm8-8h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm-8 0h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$e80c9b9b1b00c004$var$AppsIcon.displayName = 'AppsIcon';
var $e80c9b9b1b00c004$var$_default = module.exports.default = $e80c9b9b1b00c004$var$AppsIcon;

});

parcelRegister("5moLT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e7238ec03a766c3$var$_react = $3e7238ec03a766c3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3e7238ec03a766c3$var$_UNSAFE_baseNew = $3e7238ec03a766c3$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3e7238ec03a766c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "CheckboxUnchecked".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e7238ec03a766c3$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ $3e7238ec03a766c3$var$_react.default.createElement($3e7238ec03a766c3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentColor" stroke-width="1.5" rx="1.25"/>`
    }, props));
$3e7238ec03a766c3$var$CheckboxUncheckedIcon.displayName = 'CheckboxUncheckedIcon';
var $3e7238ec03a766c3$var$_default = module.exports.default = $3e7238ec03a766c3$var$CheckboxUncheckedIcon;

});

parcelRegister("jomRY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1e1ffa3823034d1$var$_react = $e1e1ffa3823034d1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e1e1ffa3823034d1$var$_UNSAFE_baseNew = $e1e1ffa3823034d1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $e1e1ffa3823034d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Project".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1e1ffa3823034d1$var$ProjectIcon = (props)=>/*#__PURE__*/ $e1e1ffa3823034d1$var$_react.default.createElement($e1e1ffa3823034d1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentColor"/>`
    }, props));
$e1e1ffa3823034d1$var$ProjectIcon.displayName = 'ProjectIcon';
var $e1e1ffa3823034d1$var$_default = module.exports.default = $e1e1ffa3823034d1$var$ProjectIcon;

});

parcelRegister("qfFzh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04ee957314405a3b$var$_react = $04ee957314405a3b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $04ee957314405a3b$var$_UNSAFE_baseNew = $04ee957314405a3b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $04ee957314405a3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Tasks".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for multiple tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04ee957314405a3b$var$TasksIcon = (props)=>/*#__PURE__*/ $04ee957314405a3b$var$_react.default.createElement($04ee957314405a3b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m4.375 7 1.75 1.75L9.625 5M3 12.25h8c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25Z"/><path stroke="currentColor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$04ee957314405a3b$var$TasksIcon.displayName = 'TasksIcon';
var $04ee957314405a3b$var$_default = module.exports.default = $04ee957314405a3b$var$TasksIcon;

});

parcelRegister("dxeoe", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $fef0bae967003148$export$b64708c6f1b3ed96);

var $eUqFw = parcelRequire("eUqFw");

var $1ZFzZ = parcelRequire("1ZFzZ");

var $iMRBA = parcelRequire("iMRBA");
const $fef0bae967003148$export$b64708c6f1b3ed96 = (props)=>{
    const { tooltip: tooltip, ...iconButtonProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ZFzZ))), {
            label: typeof tooltip === 'string' ? tooltip : 'Sign-in Icon'
        }),
        tooltip: tooltip,
        ...iconButtonProps
    }));
};
var $fef0bae967003148$export$2e2bcd8739ae039 = $fef0bae967003148$export$b64708c6f1b3ed96;

});

parcelRegister("eZmzz", function(module, exports) {

$parcel$export(module.exports, "SkeletonPrimaryButton", () => $d819e923123a4136$export$4a3049f952d3f130);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");

var $jvgG9 = parcelRequire("jvgG9");
function $d819e923123a4136$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d819e923123a4136$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
const $d819e923123a4136$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
const $d819e923123a4136$var$primaryButtonSkeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `0 ${"var(--ds-space-075, 6px)"}`,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    position: 'relative',
    appearance: 'none',
    border: 0,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::-moz-focus-inner': {
        border: 0
    }
});
const $d819e923123a4136$var$isHighlightedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$d819e923123a4136$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $d819e923123a4136$var$isHighlightedAndDropdownButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        insetInlineEnd: -10
    }
});
const $d819e923123a4136$var$isHighlightedNotDropdownButtonStyles = {
    name: "1sue5tp",
    styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
};
const $d819e923123a4136$var$isDropdownButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginInlineEnd: 18,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        display: 'inline-block',
        width: 4,
        height: 4,
        position: 'absolute',
        borderBlockEnd: '2px solid',
        borderColor: `var(${$d819e923123a4136$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
        borderInlineEnd: '2px solid',
        borderRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockStart: 'calc(50% - 4px)',
        insetInlineStart: 'calc(100% - 3px)',
        marginInlineStart: "var(--ds-space-050, 4px)",
        transform: 'rotate(45deg) scale(1.05)',
        verticalAlign: 'middle'
    }
});
const $d819e923123a4136$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $d819e923123a4136$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
    const theme = (0, $9JmWF.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const dynamicStyles = (0, $jvgG9.stripEmptyProperties)({
        ...primaryButton.default,
        ...isHighlighted && {
            color: primaryButton.selected.color
        },
        [$d819e923123a4136$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
        [$d819e923123a4136$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "listitem",
        css: $d819e923123a4136$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: [
            $d819e923123a4136$var$primaryButtonSkeletonStyles,
            isHighlighted && $d819e923123a4136$var$isHighlightedStyles,
            isDropdownButton && $d819e923123a4136$var$isDropdownButtonStyles,
            isHighlighted && (isDropdownButton ? $d819e923123a4136$var$isHighlightedAndDropdownButtonStyles : $d819e923123a4136$var$isHighlightedNotDropdownButtonStyles)
        ],
        "data-testid": testId
    }, text || children));
};

});

parcelRegister("5wXIr", function(module, exports) {

$parcel$export(module.exports, "Create", () => $2a3a81bfffc67bcc$export$8ade6fcbf3a7de5d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");

var $bkIGg = parcelRequire("bkIGg");

var $8cU5f = parcelRequire("8cU5f");


var $9JmWF = parcelRequire("9JmWF");

var $iMRBA = parcelRequire("iMRBA");

var $57Fe9 = parcelRequire("57Fe9");
const $2a3a81bfffc67bcc$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-smallscreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${(0, $cbe92d4f348ad4dd$export$24ec62cee78b7042) - 1}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-largescreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (min-width: ${0, $cbe92d4f348ad4dd$export$24ec62cee78b7042}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $2a3a81bfffc67bcc$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: buttonTooltip,
        hideTooltipOnClick: true
    }, children) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
const $2a3a81bfffc67bcc$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2a3a81bfffc67bcc$var$wrapperStyles,
        role: "listitem",
        "data-testid": "create-button-wrapper"
    }, /*#__PURE__*/ (0, $byn9U.jsx)($2a3a81bfffc67bcc$var$TooltipSwitch, {
        buttonTooltip: buttonTooltip
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
        id: "createGlobalItem",
        "aria-label": label,
        onClick: onClick,
        href: href,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $57Fe9.getCreateButtonTheme)(theme),
        testId: testId && `${testId}-button`,
        "data-hide-on-smallscreens": true
    }, text)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $iMRBA.IconButton), {
        id: "createGlobalItemIconButton",
        testId: testId && `${testId}-icon-button`,
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: text
        }),
        onClick: onClick,
        href: href,
        tooltip: iconButtonTooltip,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $57Fe9.getCreateButtonTheme)(theme),
        "aria-label": text,
        "data-hide-on-largescreens": true
    }));
};
var $2a3a81bfffc67bcc$export$2e2bcd8739ae039 = $2a3a81bfffc67bcc$export$8ade6fcbf3a7de5d;

});
parcelRegister("57Fe9", function(module, exports) {

$parcel$export(module.exports, "getCreateButtonTheme", () => $b6f6fddcdcc99923$export$256eebed8e934f30);
const $b6f6fddcdcc99923$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...create.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': create.hover,
                ':focus': create.focus,
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && create.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("ctSbD", function(module, exports) {

$parcel$export(module.exports, "SkeletonCreateButton", () => $320bdf94771a4b79$export$e321b2260435e302);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9JmWF = parcelRequire("9JmWF");
function $320bdf94771a4b79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $320bdf94771a4b79$var$skeletonCreateButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    height: 32,
    padding: `0 ${"var(--ds-space-150, 12px)"}`,
    alignSelf: 'center',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $320bdf94771a4b79$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $320bdf94771a4b79$export$e321b2260435e302 = ({ text: text, testId: testId })=>{
    const theme = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "listitem",
        css: $320bdf94771a4b79$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.create.default,
        css: $320bdf94771a4b79$var$skeletonCreateButtonStyles,
        "data-testid": testId,
        type: "button"
    }, text));
};

});

parcelRegister("8YHhh", function(module, exports) {

$parcel$export(module.exports, "Help", () => $ae01b0ce6424f9a7$export$1be7516c0280bee8);

var $eUqFw = parcelRequire("eUqFw");

var $ioiQ7 = parcelRequire("ioiQ7");

var $9JmWF = parcelRequire("9JmWF");

var $3aZfW = parcelRequire("3aZfW");

var $iMRBA = parcelRequire("iMRBA");
const $ae01b0ce6424f9a7$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $ae01b0ce6424f9a7$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
    const { mode: { navigation: navigation } } = (0, $9JmWF.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRBA.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            secondaryColor: navigation.backgroundColor
        }),
        ref: ref,
        tooltip: tooltip,
        ...iconButtonProps
    });
    return badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aZfW.BadgeContainer), {
        id: $ae01b0ce6424f9a7$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "listitem"
    }, button);
});
var $ae01b0ce6424f9a7$export$2e2bcd8739ae039 = $ae01b0ce6424f9a7$export$1be7516c0280bee8;

});

parcelRegister("lUkcz", function(module, exports) {

$parcel$export(module.exports, "SkeletonHelpButton", () => $c7057c3cb6b741a5$export$9ee5d6e291d4e456);

var $eUqFw = parcelRequire("eUqFw");

var $ioiQ7 = parcelRequire("ioiQ7");

var $ctFws = parcelRequire("ctFws");

var $9JmWF = parcelRequire("9JmWF");
const $c7057c3cb6b741a5$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
    const { mode: { navigation: navigation } } = (0, $9JmWF.useTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctFws.SkeletonIconButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: label,
        secondaryColor: navigation.backgroundColor
    }));
};

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $6bb2437d634f2335$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $deed61a8dba991fd$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $deed61a8dba991fd$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $deed61a8dba991fd$export$13f57c02915787b3 = 'atlaskit-portal';

const $7f8b23c982f78b1d$export$ed5835cc67e87f72 = 'akPortalMount';
const $7f8b23c982f78b1d$export$80816bd900e5bd00 = 'akPortalUnmount';

const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

const $b4cc463b68660864$export$d6830277b06edd6 = 'normal';
const $b4cc463b68660864$export$4f8f13a66ae77bdd = '--color';
const $b4cc463b68660864$export$e9244ec13bd422b5 = '--bg-color';
const $b4cc463b68660864$export$97e78d9745006c11 = '--bg-color-hover';
const $b4cc463b68660864$export$291d63757828f290 = '--bg-color-active';


$parcel$global.rlb("bYT2S")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.5bd8e540.js.map
